const COUNTRIES = {
  US: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}} {{region_short}} {{postalcode}}\n{{country}}",
    alpha2: "US",
    alpha3: "USA",
    continent: "North America",
    country_code: "1",
    currency_code: "USD",
    distance_unit: "MI",
    g20_member: true,
    g7_member: true,
    gec: "US",
    geo: {
      latitude: 37.09024,
      longitude: -95.712891,
      max_latitude: 71.3577635769,
      max_longitude: -66.96466,
      min_latitude: 18.91619,
      min_longitude: -171.791110603,
      bounds: {
        northeast: {
          lat: 71.3577635769,
          lng: -66.96466,
        },
        southwest: {
          lat: 18.91619,
          lng: -171.791110603,
        },
      },
    },
    international_prefix: "011",
    ioc: "USA",
    iso_long_name: "The United States of America",
    iso_short_name: "United States of America",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "American",
    number: "840",
    postal_code: true,
    postal_code_format: "(\\d{5})(?:[ \\-](\\d{4}))?",
    region: "Americas",
    start_of_week: "sunday",
    subregion: "Northern America",
    un_locode: "US",
    un_member: true,
    unofficial_names: [
      "United States",
      "USA",
      "Vereinigte Staaten von Amerika",
      "États-Unis",
      "Estados Unidos",
      "アメリカ合衆国",
      "Verenigde Staten",
      "Соединенные Штаты Америки",
    ],
    vehicle_registration_code: "USA",
    world_region: "AMER",
  },
  UY: {
    alpha2: "UY",
    alpha3: "URY",
    continent: "South America",
    country_code: "598",
    currency_code: "UYU",
    distance_unit: "KM",
    gec: "UY",
    geo: {
      latitude: -32.522779,
      longitude: -55.765835,
      max_latitude: -30.0852149,
      max_longitude: -53.0779284,
      min_latitude: -35.1558001,
      min_longitude: -58.4913609,
      bounds: {
        northeast: {
          lat: -30.0852149,
          lng: -53.0779284,
        },
        southwest: {
          lat: -35.1558001,
          lng: -58.4913609,
        },
      },
    },
    international_prefix: "00",
    ioc: "URU",
    iso_long_name: "The Oriental Republic of Uruguay",
    iso_short_name: "Uruguay",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8],
    national_prefix: "0",
    nationality: "Uruguayan",
    number: "858",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "UY",
    un_member: true,
    unofficial_names: ["Uruguay", "ウルグアイ"],
    vehicle_registration_code: "ROU",
    world_region: "AMER",
  },
  UZ: {
    alpha2: "UZ",
    alpha3: "UZB",
    continent: "Asia",
    country_code: "998",
    currency_code: "UZS",
    distance_unit: "KM",
    gec: "UZ",
    geo: {
      latitude: 41.377491,
      longitude: 64.585262,
      max_latitude: 45.590075,
      max_longitude: 73.148946,
      min_latitude: 37.1722571,
      min_longitude: 55.9982179,
      bounds: {
        northeast: {
          lat: 45.590075,
          lng: 73.148946,
        },
        southwest: {
          lat: 37.1722571,
          lng: 55.9982179,
        },
      },
    },
    international_prefix: "810",
    ioc: "UZB",
    iso_long_name: "The Republic of Uzbekistan",
    iso_short_name: "Uzbekistan",
    languages_official: ["uz"],
    languages_spoken: ["uz", "ru"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "8",
    nationality: "Uzbekistani",
    number: "860",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Central Asia",
    un_locode: "UZ",
    un_member: true,
    unofficial_names: [
      "Uzbekistan",
      "Usbekistan",
      "Ouzbékistan",
      "Uzbekistán",
      "ウズベキスタン",
      "Oezbekistan",
    ],
    vehicle_registration_code: "UZ",
    world_region: "EMEA",
  },
  VA: {
    alpha2: "VA",
    alpha3: "VAT",
    continent: "Europe",
    country_code: "39",
    currency_code: "EUR",
    distance_unit: "KM",
    gec: "VT",
    geo: {
      latitude: 41.902916,
      longitude: 12.453389,
      max_latitude: 41.90744309999999,
      max_longitude: 12.4583938,
      min_latitude: 41.9001896,
      min_longitude: 12.4457286,
      bounds: {
        northeast: {
          lat: 41.90744309999999,
          lng: 12.4583938,
        },
        southwest: {
          lat: 41.9001896,
          lng: 12.4457286,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "The Holy See",
    iso_short_name: "Holy See",
    languages_official: ["it", "la"],
    languages_spoken: ["it", "la"],
    nanp_prefix: "379",
    national_destination_code_lengths: [3],
    national_number_lengths: [9],
    national_prefix: "None",
    nationality: "Italian",
    number: "336",
    postal_code: true,
    postal_code_format: "00120",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "VA",
    un_member: false,
    unofficial_names: [
      "Vatican City",
      "Vatikan",
      "Cité du Vatican",
      "Ciudad del Vaticano",
      "バチカン市国",
      "Vaticaanstad",
      "Vatican City State (Holy See)",
    ],
    vehicle_registration_code: "V",
    world_region: "EMEA",
  },
  VC: {
    alpha2: "VC",
    alpha3: "VCT",
    continent: "North America",
    country_code: "1",
    currency_code: "XCD",
    distance_unit: "MI",
    gec: "VC",
    geo: {
      latitude: 12.984305,
      longitude: -61.287228,
      max_latitude: 13.4136657,
      max_longitude: -61.0846,
      min_latitude: 12.5294999,
      min_longitude: -61.4822,
      bounds: {
        northeast: {
          lat: 13.4136657,
          lng: -61.0846,
        },
        southwest: {
          lat: 12.5294999,
          lng: -61.4822,
        },
      },
    },
    international_prefix: "011",
    ioc: "VIN",
    iso_long_name: "Saint Vincent and the Grenadines",
    iso_short_name: "Saint Vincent and the Grenadines",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1784",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Saint Vincentian",
    number: "670",
    postal_code: true,
    postal_code_format: "VC\\d{4}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "VC",
    un_member: true,
    unofficial_names: [
      "Saint Vincent and the Grenadines",
      "Saint Vincent und die Grenadinen",
      "Saint-Vincent et les Grenadines",
      "San Vicente y Granadinas",
      "セントビンセントおよびグレナディーン諸島",
      "Saint Vincent en de Grenadines",
      "St. Vincent Grenadines",
      "St Vincent Grenadines",
    ],
    vehicle_registration_code: "WV",
    world_region: "AMER",
  },
  VE: {
    alpha2: "VE",
    alpha3: "VEN",
    continent: "South America",
    country_code: "58",
    currency_code: "VES",
    distance_unit: "KM",
    gec: "VE",
    geo: {
      latitude: 6.42375,
      longitude: -66.58973,
      max_latitude: 12.6886,
      max_longitude: -59.805666,
      min_latitude: 0.6475291,
      min_longitude: -73.36703899999999,
      bounds: {
        northeast: {
          lat: 12.6886,
          lng: -59.805666,
        },
        southwest: {
          lat: 0.6475291,
          lng: -73.36703899999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "VEN",
    iso_long_name: "The Bolivarian Republic of Venezuela",
    iso_short_name: "Venezuela (Bolivarian Republic of)",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [10],
    national_prefix: "0",
    nationality: "Venezuelan",
    number: "862",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "VE",
    un_member: true,
    unofficial_names: ["Venezuela", "ベネズエラ・ボリバル共和国"],
    vehicle_registration_code: "YV",
    world_region: "AMER",
  },
  VG: {
    alpha2: "VG",
    alpha3: "VGB",
    continent: "North America",
    country_code: "1",
    currency_code: "USD",
    distance_unit: "MI",
    gec: "VI",
    geo: {
      latitude: 18.420695,
      longitude: -64.639968,
      max_latitude: 18.7539999,
      max_longitude: -64.2651999,
      min_latitude: 18.2899998,
      min_longitude: -64.8775,
      bounds: {
        northeast: {
          lat: 18.7539999,
          lng: -64.2651999,
        },
        southwest: {
          lat: 18.2899998,
          lng: -64.8775,
        },
      },
    },
    international_prefix: "011",
    ioc: "IVB",
    iso_long_name: "The Virgin Islands",
    iso_short_name: "Virgin Islands (British)",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1284",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Virgin Islander",
    number: "092",
    postal_code: true,
    postal_code_format: "VG\\d{4}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "VG",
    un_member: false,
    unofficial_names: [
      "British Virgin Islands",
      "Britische Jungferninseln",
      "Îles Vierges britanniques",
      "Islas Vírgenes del Reino Unido",
      "イギリス領ヴァージン諸島",
      "Britse Maagdeneilanden",
      "Virgin Islands (British)",
    ],
    vehicle_registration_code: "BVI",
    world_region: "AMER",
  },
  VI: {
    alpha2: "VI",
    alpha3: "VIR",
    continent: "North America",
    country_code: "1",
    currency_code: "USD",
    distance_unit: "MI",
    gec: "VQ",
    geo: {
      latitude: 18.335765,
      longitude: -64.896335,
      max_latitude: 18.4239,
      max_longitude: -64.4391,
      min_latitude: 17.5482999,
      min_longitude: -65.1101,
      bounds: {
        northeast: {
          lat: 18.4239,
          lng: -64.4391,
        },
        southwest: {
          lat: 17.5482999,
          lng: -65.1101,
        },
      },
    },
    international_prefix: "011",
    ioc: "ISV",
    iso_long_name: "The Virgin Islands of the United States",
    iso_short_name: "Virgin Islands (U.S.)",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1340",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Virgin Islander",
    number: "850",
    postal_code: true,
    postal_code_format: "(008(?:(?:[0-4]\\d)|(?:5[01])))(?:[ \\-](\\d{4}))?",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "VI",
    un_member: false,
    unofficial_names: [
      "Virgin Islands of the United States",
      "Amerikanische Jungferninseln",
      "Îles Vierges américaines",
      "Islas Vírgenes de los Estados Unidos",
      "アメリカ領ヴァージン諸島",
      "Amerikaanse Maagdeneilanden",
      "Virgin Islands (U.S.)",
      "United States Virgin Islands",
      "U.S. Virgin Islands",
    ],
    world_region: "AMER",
  },
  VN: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}}\n{{region}}\n{{country}}",
    alpha2: "VN",
    alpha3: "VNM",
    continent: "Asia",
    country_code: "84",
    currency_code: "VND",
    distance_unit: "KM",
    gec: "VM",
    geo: {
      latitude: 14.058324,
      longitude: 108.277199,
      max_latitude: 23.3926504,
      max_longitude: 109.6765,
      min_latitude: 8.1952001,
      min_longitude: 102.1439156,
      bounds: {
        northeast: {
          lat: 23.3926504,
          lng: 109.6765,
        },
        southwest: {
          lat: 8.1952001,
          lng: 102.1439156,
        },
      },
    },
    international_prefix: "00",
    ioc: "VIE",
    iso_long_name: "The Socialist Republic of Viet Nam",
    iso_short_name: "Viet Nam",
    languages_official: ["vi"],
    languages_spoken: ["vi"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8, 9, 10],
    national_prefix: "0",
    nationality: "Vietnamese",
    number: "704",
    postal_code: true,
    postal_code_format: "\\d{5}\\d?",
    region: "Asia",
    start_of_week: "monday",
    subregion: "South-Eastern Asia",
    un_locode: "VN",
    un_member: true,
    unofficial_names: ["Vietnam", "ベトナム", "Viet Nam"],
    vehicle_registration_code: "VN",
    world_region: "APAC",
  },
  VU: {
    alpha2: "VU",
    alpha3: "VUT",
    continent: "Australia",
    country_code: "678",
    currency_code: "VUV",
    distance_unit: "KM",
    gec: "NH",
    geo: {
      latitude: -15.376706,
      longitude: 166.959158,
      max_latitude: -12.8064449,
      max_longitude: 170.5023193,
      min_latitude: -20.5350773,
      min_longitude: 166.0583495,
      bounds: {
        northeast: {
          lat: -12.8064449,
          lng: 170.5023193,
        },
        southwest: {
          lat: -20.5350773,
          lng: 166.0583495,
        },
      },
    },
    international_prefix: "00",
    ioc: "VAN",
    iso_long_name: "The Republic of Vanuatu",
    iso_short_name: "Vanuatu",
    languages_official: ["bi", "en", "fr"],
    languages_spoken: ["bi", "en", "fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [5, 6, 7],
    national_prefix: "None",
    nationality: "Ni-Vanuatu",
    number: "548",
    postal_code: false,
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Melanesia",
    un_locode: "VU",
    un_member: true,
    unofficial_names: ["Vanuatu", "バヌアツ"],
    vehicle_registration_code: "VAN",
    world_region: "APAC",
  },
  WF: {
    alpha2: "WF",
    alpha3: "WLF",
    continent: "Australia",
    country_code: "681",
    currency_code: "XPF",
    distance_unit: "KM",
    gec: "WF",
    geo: {
      latitude: -14.2938,
      longitude: -178.1165,
      max_latitude: -13.1303042,
      max_longitude: -176.0971068,
      min_latitude: -14.4187203,
      min_longitude: -178.2284546,
      bounds: {
        northeast: {
          lat: -13.1303042,
          lng: -176.0971068,
        },
        southwest: {
          lat: -14.4187203,
          lng: -178.2284546,
        },
      },
    },
    international_prefix: "19",
    ioc: null,
    iso_long_name: "The Territory of the Wallis and Futuna Islands",
    iso_short_name: "Wallis and Futuna",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6],
    national_prefix: "None",
    nationality: "Wallis and Futuna Islander",
    number: "876",
    postal_code: true,
    postal_code_format: "986\\d{2}",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Polynesia",
    un_locode: "WF",
    un_member: false,
    unofficial_names: [
      "Wallis and Futuna",
      "Wallis und Futuna",
      "Wallis et Futuna",
      "Wallis y Futuna",
      "ウォリス・フツナ",
      "Wallis en Futuna",
    ],
    world_region: "APAC",
  },
  WS: {
    alpha2: "WS",
    alpha3: "WSM",
    continent: "Australia",
    country_code: "685",
    currency_code: "WST",
    distance_unit: "MI",
    gec: "WS",
    geo: {
      latitude: -13.759029,
      longitude: -172.104629,
      max_latitude: -13.4203449,
      max_longitude: -171.3950515,
      min_latitude: -14.0833012,
      min_longitude: -172.8108215,
      bounds: {
        northeast: {
          lat: -13.4203449,
          lng: -171.3950515,
        },
        southwest: {
          lat: -14.0833012,
          lng: -172.8108215,
        },
      },
    },
    international_prefix: "00",
    ioc: "SAM",
    iso_long_name: "The Independent State of Samoa",
    iso_short_name: "Samoa",
    languages_official: ["sm", "en"],
    languages_spoken: ["sm", "en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6, 7],
    national_prefix: "None",
    nationality: "Samoan",
    number: "882",
    postal_code: false,
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Polynesia",
    un_locode: "WS",
    un_member: true,
    unofficial_names: ["Samoa", "サモア"],
    vehicle_registration_code: "WS",
    world_region: "APAC",
  },
  YE: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "YE",
    alpha3: "YEM",
    continent: "Asia",
    country_code: "967",
    currency_code: "YER",
    distance_unit: "KM",
    gec: "YM",
    geo: {
      latitude: 15.552727,
      longitude: 48.516388,
      max_latitude: 18.9996331,
      max_longitude: 54.67899999999999,
      min_latitude: 11.7975,
      min_longitude: 41.70959999999999,
      bounds: {
        northeast: {
          lat: 18.9996331,
          lng: 54.67899999999999,
        },
        southwest: {
          lat: 11.7975,
          lng: 41.70959999999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "YEM",
    iso_long_name: "The Republic of Yemen",
    iso_short_name: "Yemen",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8, 9],
    national_prefix: "0",
    nationality: "Yemeni",
    number: "887",
    postal_code: false,
    region: "Asia",
    start_of_week: "sunday",
    subregion: "Western Asia",
    un_locode: "YE",
    un_member: true,
    unofficial_names: ["Yemen", "اليمن", "Jemen", "Yémen", "イエメン"],
    vehicle_registration_code: "YEM",
    world_region: "EMEA",
  },
  YT: {
    alpha2: "YT",
    alpha3: "MYT",
    continent: "Africa",
    country_code: "262",
    currency_code: "EUR",
    distance_unit: "KM",
    eu_member: true,
    euvat_member: false,
    gec: "MF",
    geo: {
      latitude: -12.8275,
      longitude: 45.166244,
      max_latitude: -12.5772665,
      max_longitude: 45.32014849999999,
      min_latitude: -13.0358332,
      min_longitude: 44.9914169,
      bounds: {
        northeast: {
          lat: -12.5772665,
          lng: 45.32014849999999,
        },
        southwest: {
          lat: -13.0358332,
          lng: 44.9914169,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "The Department of Mayotte",
    iso_short_name: "Mayotte",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "French",
    number: "175",
    postal_code: true,
    postal_code_format: "976\\d{2}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "YT",
    un_member: false,
    unofficial_names: ["Mayotte", "マヨット"],
    world_region: "EMEA",
  },
  ZA: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}}\n{{region}}\n{{postalcode}}\n{{country}}",
    alpha2: "ZA",
    alpha3: "ZAF",
    continent: "Africa",
    country_code: "27",
    currency_code: "ZAR",
    distance_unit: "KM",
    g20_member: true,
    gec: "SF",
    geo: {
      latitude: -30.559482,
      longitude: 22.937506,
      max_latitude: -22.1254239,
      max_longitude: 38.2216904,
      min_latitude: -47.1313489,
      min_longitude: 16.2816999,
      bounds: {
        northeast: {
          lat: -22.1254239,
          lng: 38.2216904,
        },
        southwest: {
          lat: -47.1313489,
          lng: 16.2816999,
        },
      },
    },
    international_prefix: "09",
    ioc: "RSA",
    iso_long_name: "The Republic of South Africa",
    iso_short_name: "South Africa",
    languages_official: [
      "af",
      "en",
      "nr",
      "st",
      "ss",
      "tn",
      "ts",
      "ve",
      "xh",
      "zu",
    ],
    languages_spoken: [
      "af",
      "en",
      "nr",
      "st",
      "ss",
      "tn",
      "ts",
      "ve",
      "xh",
      "zu",
    ],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "South African",
    number: "710",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Southern Africa",
    un_locode: "ZA",
    un_member: true,
    unofficial_names: [
      "South Africa",
      "Republik Südafrika",
      "Afrique du Sud",
      "República de Sudáfrica",
      "南アフリカ",
      "Zuid-Afrika",
    ],
    vehicle_registration_code: "ZA",
    world_region: "EMEA",
  },
  ZM: {
    alpha2: "ZM",
    alpha3: "ZMB",
    continent: "Africa",
    country_code: "260",
    currency_code: "ZMW",
    distance_unit: "KM",
    gec: "ZA",
    geo: {
      latitude: -13.133897,
      longitude: 27.849332,
      max_latitude: -8.2032838,
      max_longitude: 33.7090305,
      min_latitude: -18.0774179,
      min_longitude: 21.999351,
      bounds: {
        northeast: {
          lat: -8.2032838,
          lng: 33.7090305,
        },
        southwest: {
          lat: -18.0774179,
          lng: 21.999351,
        },
      },
    },
    international_prefix: "00",
    ioc: "ZAM",
    iso_long_name: "The Republic of Zambia",
    iso_short_name: "Zambia",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Zambian",
    number: "894",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "ZM",
    un_member: true,
    unofficial_names: ["Zambia", "Sambia", "Zambie", "ザンビア"],
    vehicle_registration_code: "Z",
    world_region: "EMEA",
  },
  ZW: {
    alpha2: "ZW",
    alpha3: "ZWE",
    continent: "Africa",
    country_code: "263",
    currency_code: "USD",
    distance_unit: "KM",
    gec: "ZI",
    geo: {
      latitude: -19.015438,
      longitude: 29.154857,
      max_latitude: -15.6093188,
      max_longitude: 33.068236,
      min_latitude: -22.4219117,
      min_longitude: 25.237368,
      bounds: {
        northeast: {
          lat: -15.6093188,
          lng: 33.068236,
        },
        southwest: {
          lat: -22.4219117,
          lng: 25.237368,
        },
      },
    },
    international_prefix: "00",
    ioc: "ZIM",
    iso_long_name: "The Republic of Zimbabwe",
    iso_short_name: "Zimbabwe",
    languages_official: ["en", "sn", "nd"],
    languages_spoken: ["en", "sn", "nd"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9, 10, 11],
    national_prefix: "0",
    nationality: "Zimbabwean",
    number: "716",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "ZW",
    un_member: true,
    unofficial_names: ["Zimbabwe", "Simbabwe", "Zimbabue", "ジンバブエ"],
    vehicle_registration_code: "ZW",
    world_region: "EMEA",
  },
  RE: {
    alpha2: "RE",
    alpha3: "REU",
    continent: "Africa",
    country_code: "262",
    currency_code: "EUR",
    distance_unit: "KM",
    eu_member: true,
    euvat_member: false,
    gec: "RE",
    geo: {
      latitude: -21.115141,
      longitude: 55.536384,
      max_latitude: -20.8671529,
      max_longitude: 55.84487919999999,
      min_latitude: -21.4035321,
      min_longitude: 55.209732,
      bounds: {
        northeast: {
          lat: -20.8671529,
          lng: 55.84487919999999,
        },
        southwest: {
          lat: -21.4035321,
          lng: 55.209732,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "Réunion",
    iso_short_name: "Réunion",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [10],
    national_prefix: "None",
    nationality: "French",
    number: "638",
    postal_code: true,
    postal_code_format: "9[78]4\\d{2}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "RE",
    un_member: false,
    unofficial_names: ["Réunion", "Reunión", "Reunion", "レユニオン"],
    world_region: "EMEA",
  },
  RO: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "RO",
    alpha3: "ROU",
    continent: "Europe",
    country_code: "40",
    currency_code: "RON",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "RO",
    geo: {
      latitude: 45.943161,
      longitude: 24.96676,
      max_latitude: 48.26518,
      max_longitude: 29.77839999999999,
      min_latitude: 43.6186193,
      min_longitude: 20.2617591,
      bounds: {
        northeast: {
          lat: 48.26518,
          lng: 29.77839999999999,
        },
        southwest: {
          lat: 43.6186193,
          lng: 20.2617591,
        },
      },
    },
    international_prefix: "00",
    ioc: "ROU",
    iso_long_name: "Romania",
    iso_short_name: "Romania",
    languages_official: ["ro"],
    languages_spoken: ["ro"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Romanian",
    number: "642",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Eastern Europe",
    un_locode: "RO",
    un_member: true,
    unofficial_names: [
      "Romania",
      "Rumänien",
      "Roumanie",
      "Rumania",
      "ルーマニア",
      "Roemenië",
    ],
    vat_rates: {
      standard: 19,
      reduced: [5, 9],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "RO",
    world_region: "EMEA",
  },
  RS: {
    alpha2: "RS",
    alpha3: "SRB",
    continent: "Europe",
    country_code: "381",
    currency_code: "RSD",
    distance_unit: "KM",
    gec: "RI",
    geo: {
      latitude: 44.016521,
      longitude: 21.005859,
      max_latitude: 46.190032,
      max_longitude: 23.0063095,
      min_latitude: 42.2315029,
      min_longitude: 18.8385221,
      bounds: {
        northeast: {
          lat: 46.190032,
          lng: 23.0063095,
        },
        southwest: {
          lat: 42.2315029,
          lng: 18.8385221,
        },
      },
    },
    international_prefix: "99",
    ioc: "SRB",
    iso_long_name: "The Republic of Serbia",
    iso_short_name: "Serbia",
    languages_official: ["sr"],
    languages_spoken: ["sr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Serbian",
    number: "688",
    postal_code: true,
    postal_code_format: "\\d{5,6}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "RS",
    un_member: true,
    unofficial_names: ["Serbia", "Serbien", "Serbie", "セルビア", "Servië"],
    vehicle_registration_code: "SRB",
    world_region: "EMEA",
  },
  RU: {
    address_format:
      "{{recipient}}\n{{postalcode}} {{city}}\n{{street}}\n{{country}}",
    alpha2: "RU",
    alpha3: "RUS",
    continent: "Europe",
    country_code: "7",
    currency_code: "RUB",
    distance_unit: "KM",
    g20_member: true,
    gec: "RS",
    geo: {
      latitude: 61.52401,
      longitude: 105.318756,
      max_latitude: 82.1673907,
      max_longitude: -168.97788,
      min_latitude: 41.185353,
      min_longitude: 19.6160999,
      bounds: {
        northeast: {
          lat: 82.1673907,
          lng: -168.97788,
        },
        southwest: {
          lat: 41.185353,
          lng: 19.6160999,
        },
      },
    },
    international_prefix: "810",
    ioc: "RUS",
    iso_long_name: "The Russian Federation",
    iso_short_name: "Russian Federation",
    languages_official: ["ru"],
    languages_spoken: ["ru"],
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "8",
    nationality: "Russian",
    number: "643",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Eastern Europe",
    un_locode: "RU",
    un_member: true,
    unofficial_names: [
      "Russia",
      "Russland",
      "Russie",
      "Rusia",
      "ロシア連邦",
      "Rusland",
      "Россия",
      "Расія",
    ],
    vehicle_registration_code: "RUS",
    world_region: "EMEA",
  },
  RW: {
    alpha2: "RW",
    alpha3: "RWA",
    continent: "Africa",
    country_code: "250",
    currency_code: "RWF",
    distance_unit: "KM",
    gec: "RW",
    geo: {
      latitude: -1.940278,
      longitude: 29.873888,
      max_latitude: -1.0473752,
      max_longitude: 30.8991179,
      min_latitude: -2.8399383,
      min_longitude: 28.861754,
      bounds: {
        northeast: {
          lat: -1.0473752,
          lng: 30.8991179,
        },
        southwest: {
          lat: -2.8399383,
          lng: 28.861754,
        },
      },
    },
    international_prefix: "00",
    ioc: "RWA",
    iso_long_name: "The Republic of Rwanda",
    iso_short_name: "Rwanda",
    languages_official: ["rw", "en", "fr"],
    languages_spoken: ["rw", "en", "fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "Rwandan",
    number: "646",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "RW",
    un_member: true,
    unofficial_names: ["Rwanda", "Ruanda", "ルワンダ"],
    vehicle_registration_code: "RWA",
    world_region: "EMEA",
  },
  SA: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "SA",
    alpha3: "SAU",
    continent: "Asia",
    country_code: "966",
    currency_code: "SAR",
    distance_unit: "KM",
    g20_member: true,
    gec: "SA",
    geo: {
      latitude: 23.885942,
      longitude: 45.079162,
      max_latitude: 32.154284,
      max_longitude: 55.6666999,
      min_latitude: 16.0036,
      min_longitude: 34.4815001,
      bounds: {
        northeast: {
          lat: 32.154284,
          lng: 55.6666999,
        },
        southwest: {
          lat: 16.0036,
          lng: 34.4815001,
        },
      },
    },
    international_prefix: "00",
    ioc: "KSA",
    iso_long_name: "The Kingdom of Saudi Arabia",
    iso_short_name: "Saudi Arabia",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "Saudi Arabian",
    number: "682",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "sunday",
    subregion: "Western Asia",
    un_locode: "SA",
    un_member: true,
    unofficial_names: [
      "Saudi Arabia",
      "Kingdom of Saudi Arabia",
      "السعودية",
      "Saudi-Arabien",
      "Arabie Saoudite",
      "Arabia Saudí",
      "サウジアラビア",
      "Saoedi-Arabië",
    ],
    vat_rates: {
      standard: 15,
      reduced: [],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "KSA",
    world_region: "EMEA",
  },
  SB: {
    alpha2: "SB",
    alpha3: "SLB",
    continent: "Australia",
    country_code: "677",
    currency_code: "SBD",
    distance_unit: "KM",
    gec: "BP",
    geo: {
      latitude: -9.64571,
      longitude: 160.156194,
      max_latitude: -6.075011,
      max_longitude: 168.0249023,
      min_latitude: -12.6832149,
      min_longitude: 155.1187134,
      bounds: {
        northeast: {
          lat: -6.075011,
          lng: 168.0249023,
        },
        southwest: {
          lat: -12.6832149,
          lng: 155.1187134,
        },
      },
    },
    international_prefix: "00",
    ioc: "SOL",
    iso_long_name: "The Solomon Islands",
    iso_short_name: "Solomon Islands",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [5],
    national_prefix: "None",
    nationality: "Solomon Islander",
    number: "090",
    postal_code: false,
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Melanesia",
    un_locode: "SB",
    un_member: true,
    unofficial_names: [
      "Solomon Islands",
      "Salomonen",
      "Îles Salomon",
      "Islas Salomón",
      "ソロモン諸島",
      "Salomonseilanden",
    ],
    vehicle_registration_code: "SOL",
    world_region: "APAC",
  },
  SC: {
    alpha2: "SC",
    alpha3: "SYC",
    continent: "Africa",
    country_code: "248",
    currency_code: "SCR",
    distance_unit: "KM",
    gec: "SE",
    geo: {
      latitude: -4.679574,
      longitude: 55.491977,
      max_latitude: -3.7091721,
      max_longitude: 56.3928224,
      min_latitude: -10.4716073,
      min_longitude: 45.9832764,
      bounds: {
        northeast: {
          lat: -3.7091721,
          lng: 56.3928224,
        },
        southwest: {
          lat: -10.4716073,
          lng: 45.9832764,
        },
      },
    },
    international_prefix: "00",
    ioc: "SEY",
    iso_long_name: "The Republic of Seychelles",
    iso_short_name: "Seychelles",
    languages_official: ["fr", "en"],
    languages_spoken: ["fr", "en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6],
    national_prefix: "None",
    nationality: "Seychellois",
    number: "690",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "SC",
    un_member: true,
    unofficial_names: ["Seychelles", "Seychellen", "セーシェル"],
    vehicle_registration_code: "SY",
    world_region: "EMEA",
  },
  SD: {
    alpha2: "SD",
    alpha3: "SDN",
    continent: "Africa",
    country_code: "249",
    currency_code: "SDG",
    distance_unit: "KM",
    gec: "SU",
    geo: {
      latitude: 12.862807,
      longitude: 30.217636,
      max_latitude: 22.224918,
      max_longitude: 38.69379989999999,
      min_latitude: 9.3472209,
      min_longitude: 21.8146345,
      bounds: {
        northeast: {
          lat: 22.224918,
          lng: 38.69379989999999,
        },
        southwest: {
          lat: 9.3472209,
          lng: 21.8146345,
        },
      },
    },
    international_prefix: "00",
    ioc: "SUD",
    iso_long_name: "The Republic of the Sudan",
    iso_short_name: "Sudan",
    languages_official: ["ar", "en"],
    languages_spoken: ["ar", "en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Sudanese",
    number: "729",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Northern Africa",
    un_locode: "SD",
    un_member: true,
    unofficial_names: [
      "Sudan",
      "السودان",
      "Soudan",
      "Sudán",
      "スーダン",
      "Soedan",
    ],
    vehicle_registration_code: "SUD",
    world_region: "EMEA",
  },
  SE: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "SE",
    alpha3: "SWE",
    continent: "Europe",
    country_code: "46",
    currency_code: "SEK",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "SW",
    geo: {
      latitude: 60.12816100000001,
      longitude: 18.643501,
      max_latitude: 69.0599709,
      max_longitude: 24.1773101,
      min_latitude: 55.0059799,
      min_longitude: 10.5798,
      bounds: {
        northeast: {
          lat: 69.0599709,
          lng: 24.1773101,
        },
        southwest: {
          lat: 55.0059799,
          lng: 10.5798,
        },
      },
    },
    international_prefix: "00",
    ioc: "SWE",
    iso_long_name: "The Kingdom of Sweden",
    iso_short_name: "Sweden",
    languages_official: ["sv"],
    languages_spoken: ["sv"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Swedish",
    number: "752",
    postal_code: true,
    postal_code_format: "\\d{3} ?\\d{2}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "SE",
    un_member: true,
    unofficial_names: [
      "Sweden",
      "Schweden",
      "Suède",
      "Suecia",
      "スウェーデン",
      "Zweden",
    ],
    vat_rates: {
      standard: 25,
      reduced: [6, 12],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "S",
    world_region: "EMEA",
  },
  SG: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}} {{postalcode}}\n{{country}}",
    alpha2: "SG",
    alpha3: "SGP",
    continent: "Asia",
    country_code: "65",
    currency_code: "SGD",
    distance_unit: "KM",
    gec: "SN",
    geo: {
      latitude: 1.352083,
      longitude: 103.819836,
      max_latitude: 1.4784001,
      max_longitude: 104.0945001,
      min_latitude: 1.1496,
      min_longitude: 103.594,
      bounds: {
        northeast: {
          lat: 1.4784001,
          lng: 104.0945001,
        },
        southwest: {
          lat: 1.1496,
          lng: 103.594,
        },
      },
    },
    international_prefix: "001",
    ioc: "SGP",
    iso_long_name: "The Republic of Singapore",
    iso_short_name: "Singapore",
    languages_official: ["en", "ms", "ta"],
    languages_spoken: ["en", "ms", "ta"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "None",
    nationality: "Singaporean",
    number: "702",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "South-Eastern Asia",
    un_locode: "SG",
    un_member: true,
    unofficial_names: ["Singapore", "Singapur", "Singapour", "シンガポール"],
    vehicle_registration_code: "SGP",
    world_region: "APAC",
  },
  SH: {
    alpha2: "SH",
    alpha3: "SHN",
    continent: "Africa",
    country_code: "290",
    currency_code: "SHP",
    distance_unit: "MI",
    gec: "SH",
    geo: {
      latitude: -24.1434812,
      longitude: -10.0306945,
      max_latitude: -7.1008926,
      max_longitude: -5.0976561,
      min_latitude: -41.0371886,
      min_longitude: -15.4248047,
      bounds: {
        northeast: {
          lat: -7.1008926,
          lng: -5.0976561,
        },
        southwest: {
          lat: -41.0371886,
          lng: -15.4248047,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "Saint Helena, Ascension and Tristan da Cunha",
    iso_short_name: "Saint Helena, Ascension and Tristan da Cunha",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [4],
    national_prefix: "None",
    nationality: "Saint Helenian",
    number: "654",
    postal_code: true,
    postal_code_format: "(?:ASCN|STHL) 1ZZ",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "SH",
    un_member: false,
    unofficial_names: [
      "Saint Helena",
      "Sankt Helena",
      "Sainte Hélène",
      "Santa Helena",
      "セントヘレナ・アセンションおよびトリスタンダクーニャ",
      "Sint-Helena",
      "Saint Helena, Ascension and Tristan da Cunha",
    ],
    world_region: "APAC",
  },
  SI: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "SI",
    alpha3: "SVN",
    continent: "Europe",
    country_code: "386",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "SI",
    geo: {
      latitude: 46.151241,
      longitude: 14.995463,
      max_latitude: 46.876659,
      max_longitude: 16.6107038,
      min_latitude: 45.4218356,
      min_longitude: 13.3753355,
      bounds: {
        northeast: {
          lat: 46.876659,
          lng: 16.6107038,
        },
        southwest: {
          lat: 45.4218356,
          lng: 13.3753355,
        },
      },
    },
    international_prefix: "00",
    ioc: "SLO",
    iso_long_name: "The Republic of Slovenia",
    iso_short_name: "Slovenia",
    languages_official: ["sl"],
    languages_spoken: ["sl"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Slovene",
    number: "705",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "SI",
    un_member: true,
    unofficial_names: [
      "Slovenia",
      "Slowenien",
      "Slovénie",
      "Eslovenia",
      "スロベニア",
      "Slovenië",
    ],
    vat_rates: {
      standard: 22,
      reduced: [9.5],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "SLO",
    world_region: "EMEA",
  },
  SJ: {
    alpha2: "SJ",
    alpha3: "SJM",
    continent: "Europe",
    country_code: "47",
    currency_code: "NOK",
    distance_unit: "KM",
    gec: "SV",
    geo: {
      latitude: 77.55360399999999,
      longitude: 23.6702719,
      max_latitude: 80.92842569999999,
      max_longitude: 34.8046879,
      min_latitude: 70.4662074,
      min_longitude: -10.5468752,
      bounds: {
        northeast: {
          lat: 80.92842569999999,
          lng: 34.8046879,
        },
        southwest: {
          lat: 70.4662074,
          lng: -10.5468752,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "Svalbard and Jan Mayen",
    iso_short_name: "Svalbard and Jan Mayen",
    languages_official: ["no"],
    languages_spoken: ["no"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Norwegian",
    number: "744",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "SJ",
    un_member: false,
    unofficial_names: [
      "Svalbard and Jan Mayen",
      "Svalbard und Jan Mayen",
      "Îles Svalbard et Jan Mayen",
      "Islas Svalbard y Jan Mayen",
      "スヴァールバル諸島およびヤンマイエン島",
      "Svalbard en Jan Mayen",
    ],
    world_region: "EMEA",
  },
  SK: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "SK",
    alpha3: "SVK",
    continent: "Europe",
    country_code: "421",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "LO",
    geo: {
      latitude: 48.669026,
      longitude: 19.699024,
      max_latitude: 49.613805,
      max_longitude: 22.5658602,
      min_latitude: 47.731159,
      min_longitude: 16.8331821,
      bounds: {
        northeast: {
          lat: 49.613805,
          lng: 22.5658602,
        },
        southwest: {
          lat: 47.731159,
          lng: 16.8331821,
        },
      },
    },
    international_prefix: "00",
    ioc: "SVK",
    iso_long_name: "The Slovak Republic",
    iso_short_name: "Slovakia",
    languages_official: ["sk"],
    languages_spoken: ["sk"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Slovak",
    number: "703",
    postal_code: true,
    postal_code_format: "\\d{3} ?\\d{2}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Eastern Europe",
    un_locode: "SK",
    un_member: true,
    unofficial_names: [
      "Slovakia",
      "Slowakei",
      "Slovaquie",
      "República Eslovaca",
      "スロバキア",
      "Slowakije",
    ],
    vat_rates: {
      standard: 23,
      reduced: [19],
      super_reduced: [5],
      parking: null,
    },
    vehicle_registration_code: "SK",
    world_region: "EMEA",
  },
  SL: {
    alpha2: "SL",
    alpha3: "SLE",
    continent: "Africa",
    country_code: "232",
    currency_code: "SLL",
    distance_unit: "KM",
    gec: "SL",
    geo: {
      latitude: 8.460555,
      longitude: -11.779889,
      max_latitude: 9.9999737,
      max_longitude: -10.2716829,
      min_latitude: 6.8446,
      min_longitude: -13.4032999,
      bounds: {
        northeast: {
          lat: 9.9999737,
          lng: -10.2716829,
        },
        southwest: {
          lat: 6.8446,
          lng: -13.4032999,
        },
      },
    },
    international_prefix: "00",
    ioc: "SLE",
    iso_long_name: "The Republic of Sierra Leone",
    iso_short_name: "Sierra Leone",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Sierra Leonean",
    number: "694",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "SL",
    un_member: true,
    unofficial_names: ["Sierra Leone", "シエラレオネ"],
    vehicle_registration_code: "SLE",
    world_region: "EMEA",
  },
  SM: {
    alpha2: "SM",
    alpha3: "SMR",
    continent: "Europe",
    country_code: "378",
    currency_code: "EUR",
    distance_unit: "KM",
    gec: "SM",
    geo: {
      latitude: 43.94236,
      longitude: 12.457777,
      max_latitude: 43.992075,
      max_longitude: 12.5167041,
      min_latitude: 43.8936809,
      min_longitude: 12.4034824,
      bounds: {
        northeast: {
          lat: 43.992075,
          lng: 12.5167041,
        },
        southwest: {
          lat: 43.8936809,
          lng: 12.4034824,
        },
      },
    },
    international_prefix: "00",
    ioc: "SMR",
    iso_long_name: "The Republic of San Marino",
    iso_short_name: "San Marino",
    languages_official: ["it"],
    languages_spoken: ["it"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9, 10, 11, 12],
    national_prefix: "None",
    nationality: "Sammarinese",
    number: "674",
    postal_code: true,
    postal_code_format: "4789\\d",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "SM",
    un_member: true,
    unofficial_names: ["San Marino", "Saint-Marin", "サンマリノ"],
    vehicle_registration_code: "RSM",
    world_region: "EMEA",
  },
  SN: {
    alpha2: "SN",
    alpha3: "SEN",
    continent: "Africa",
    country_code: "221",
    currency_code: "XOF",
    distance_unit: "KM",
    gec: "SG",
    geo: {
      latitude: 14.497401,
      longitude: -14.452362,
      max_latitude: 16.6929572,
      max_longitude: -11.3457683,
      min_latitude: 12.2649001,
      min_longitude: -17.6879999,
      bounds: {
        northeast: {
          lat: 16.6929572,
          lng: -11.3457683,
        },
        southwest: {
          lat: 12.2649001,
          lng: -17.6879999,
        },
      },
    },
    international_prefix: "00",
    ioc: "SEN",
    iso_long_name: "The Republic of Senegal",
    iso_short_name: "Senegal",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Senegalese",
    number: "686",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "SN",
    un_member: true,
    unofficial_names: ["Senegal", "Sénégal", "セネガル"],
    vehicle_registration_code: "SN",
    world_region: "EMEA",
  },
  SO: {
    alpha2: "SO",
    alpha3: "SOM",
    continent: "Africa",
    country_code: "252",
    currency_code: "SOS",
    distance_unit: "KM",
    gec: "SO",
    geo: {
      latitude: 5.152149,
      longitude: 46.199616,
      max_latitude: 12.3615,
      max_longitude: 51.6138,
      min_latitude: -1.8673,
      min_longitude: 40.994373,
      bounds: {
        northeast: {
          lat: 12.3615,
          lng: 51.6138,
        },
        southwest: {
          lat: -1.8673,
          lng: 40.994373,
        },
      },
    },
    international_prefix: "00",
    ioc: "SOM",
    iso_long_name: "The Federal Republic of Somalia",
    iso_short_name: "Somalia",
    languages_official: ["so", "ar"],
    languages_spoken: ["so", "ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8],
    national_prefix: "None",
    nationality: "Somali",
    number: "706",
    postal_code: true,
    postal_code_format: "[A-Z]{2} ?\\d{5}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "SO",
    un_member: true,
    unofficial_names: ["Somalia", "الصومال", "ソマリア", "Somalië"],
    vehicle_registration_code: "SO",
    world_region: "EMEA",
  },
  SR: {
    alpha2: "SR",
    alpha3: "SUR",
    continent: "South America",
    country_code: "597",
    currency_code: "SRD",
    distance_unit: "KM",
    gec: "NS",
    geo: {
      latitude: 3.919305,
      longitude: -56.027783,
      max_latitude: 6.1295999,
      max_longitude: -53.94289999999999,
      min_latitude: 1.837306,
      min_longitude: -58.07050590000001,
      bounds: {
        northeast: {
          lat: 6.1295999,
          lng: -53.94289999999999,
        },
        southwest: {
          lat: 1.837306,
          lng: -58.07050590000001,
        },
      },
    },
    international_prefix: "00",
    ioc: "SUR",
    iso_long_name: "The Republic of Suriname",
    iso_short_name: "Suriname",
    languages_official: ["nl"],
    languages_spoken: ["nl"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6],
    national_prefix: "0",
    nationality: "Surinamer",
    number: "740",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "SR",
    un_member: true,
    unofficial_names: ["Suriname", "Surinam", "スリナム"],
    vehicle_registration_code: "SME",
    world_region: "AMER",
  },
  SS: {
    alpha2: "SS",
    alpha3: "SSD",
    continent: "Africa",
    country_code: "211",
    currency_code: "SSP",
    distance_unit: "KM",
    gec: "OD",
    geo: {
      latitude: 6.876991899999999,
      longitude: 31.3069788,
      max_latitude: 12.236389,
      max_longitude: 35.9489971,
      min_latitude: 3.48898,
      min_longitude: 23.4408491,
      bounds: {
        northeast: {
          lat: 12.236389,
          lng: 35.9489971,
        },
        southwest: {
          lat: 3.48898,
          lng: 23.4408491,
        },
      },
    },
    international_prefix: "0",
    ioc: null,
    iso_long_name: "The Republic of South Sudan",
    iso_short_name: "South Sudan",
    languages_official: ["ar", "en"],
    languages_spoken: ["ar", "en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "South Sudanese",
    number: "728",
    postal_code: false,
    region: "Africa",
    start_of_week: "sunday",
    subregion: "Northern Africa",
    un_locode: "SS",
    un_member: true,
    unofficial_names: ["South Sudan", "Südsudan", "南スーダン", "Zuid-Soedan"],
    vehicle_registration_code: "SSD",
    world_region: "EMEA",
  },
  ST: {
    alpha2: "ST",
    alpha3: "STP",
    continent: "Africa",
    country_code: "239",
    currency_code: "STD",
    distance_unit: "KM",
    gec: "TP",
    geo: {
      latitude: 0.18636,
      longitude: 6.613080999999999,
      max_latitude: 1.8961687,
      max_longitude: 7.658843900000001,
      min_latitude: -0.09887689999999999,
      min_longitude: 6.328125,
      bounds: {
        northeast: {
          lat: 1.8961687,
          lng: 7.658843900000001,
        },
        southwest: {
          lat: -0.09887689999999999,
          lng: 6.328125,
        },
      },
    },
    international_prefix: "00",
    ioc: "STP",
    iso_long_name: "The Democratic Republic of São Tomé and Príncipe",
    iso_short_name: "Sao Tome and Principe",
    languages_official: ["pt"],
    languages_spoken: ["pt"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6, 7],
    national_prefix: "0",
    nationality: "Sao Tomean",
    number: "678",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Middle Africa",
    un_locode: "ST",
    un_member: true,
    unofficial_names: [
      "São Tomé and Príncipe",
      "São Tomé und Príncipe",
      "São Tomé et Príncipe",
      "Santo Tomé y Príncipe",
      "サントメ・プリンシペ",
      "Sao Tomé en Principe",
    ],
    vehicle_registration_code: "STP",
    world_region: "EMEA",
  },
  SV: {
    alpha2: "SV",
    alpha3: "SLV",
    continent: "North America",
    country_code: "503",
    currency_code: "USD",
    distance_unit: "KM",
    gec: "ES",
    geo: {
      latitude: 13.794185,
      longitude: -88.89653,
      max_latitude: 14.4505567,
      max_longitude: -87.6682,
      min_latitude: 13.0473999,
      min_longitude: -90.19229999999999,
      bounds: {
        northeast: {
          lat: 14.4505567,
          lng: -87.6682,
        },
        southwest: {
          lat: 13.0473999,
          lng: -90.19229999999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "ESA",
    iso_long_name: "The Republic of El Salvador",
    iso_short_name: "El Salvador",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Salvadoran",
    number: "222",
    postal_code: true,
    postal_code_format: "CP [1-3][1-7][0-2]\\d",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Central America",
    un_locode: "SV",
    un_member: true,
    unofficial_names: ["El Salvador", "Salvador", "エルサルバドル"],
    vehicle_registration_code: "ES",
    world_region: "AMER",
  },
  SX: {
    alpha2: "SX",
    alpha3: "SXM",
    continent: "North America",
    country_code: "1",
    currency_code: "ANG",
    distance_unit: "KM",
    gec: "NN",
    geo: {
      latitude: 18.04248,
      longitude: -63.05483,
      max_latitude: 18.0641707,
      max_longitude: -62.9784,
      min_latitude: 17.9941,
      min_longitude: -63.13979990000001,
      bounds: {
        northeast: {
          lat: 18.0641707,
          lng: -62.9784,
        },
        southwest: {
          lat: 17.9941,
          lng: -63.13979990000001,
        },
      },
    },
    international_prefix: "011",
    ioc: null,
    iso_long_name: "Sint Maarten",
    iso_short_name: "Sint Maarten (Dutch part)",
    languages_official: ["nl", "en"],
    languages_spoken: ["nl", "en"],
    nanp_prefix: "1721",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "0",
    nationality: "Dutch",
    number: "534",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "SX",
    un_member: false,
    unofficial_names: ["Sint Maarten", "セント・マーチン島"],
    world_region: "AMER",
  },
  SY: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "SY",
    alpha3: "SYR",
    continent: "Asia",
    country_code: "963",
    currency_code: "SYP",
    distance_unit: "KM",
    gec: "SY",
    geo: {
      latitude: 34.80207499999999,
      longitude: 38.996815,
      max_latitude: 37.318693,
      max_longitude: 42.376309,
      min_latitude: 32.311136,
      min_longitude: 35.62869999999999,
      bounds: {
        northeast: {
          lat: 37.318693,
          lng: 42.376309,
        },
        southwest: {
          lat: 32.311136,
          lng: 35.62869999999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "SYR",
    iso_long_name: "The Syrian Arab Republic",
    iso_short_name: "Syrian Arab Republic",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8],
    national_prefix: "0",
    nationality: "Syrian",
    number: "760",
    postal_code: false,
    region: "Asia",
    start_of_week: "monday",
    subregion: "Western Asia",
    un_locode: "SY",
    un_member: true,
    unofficial_names: [
      "Syria",
      "سوريا",
      "سورية",
      "Syrien",
      "Syrie",
      "Siria",
      "シリア・アラブ共和国",
      "Syrië",
    ],
    vehicle_registration_code: "SYR",
    world_region: "EMEA",
  },
  SZ: {
    alpha2: "SZ",
    alpha3: "SWZ",
    continent: "Africa",
    country_code: "268",
    currency_code: "SZL",
    distance_unit: "KM",
    gec: "WZ",
    geo: {
      latitude: -26.522503,
      longitude: 31.465866,
      max_latitude: -25.71792,
      max_longitude: 32.1349067,
      min_latitude: -27.317402,
      min_longitude: 30.79064,
      bounds: {
        northeast: {
          lat: -25.71792,
          lng: 32.1349067,
        },
        southwest: {
          lat: -27.317402,
          lng: 30.79064,
        },
      },
    },
    international_prefix: "00",
    ioc: "SWZ",
    iso_long_name: "The Kingdom of Eswatini",
    iso_short_name: "Eswatini",
    languages_official: ["en", "ss"],
    languages_spoken: ["en", "ss"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Swazi",
    number: "748",
    postal_code: true,
    postal_code_format: "[HLMS]\\d{3}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Southern Africa",
    un_locode: "SZ",
    un_member: true,
    unofficial_names: ["Swaziland", "Swasiland", "Suazilandia", "スワジランド"],
    vehicle_registration_code: "SD",
    world_region: "EMEA",
  },
  TC: {
    alpha2: "TC",
    alpha3: "TCA",
    continent: "North America",
    country_code: "1",
    currency_code: "USD",
    distance_unit: "MI",
    gec: "TK",
    geo: {
      latitude: 21.694025,
      longitude: -71.797928,
      max_latitude: 22.0016285,
      max_longitude: -71.05949989999999,
      min_latitude: 21.1459922,
      min_longitude: -72.52069999999999,
      bounds: {
        northeast: {
          lat: 22.0016285,
          lng: -71.05949989999999,
        },
        southwest: {
          lat: 21.1459922,
          lng: -72.52069999999999,
        },
      },
    },
    international_prefix: "011",
    ioc: null,
    iso_long_name: "The Turks and Caicos Islands",
    iso_short_name: "Turks and Caicos Islands",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1649",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Turks and Caicos Islander",
    number: "796",
    postal_code: true,
    postal_code_format: "TKCA 1ZZ",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "TC",
    un_member: false,
    unofficial_names: [
      "Turks and Caicos Islands",
      "Turks- und Caicosinseln",
      "Îles Turks et Caïcos",
      "Islas Turks y Caicos",
      "タークス・カイコス諸島",
      "Turks- en Caicoseilanden",
      "Turks and Caicos",
    ],
    world_region: "APAC",
  },
  TD: {
    alpha2: "TD",
    alpha3: "TCD",
    continent: "Africa",
    country_code: "235",
    currency_code: "XAF",
    distance_unit: "KM",
    gec: "CD",
    geo: {
      latitude: 15.454166,
      longitude: 18.732207,
      max_latitude: 23.449228,
      max_longitude: 24.0000011,
      min_latitude: 7.442975,
      min_longitude: 13.4699999,
      bounds: {
        northeast: {
          lat: 23.449228,
          lng: 24.0000011,
        },
        southwest: {
          lat: 7.442975,
          lng: 13.4699999,
        },
      },
    },
    international_prefix: "15",
    ioc: "CHA",
    iso_long_name: "The Republic of Chad",
    iso_short_name: "Chad",
    languages_official: ["ar", "fr"],
    languages_spoken: ["ar", "fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Chadian",
    number: "148",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Middle Africa",
    un_locode: "TD",
    un_member: true,
    unofficial_names: ["Chad", "تشاد", "Tschad", "Tchad", "チャド", "Tsjaad"],
    vehicle_registration_code: "TD",
    world_region: "EMEA",
  },
  TF: {
    alpha2: "TF",
    alpha3: "ATF",
    continent: "Africa",
    country_code: "262",
    currency_code: "EUR",
    distance_unit: "KM",
    gec: "FS",
    geo: {
      latitude: -49.280366,
      longitude: 69.3485571,
      max_latitude: -45.7567331,
      max_longitude: 70.6558228,
      min_latitude: -50.0641918,
      min_longitude: 49.8519168,
      bounds: {
        northeast: {
          lat: -45.7567331,
          lng: 70.6558228,
        },
        southwest: {
          lat: -50.0641918,
          lng: 49.8519168,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "The French Southern and Antarctic Lands",
    iso_short_name: "French Southern Territories",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "French",
    number: "260",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "TF",
    un_member: false,
    unofficial_names: [
      "French Southern Territories",
      "Französische Süd- und Antarktisgebiete",
      "Terres Australes Françaises",
      "Territorios Franceses del Sur",
      "フランス領南方・南極地域",
      "Franse Gebieden in de zuidelijke Indische Oceaan",
      "French Southern and Antarctic Lands",
    ],
    world_region: "EMEA",
  },
  TG: {
    alpha2: "TG",
    alpha3: "TGO",
    continent: "Africa",
    country_code: "228",
    currency_code: "XOF",
    distance_unit: "KM",
    gec: "TO",
    geo: {
      latitude: 8.619543,
      longitude: 0.824782,
      max_latitude: 11.139617,
      max_longitude: 1.8089071,
      min_latitude: 6.0812,
      min_longitude: -0.1440418,
      bounds: {
        northeast: {
          lat: 11.139617,
          lng: 1.8089071,
        },
        southwest: {
          lat: 6.0812,
          lng: -0.1440418,
        },
      },
    },
    international_prefix: "00",
    ioc: "TOG",
    iso_long_name: "The Togolese Republic",
    iso_short_name: "Togo",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Togolese",
    number: "768",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "TG",
    un_member: true,
    unofficial_names: ["Togo", "トーゴ"],
    vehicle_registration_code: "RT",
    world_region: "EMEA",
  },
  TH: {
    alpha2: "TH",
    alpha3: "THA",
    continent: "Asia",
    country_code: "66",
    currency_code: "THB",
    distance_unit: "KM",
    gec: "TH",
    geo: {
      latitude: 15.870032,
      longitude: 100.992541,
      max_latitude: 20.465143,
      max_longitude: 105.636812,
      min_latitude: 5.613038,
      min_longitude: 97.343396,
      bounds: {
        northeast: {
          lat: 20.465143,
          lng: 105.636812,
        },
        southwest: {
          lat: 5.613038,
          lng: 97.343396,
        },
      },
    },
    international_prefix: "001",
    ioc: "THA",
    iso_long_name: "The Kingdom of Thailand",
    iso_short_name: "Thailand",
    languages_official: ["th"],
    languages_spoken: ["th"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9, 10],
    national_prefix: "0",
    nationality: "Thai",
    number: "764",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "South-Eastern Asia",
    un_locode: "TH",
    un_member: true,
    unofficial_names: [
      "Thailand",
      "Thaïlande",
      "Tailandia",
      "タイ",
      "ประเทศไทย",
    ],
    vat_rates: {
      standard: 7,
      reduced: [0],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "T",
    world_region: "APAC",
  },
  TJ: {
    alpha2: "TJ",
    alpha3: "TJK",
    alt_currency: "RUB",
    continent: "Asia",
    country_code: "992",
    currency_code: "TJS",
    distance_unit: "KM",
    gec: "TI",
    geo: {
      latitude: 38.861034,
      longitude: 71.276093,
      max_latitude: 41.044367,
      max_longitude: 75.1539564,
      min_latitude: 36.6719898,
      min_longitude: 67.34201209999999,
      bounds: {
        northeast: {
          lat: 41.044367,
          lng: 75.1539564,
        },
        southwest: {
          lat: 36.6719898,
          lng: 67.34201209999999,
        },
      },
    },
    international_prefix: "810",
    ioc: "TJK",
    iso_long_name: "The Republic of Tajikistan",
    iso_short_name: "Tajikistan",
    languages_official: ["tg", "ru"],
    languages_spoken: ["tg", "ru"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "8",
    nationality: "Tadzhik",
    number: "762",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Central Asia",
    un_locode: "TJ",
    un_member: true,
    unofficial_names: [
      "Tajikistan",
      "Tadschikistan",
      "Tayikistán",
      "タジキスタン",
      "Tadzjikistan",
      "Tajikstan",
    ],
    vehicle_registration_code: "TJ",
    world_region: "EMEA",
  },
  TK: {
    alpha2: "TK",
    alpha3: "TKL",
    continent: "Australia",
    country_code: "690",
    currency_code: "NZD",
    distance_unit: "KM",
    gec: "TL",
    geo: {
      latitude: -9.200199999999999,
      longitude: -171.8484,
      max_latitude: -8.4221116,
      max_longitude: -171.0928346,
      min_latitude: -9.5059527,
      min_longitude: -172.6625061,
      bounds: {
        northeast: {
          lat: -8.4221116,
          lng: -171.0928346,
        },
        southwest: {
          lat: -9.5059527,
          lng: -172.6625061,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "Tokelau",
    iso_short_name: "Tokelau",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [4],
    national_prefix: "None",
    nationality: "Tokelauan",
    number: "772",
    postal_code: false,
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Polynesia",
    un_locode: "TK",
    un_member: false,
    unofficial_names: ["Tokelau", "Îles Tokelau", "Islas Tokelau", "トケラウ"],
    world_region: "APAC",
  },
  TL: {
    alpha2: "TL",
    alpha3: "TLS",
    continent: "Asia",
    country_code: "670",
    currency_code: "IDR",
    distance_unit: "KM",
    gec: "TT",
    geo: {
      latitude: -8.874217,
      longitude: 125.727539,
      max_latitude: -8.048399999999999,
      max_longitude: 127.4249,
      min_latitude: -9.5303001,
      min_longitude: 124.0332,
      bounds: {
        northeast: {
          lat: -8.048399999999999,
          lng: 127.4249,
        },
        southwest: {
          lat: -9.5303001,
          lng: 124.0332,
        },
      },
    },
    international_prefix: "None",
    ioc: "TLS",
    iso_long_name: "The Democratic Republic of Timor-Leste",
    iso_short_name: "Timor-Leste",
    languages_official: ["pt"],
    languages_spoken: ["pt"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "East Timorese",
    number: "626",
    postal_code: false,
    region: "Asia",
    start_of_week: "monday",
    subregion: "South-Eastern Asia",
    un_locode: "TL",
    un_member: true,
    unofficial_names: [
      "East Timor",
      "Timor-Leste",
      "Timor oriental",
      "Timor Oriental",
      "東ティモール",
      "Oost-Timor",
    ],
    vehicle_registration_code: "TL",
    world_region: "APAC",
  },
  TM: {
    alpha2: "TM",
    alpha3: "TKM",
    continent: "Asia",
    country_code: "993",
    currency_code: "TMT",
    distance_unit: "KM",
    gec: "TX",
    geo: {
      latitude: 38.969719,
      longitude: 59.556278,
      max_latitude: 42.798844,
      max_longitude: 66.70735309999999,
      min_latitude: 35.12876,
      min_longitude: 52.3169,
      bounds: {
        northeast: {
          lat: 42.798844,
          lng: 66.70735309999999,
        },
        southwest: {
          lat: 35.12876,
          lng: 52.3169,
        },
      },
    },
    international_prefix: "810",
    ioc: "TKM",
    iso_long_name: "Turkmenistan",
    iso_short_name: "Turkmenistan",
    languages_official: ["tk"],
    languages_spoken: ["tk", "ru"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "8",
    nationality: "Turkmen",
    number: "795",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Central Asia",
    un_locode: "TM",
    un_member: true,
    unofficial_names: [
      "Turkmenistan",
      "Turkménistan",
      "Turkmenistán",
      "トルクメニスタン",
      "Turkmenia",
    ],
    vehicle_registration_code: "TM",
    world_region: "EMEA",
  },
  TN: {
    alpha2: "TN",
    alpha3: "TUN",
    continent: "Africa",
    country_code: "216",
    currency_code: "TND",
    distance_unit: "KM",
    gec: "TS",
    geo: {
      latitude: 33.886917,
      longitude: 9.537499,
      max_latitude: 37.5359,
      max_longitude: 11.599217,
      min_latitude: 30.2280339,
      min_longitude: 7.522311,
      bounds: {
        northeast: {
          lat: 37.5359,
          lng: 11.599217,
        },
        southwest: {
          lat: 30.2280339,
          lng: 7.522311,
        },
      },
    },
    international_prefix: "00",
    ioc: "TUN",
    iso_long_name: "The Republic of Tunisia",
    iso_short_name: "Tunisia",
    languages_official: ["ar", "fr"],
    languages_spoken: ["ar", "fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Tunisian",
    number: "788",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Northern Africa",
    un_locode: "TN",
    un_member: true,
    unofficial_names: [
      "Tunisia",
      "تونس",
      "Tunesien",
      "Tunisie",
      "Túnez",
      "チュニジア",
      "Tunesië",
    ],
    vehicle_registration_code: "TN",
    world_region: "EMEA",
  },
  TO: {
    alpha2: "TO",
    alpha3: "TON",
    continent: "Australia",
    country_code: "676",
    currency_code: "TOP",
    distance_unit: "KM",
    gec: "TN",
    geo: {
      latitude: -21.178986,
      longitude: -175.198242,
      max_latitude: -15.4060236,
      max_longitude: -173.2543946,
      min_latitude: -21.8360059,
      min_longitude: -175.9570313,
      bounds: {
        northeast: {
          lat: -15.4060236,
          lng: -173.2543946,
        },
        southwest: {
          lat: -21.8360059,
          lng: -175.9570313,
        },
      },
    },
    international_prefix: "00",
    ioc: "TGA",
    iso_long_name: "The Kingdom of Tonga",
    iso_short_name: "Tonga",
    languages_official: ["en", "to"],
    languages_spoken: ["en", "to"],
    national_destination_code_lengths: [2],
    national_number_lengths: [5, 6, 7],
    national_prefix: "None",
    nationality: "Tongan",
    number: "776",
    postal_code: false,
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Polynesia",
    un_locode: "TO",
    un_member: true,
    unofficial_names: ["Tonga", "トンガ"],
    vehicle_registration_code: "TON",
    world_region: "APAC",
  },
  TR: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "TR",
    alpha3: "TUR",
    continent: "Europe",
    country_code: "90",
    currency_code: "TRY",
    distance_unit: "KM",
    g20_member: true,
    gec: "TU",
    geo: {
      latitude: 38.963745,
      longitude: 35.243322,
      max_latitude: 42.3666999,
      max_longitude: 44.8178449,
      min_latitude: 35.808592,
      min_longitude: 25.5377,
      bounds: {
        northeast: {
          lat: 42.3666999,
          lng: 44.8178449,
        },
        southwest: {
          lat: 35.808592,
          lng: 25.5377,
        },
      },
    },
    international_prefix: "00",
    ioc: "TUR",
    iso_long_name: "The Republic of Türkiye",
    iso_short_name: "Türkiye",
    languages_official: ["tr"],
    languages_spoken: ["tr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [10],
    national_prefix: "0",
    nationality: "Turkish",
    number: "792",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Western Asia",
    un_locode: "TR",
    un_member: true,
    unofficial_names: [
      "Turkey",
      "Türkei",
      "Turquie",
      "Turquía",
      "トルコ",
      "Turkije",
    ],
    vehicle_registration_code: "TR",
    world_region: "EMEA",
  },
  TT: {
    alpha2: "TT",
    alpha3: "TTO",
    continent: "North America",
    country_code: "1",
    currency_code: "TTD",
    distance_unit: "KM",
    gec: "TD",
    geo: {
      latitude: 10.691803,
      longitude: -61.222503,
      max_latitude: 11.4004,
      max_longitude: -60.45089989999999,
      min_latitude: 9.9930001,
      min_longitude: -61.9725001,
      bounds: {
        northeast: {
          lat: 11.4004,
          lng: -60.45089989999999,
        },
        southwest: {
          lat: 9.9930001,
          lng: -61.9725001,
        },
      },
    },
    international_prefix: "011",
    ioc: "TRI",
    iso_long_name: "The Republic of Trinidad and Tobago",
    iso_short_name: "Trinidad and Tobago",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1868",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Trinidadian",
    number: "780",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "TT",
    un_member: true,
    unofficial_names: [
      "Trinidad and Tobago",
      "Trinidad und Tobago",
      "Trinité et Tobago",
      "Trinidad y Tobago",
      "トリニダード・トバゴ",
      "Trinidad en Tobago",
    ],
    vehicle_registration_code: "TT",
    world_region: "AMER",
  },
  TV: {
    alpha2: "TV",
    alpha3: "TUV",
    continent: "Australia",
    country_code: "688",
    currency_code: "AUD",
    distance_unit: "KM",
    gec: "TV",
    geo: {
      latitude: -7.109534999999999,
      longitude: 177.64933,
      max_latitude: -5.4300853,
      max_longitude: 179.9999999,
      min_latitude: -11.1891797,
      min_longitude: 175.5615234,
      bounds: {
        northeast: {
          lat: -5.4300853,
          lng: 179.9999999,
        },
        southwest: {
          lat: -11.1891797,
          lng: 175.5615234,
        },
      },
    },
    international_prefix: "00",
    ioc: "TUV",
    iso_long_name: "Tuvalu",
    iso_short_name: "Tuvalu",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [5],
    national_prefix: "None",
    nationality: "Tuvaluan",
    number: "798",
    postal_code: false,
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Polynesia",
    un_locode: "TV",
    un_member: true,
    unofficial_names: ["Tuvalu", "ツバル"],
    vehicle_registration_code: "TUV",
    world_region: "APAC",
  },
  TW: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}} {{region_short}} {{postalcode}}\n{{country}}",
    alpha2: "TW",
    alpha3: "TWN",
    continent: "Asia",
    country_code: "886",
    currency_code: "TWD",
    distance_unit: "KM",
    gec: "TW",
    geo: {
      latitude: 23.69781,
      longitude: 120.960515,
      max_latitude: 26.4545,
      max_longitude: 123.5021012,
      min_latitude: 20.5170001,
      min_longitude: 116.6665,
      bounds: {
        northeast: {
          lat: 26.4545,
          lng: 123.5021012,
        },
        southwest: {
          lat: 20.5170001,
          lng: 116.6665,
        },
      },
    },
    international_prefix: "002",
    ioc: "TPE",
    iso_long_name: "Taiwan, Province of China",
    iso_short_name: "Taiwan, Province of China",
    languages_official: ["zh"],
    languages_spoken: ["zh"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8],
    national_prefix: "0",
    nationality: "Taiwanese",
    number: "158",
    postal_code: true,
    postal_code_format: "\\d{3}(?:\\d{2,3})?",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Eastern Asia",
    un_locode: "TW",
    un_member: false,
    unofficial_names: ["Taiwan", "Taiwán", "台灣", "臺灣", "台湾"],
    vehicle_registration_code: "RC",
    world_region: "APAC",
  },
  TZ: {
    alpha2: "TZ",
    alpha3: "TZA",
    continent: "Africa",
    country_code: "255",
    currency_code: "TZS",
    distance_unit: "KM",
    gec: "TZ",
    geo: {
      latitude: -6.369028,
      longitude: 34.888822,
      max_latitude: -0.9843968000000001,
      max_longitude: 40.6398,
      min_latitude: -11.7612539,
      min_longitude: 29.34,
      bounds: {
        northeast: {
          lat: -0.9843968000000001,
          lng: 40.6398,
        },
        southwest: {
          lat: -11.7612539,
          lng: 29.34,
        },
      },
    },
    international_prefix: "000",
    ioc: "TAN",
    iso_long_name: "The United Republic of Tanzania",
    iso_short_name: "Tanzania, United Republic of",
    languages_official: ["sw", "en"],
    languages_spoken: ["sw", "en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Tanzanian",
    number: "834",
    postal_code: true,
    postal_code_format: "\\d{4,5}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "TZ",
    un_member: true,
    unofficial_names: [
      "Tanzania",
      "Tansania",
      "Tanzanie",
      "タンザニア",
      "Tanzania United Republic",
    ],
    vehicle_registration_code: "EAT",
    world_region: "EMEA",
  },
  UA: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}} {{region_short}}\n{{postalcode}}\n{{country}}",
    alpha2: "UA",
    alpha3: "UKR",
    continent: "Europe",
    country_code: "380",
    currency_code: "UAH",
    distance_unit: "KM",
    gec: "UP",
    geo: {
      latitude: 48.379433,
      longitude: 31.1655799,
      max_latitude: 52.3793713,
      max_longitude: 40.2204802,
      min_latitude: 44.2924,
      min_longitude: 22.137159,
      bounds: {
        northeast: {
          lat: 52.3793713,
          lng: 40.2204802,
        },
        southwest: {
          lat: 44.2924,
          lng: 22.137159,
        },
      },
    },
    international_prefix: "810",
    ioc: "UKR",
    iso_long_name: "Ukraine",
    iso_short_name: "Ukraine",
    languages_official: ["uk"],
    languages_spoken: ["uk"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "8",
    nationality: "Ukrainian",
    number: "804",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Eastern Europe",
    un_locode: "UA",
    un_member: true,
    unofficial_names: [
      "Ukraine",
      "Ucrania",
      "ウクライナ",
      "Oekraïne",
      "Украина",
      "Україна",
      "Украіна",
    ],
    vat_rates: {
      standard: 20,
      reduced: [7],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "UA",
    world_region: "EMEA",
  },
  UG: {
    alpha2: "UG",
    alpha3: "UGA",
    continent: "Africa",
    country_code: "256",
    currency_code: "UGX",
    distance_unit: "KM",
    gec: "UG",
    geo: {
      latitude: 1.373333,
      longitude: 32.290275,
      max_latitude: 4.218628,
      max_longitude: 35.0330489,
      min_latitude: -1.4823178,
      min_longitude: 29.573433,
      bounds: {
        northeast: {
          lat: 4.218628,
          lng: 35.0330489,
        },
        southwest: {
          lat: -1.4823178,
          lng: 29.573433,
        },
      },
    },
    international_prefix: "000",
    ioc: "UGA",
    iso_long_name: "The Republic of Uganda",
    iso_short_name: "Uganda",
    languages_official: ["en", "sw"],
    languages_spoken: ["en", "sw"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Ugandan",
    number: "800",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "UG",
    un_member: true,
    unofficial_names: ["Uganda", "ウガンダ", "Oeganda"],
    vehicle_registration_code: "EAU",
    world_region: "EMEA",
  },
  UM: {
    alpha2: "UM",
    alpha3: "UMI",
    continent: "Australia",
    country_code: "1",
    currency_code: "USD",
    distance_unit: "KM",
    gec: null,
    geo: {
      latitude: 19.2823192,
      longitude: 166.647047,
      max_latitude: 28.3977184,
      max_longitude: -159.9849071,
      min_latitude: -0.3824678,
      min_longitude: 166.5989221,
      bounds: {
        northeast: {
          lat: 28.3977184,
          lng: -159.9849071,
        },
        southwest: {
          lat: -0.3824678,
          lng: 166.5989221,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "United States Minor Outlying Islands",
    iso_short_name: "United States Minor Outlying Islands",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "246",
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "American",
    number: "581",
    postal_code: true,
    postal_code_format: "96898",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Northern America",
    un_locode: "UM",
    un_member: false,
    unofficial_names: [
      "United States Minor Outlying Islands",
      "US-Amerikanische Hoheitsgebiete",
      "Dépendances américaines",
      "Islas menores de Estados Unidos",
      "合衆国領有小離島",
      "Kleine afgelegen eilanden van de Verenigde Staten",
    ],
    world_region: "AMER",
  },
  MK: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}} {{postalcode}}\n{{country}}",
    alpha2: "MK",
    alpha3: "MKD",
    continent: "Europe",
    country_code: "389",
    currency_code: "MKD",
    distance_unit: "KM",
    gec: "MK",
    geo: {
      latitude: 41.608635,
      longitude: 21.745275,
      max_latitude: 42.373646,
      max_longitude: 23.0340441,
      min_latitude: 40.8537826,
      min_longitude: 20.452423,
      bounds: {
        northeast: {
          lat: 42.373646,
          lng: 23.0340441,
        },
        southwest: {
          lat: 40.8537826,
          lng: 20.452423,
        },
      },
    },
    international_prefix: "00",
    ioc: "MKD",
    iso_long_name: "The Republic of North Macedonia",
    iso_short_name: "North Macedonia",
    languages_official: ["mk"],
    languages_spoken: ["mk"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8],
    national_prefix: "0",
    nationality: "Macedonian",
    number: "807",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "MK",
    un_member: true,
    unofficial_names: [
      "Macedonia",
      "Mazedonien",
      "Macédoine",
      "F.Y.R.O.M (Macedonia)",
      "マケドニア旧ユーゴスラビア共和国",
      "Macedonië [FYROM]",
      "Macedonia (The Former Yugoslav Republic of)",
      "North Macedonia",
      "Macedonia (FYROM)",
    ],
    vehicle_registration_code: "NMK",
    world_region: "EMEA",
  },
  ML: {
    alpha2: "ML",
    alpha3: "MLI",
    continent: "Africa",
    country_code: "223",
    currency_code: "XOF",
    distance_unit: "KM",
    gec: "ML",
    geo: {
      latitude: 17.570692,
      longitude: -3.996166,
      max_latitude: 25.001084,
      max_longitude: 4.267382599999999,
      min_latitude: 10.147811,
      min_longitude: -12.2403447,
      bounds: {
        northeast: {
          lat: 25.001084,
          lng: 4.267382599999999,
        },
        southwest: {
          lat: 10.147811,
          lng: -12.2403447,
        },
      },
    },
    international_prefix: "00",
    ioc: "MLI",
    iso_long_name: "The Republic of Mali",
    iso_short_name: "Mali",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Malian",
    number: "466",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "ML",
    un_member: true,
    unofficial_names: ["Mali", "マリ"],
    vehicle_registration_code: "RMM",
    world_region: "EMEA",
  },
  MM: {
    alpha2: "MM",
    alpha3: "MMR",
    continent: "Asia",
    country_code: "95",
    currency_code: "MMK",
    distance_unit: "MI",
    gec: "BM",
    geo: {
      latitude: 21.916221,
      longitude: 95.955974,
      max_latitude: 28.5478351,
      max_longitude: 101.1702717,
      min_latitude: 9.4518,
      min_longitude: 92.171808,
      bounds: {
        northeast: {
          lat: 28.5478351,
          lng: 101.1702717,
        },
        southwest: {
          lat: 9.4518,
          lng: 92.171808,
        },
      },
    },
    international_prefix: "00",
    ioc: "MYA",
    iso_long_name: "The Republic of the Union of Myanmar",
    iso_short_name: "Myanmar",
    languages_official: ["my"],
    languages_spoken: ["my"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8],
    national_prefix: "None",
    nationality: "Myanmarian",
    number: "104",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "South-Eastern Asia",
    un_locode: "MM",
    un_member: true,
    unofficial_names: ["Myanmar (Burma)", "ミャンマー", "Burma"],
    vehicle_registration_code: "MYA",
    world_region: "APAC",
  },
  MN: {
    alpha2: "MN",
    alpha3: "MNG",
    continent: "Asia",
    country_code: "976",
    currency_code: "MNT",
    distance_unit: "KM",
    gec: "MG",
    geo: {
      latitude: 46.862496,
      longitude: 103.846656,
      max_latitude: 52.148355,
      max_longitude: 119.9315098,
      min_latitude: 41.581833,
      min_longitude: 87.7344789,
      bounds: {
        northeast: {
          lat: 52.148355,
          lng: 119.9315098,
        },
        southwest: {
          lat: 41.581833,
          lng: 87.7344789,
        },
      },
    },
    international_prefix: "001",
    ioc: "MGL",
    iso_long_name: "Mongolia",
    iso_short_name: "Mongolia",
    languages_official: ["mn"],
    languages_spoken: ["mn"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8, 9, 10],
    national_prefix: "0",
    nationality: "Mongolian",
    number: "496",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Eastern Asia",
    un_locode: "MN",
    un_member: true,
    unofficial_names: [
      "Mongolia",
      "Mongolei",
      "Mongolie",
      "モンゴル",
      "Mongolië",
    ],
    vehicle_registration_code: "MNG",
    world_region: "APAC",
  },
  MO: {
    alpha2: "MO",
    alpha3: "MAC",
    continent: "Asia",
    country_code: "853",
    currency_code: "MOP",
    distance_unit: "KM",
    gec: "MC",
    geo: {
      latitude: 22.198745,
      longitude: 113.543873,
      max_latitude: 22.2170639,
      max_longitude: 113.6127001,
      min_latitude: 22.1066001,
      min_longitude: 113.5276053,
      bounds: {
        northeast: {
          lat: 22.2170639,
          lng: 113.6127001,
        },
        southwest: {
          lat: 22.1066001,
          lng: 113.5276053,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "The Macao Special Administrative Region of China",
    iso_short_name: "Macao",
    languages_official: ["zh", "pt"],
    languages_spoken: ["zh", "pt"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Chinese",
    number: "446",
    postal_code: false,
    region: "Asia",
    start_of_week: "monday",
    subregion: "Eastern Asia",
    un_locode: "MO",
    un_member: false,
    unofficial_names: ["Macao", "Macau", "マカオ"],
    world_region: "APAC",
  },
  MP: {
    alpha2: "MP",
    alpha3: "MNP",
    continent: "Australia",
    country_code: "1",
    currency_code: "USD",
    distance_unit: "MI",
    gec: "CQ",
    geo: {
      latitude: 15.0979,
      longitude: 145.6739,
      max_latitude: 20.6584862,
      max_longitude: 146.2060546,
      min_latitude: 13.9713848,
      min_longitude: 144.7668457,
      bounds: {
        northeast: {
          lat: 20.6584862,
          lng: 146.2060546,
        },
        southwest: {
          lat: 13.9713848,
          lng: 144.7668457,
        },
      },
    },
    international_prefix: "011",
    ioc: null,
    iso_long_name: "The Commonwealth of the Northern Mariana Islands",
    iso_short_name: "Northern Mariana Islands",
    languages_official: ["en", "ch"],
    languages_spoken: ["en", "ch"],
    nanp_prefix: "1670",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "American",
    number: "580",
    postal_code: true,
    postal_code_format: "(9695[012])(?:[ \\-](\\d{4}))?",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Micronesia",
    un_locode: "MP",
    un_member: false,
    unofficial_names: [
      "Northern Mariana Islands",
      "Nördliche Marianen",
      "Mariannes du Nord",
      "Islas Marianas del Norte",
      "北マリアナ諸島",
      "Noordelijke Marianeneilanden",
    ],
    world_region: "APAC",
  },
  MQ: {
    alpha2: "MQ",
    alpha3: "MTQ",
    continent: "North America",
    country_code: "596",
    currency_code: "EUR",
    distance_unit: "KM",
    eu_member: true,
    euvat_member: false,
    gec: "MB",
    geo: {
      latitude: 14.641528,
      longitude: -61.024174,
      max_latitude: 14.8973451,
      max_longitude: -60.7856368,
      min_latitude: 14.370834,
      min_longitude: -61.24191279999999,
      bounds: {
        northeast: {
          lat: 14.8973451,
          lng: -60.7856368,
        },
        southwest: {
          lat: 14.370834,
          lng: -61.24191279999999,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "Martinique",
    iso_short_name: "Martinique",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "None",
    nationality: "French",
    number: "474",
    postal_code: true,
    postal_code_format: "9[78]2\\d{2}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "MQ",
    un_member: false,
    unofficial_names: ["Martinique", "Martinica", "マルティニーク"],
    world_region: "AMER",
  },
  MR: {
    alpha2: "MR",
    alpha3: "MRT",
    continent: "Africa",
    country_code: "222",
    currency_code: "MRU",
    distance_unit: "KM",
    gec: "MR",
    geo: {
      latitude: 21.00789,
      longitude: -10.940835,
      max_latitude: 27.3158916,
      max_longitude: -4.833334799999999,
      min_latitude: 14.721273,
      min_longitude: -17.0687276,
      bounds: {
        northeast: {
          lat: 27.3158916,
          lng: -4.833334799999999,
        },
        southwest: {
          lat: 14.721273,
          lng: -17.0687276,
        },
      },
    },
    international_prefix: "00",
    ioc: "MTN",
    iso_long_name: "The Islamic Republic of Mauritania",
    iso_short_name: "Mauritania",
    languages_official: ["ar", "fr"],
    languages_spoken: ["ar", "fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "0",
    nationality: "Mauritanian",
    number: "478",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "MR",
    un_member: true,
    unofficial_names: [
      "Mauritania",
      "موريتانيا",
      "Mauretanien",
      "Mauritanie",
      "モーリタニア",
      "Mauritanië",
    ],
    vehicle_registration_code: "RIM",
    world_region: "EMEA",
  },
  MS: {
    alpha2: "MS",
    alpha3: "MSR",
    continent: "North America",
    country_code: "1",
    currency_code: "XCD",
    distance_unit: "KM",
    gec: "MH",
    geo: {
      latitude: 16.742498,
      longitude: -62.187366,
      max_latitude: 16.8260672,
      max_longitude: -62.14262009999999,
      min_latitude: 16.671007,
      min_longitude: -62.242584,
      bounds: {
        northeast: {
          lat: 16.8260672,
          lng: -62.14262009999999,
        },
        southwest: {
          lat: 16.671007,
          lng: -62.242584,
        },
      },
    },
    international_prefix: "011",
    ioc: null,
    iso_long_name: "Montserrat",
    iso_short_name: "Montserrat",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1664",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Montserratian",
    number: "500",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "MS",
    un_member: false,
    unofficial_names: ["Montserrat", "モントセラト"],
    world_region: "EMEA",
  },
  MT: {
    alpha2: "MT",
    alpha3: "MLT",
    continent: "Europe",
    country_code: "356",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "MT",
    geo: {
      latitude: 35.937496,
      longitude: 14.375416,
      max_latitude: 36.0853,
      max_longitude: 14.5765999,
      min_latitude: 35.79960000000001,
      min_longitude: 14.1801001,
      bounds: {
        northeast: {
          lat: 36.0853,
          lng: 14.5765999,
        },
        southwest: {
          lat: 35.79960000000001,
          lng: 14.1801001,
        },
      },
    },
    international_prefix: "00",
    ioc: "MLT",
    iso_long_name: "The Republic of Malta",
    iso_short_name: "Malta",
    languages_official: ["mt", "en"],
    languages_spoken: ["mt", "en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "21",
    nationality: "Maltese",
    number: "470",
    postal_code: true,
    postal_code_format: "[A-Z]{3} ?\\d{2,4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "MT",
    un_member: true,
    unofficial_names: ["Malta", "Malte", "マルタ"],
    vat_rates: {
      standard: 18,
      reduced: [5, 7],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "M",
    world_region: "EMEA",
  },
  MU: {
    alpha2: "MU",
    alpha3: "MUS",
    continent: "Africa",
    country_code: "230",
    currency_code: "MUR",
    distance_unit: "KM",
    gec: "MP",
    geo: {
      latitude: -20.348404,
      longitude: 57.55215200000001,
      max_latitude: -10.0878538,
      max_longitude: 63.80859390000001,
      min_latitude: -20.7458403,
      min_longitude: 56.3159179,
      bounds: {
        northeast: {
          lat: -10.0878538,
          lng: 63.80859390000001,
        },
        southwest: {
          lat: -20.7458403,
          lng: 56.3159179,
        },
      },
    },
    international_prefix: "020",
    ioc: "MRI",
    iso_long_name: "The Republic of Mauritius",
    iso_short_name: "Mauritius",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Mauritian",
    number: "480",
    postal_code: true,
    postal_code_format: "\\d{3}(?:\\d{2}|[A-Z]{2}\\d{3})",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "MU",
    un_member: true,
    unofficial_names: ["Mauritius", "Île Maurice", "Mauricio", "モーリシャス"],
    vehicle_registration_code: "MS",
    world_region: "EMEA",
  },
  MV: {
    alpha2: "MV",
    alpha3: "MDV",
    continent: "Asia",
    country_code: "960",
    currency_code: "MVR",
    distance_unit: "KM",
    gec: "MV",
    geo: {
      latitude: 3.202778,
      longitude: 73.22068,
      max_latitude: 7.5149809,
      max_longitude: 74.7290038,
      min_latitude: -1.2907844,
      min_longitude: 71.75170899999999,
      bounds: {
        northeast: {
          lat: 7.5149809,
          lng: 74.7290038,
        },
        southwest: {
          lat: -1.2907844,
          lng: 71.75170899999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "MDV",
    iso_long_name: "The Republic of Maldives",
    iso_short_name: "Maldives",
    languages_official: ["dv"],
    languages_spoken: ["dv"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Maldivan",
    number: "462",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "sunday",
    subregion: "Southern Asia",
    un_locode: "MV",
    un_member: true,
    unofficial_names: [
      "Maldives",
      "Malediven",
      "Maldivas",
      "モルディブ",
      "Maldiven",
    ],
    vehicle_registration_code: "MV",
    world_region: "APAC",
  },
  MW: {
    alpha2: "MW",
    alpha3: "MWI",
    continent: "Africa",
    country_code: "265",
    currency_code: "MWK",
    distance_unit: "KM",
    gec: "MI",
    geo: {
      latitude: -13.254308,
      longitude: 34.301525,
      max_latitude: -9.3672272,
      max_longitude: 35.91857299999999,
      min_latitude: -17.1295216,
      min_longitude: 32.6725205,
      bounds: {
        northeast: {
          lat: -9.3672272,
          lng: 35.91857299999999,
        },
        southwest: {
          lat: -17.1295216,
          lng: 32.6725205,
        },
      },
    },
    international_prefix: "00",
    ioc: "MAW",
    iso_long_name: "The Republic of Malawi",
    iso_short_name: "Malawi",
    languages_official: ["en", "ny"],
    languages_spoken: ["en", "ny"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Malawian",
    number: "454",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "MW",
    un_member: true,
    unofficial_names: ["Malawi", "マラウイ"],
    vehicle_registration_code: "MW",
    world_region: "EMEA",
  },
  MX: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}} {{region_short}}\n{{country}}",
    alpha2: "MX",
    alpha3: "MEX",
    continent: "North America",
    country_code: "52",
    currency_code: "MXN",
    distance_unit: "KM",
    g20_member: true,
    gec: "MX",
    geo: {
      latitude: 23.634501,
      longitude: -102.552784,
      max_latitude: 32.7186534,
      max_longitude: -86.5887,
      min_latitude: 14.3895,
      min_longitude: -118.6523001,
      bounds: {
        northeast: {
          lat: 32.7186534,
          lng: -86.5887,
        },
        southwest: {
          lat: 14.3895,
          lng: -118.6523001,
        },
      },
    },
    international_prefix: "00",
    ioc: "MEX",
    iso_long_name: "The United Mexican States",
    iso_short_name: "Mexico",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9, 10],
    national_prefix: "01",
    nationality: "Mexican",
    number: "484",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Central America",
    un_locode: "MX",
    un_member: true,
    unofficial_names: ["Mexico", "Mexiko", "Mexique", "México", "メキシコ"],
    vat_rates: {
      standard: 16,
      reduced: [],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "MEX",
    world_region: "AMER",
  },
  MY: {
    alpha2: "MY",
    alpha3: "MYS",
    continent: "Asia",
    country_code: "60",
    currency_code: "MYR",
    distance_unit: "KM",
    gec: "MY",
    geo: {
      latitude: 4.210484,
      longitude: 101.975766,
      max_latitude: 7.5191,
      max_longitude: 119.4000001,
      min_latitude: 0.8539281000000001,
      min_longitude: 98.9353999,
      bounds: {
        northeast: {
          lat: 7.5191,
          lng: 119.4000001,
        },
        southwest: {
          lat: 0.8539281000000001,
          lng: 98.9353999,
        },
      },
    },
    international_prefix: "00",
    ioc: "MAS",
    iso_long_name: "Malaysia",
    iso_short_name: "Malaysia",
    languages_official: ["ms", "en"],
    languages_spoken: ["ms", "en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9, 10],
    national_prefix: "0",
    nationality: "Malaysian",
    number: "458",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "sunday",
    subregion: "South-Eastern Asia",
    un_locode: "MY",
    un_member: true,
    unofficial_names: [
      "Malaysia",
      "Malaisie",
      "Malasia",
      "マレーシア",
      "Maleisië",
    ],
    vehicle_registration_code: "MAL",
    world_region: "APAC",
  },
  MZ: {
    alpha2: "MZ",
    alpha3: "MOZ",
    continent: "Africa",
    country_code: "258",
    currency_code: "MZN",
    distance_unit: "KM",
    gec: "MZ",
    geo: {
      latitude: -18.665695,
      longitude: 35.529562,
      max_latitude: -10.3128929,
      max_longitude: 41.3965,
      min_latitude: -26.9612,
      min_longitude: 30.2155501,
      bounds: {
        northeast: {
          lat: -10.3128929,
          lng: 41.3965,
        },
        southwest: {
          lat: -26.9612,
          lng: 30.2155501,
        },
      },
    },
    international_prefix: "00",
    ioc: "MOZ",
    iso_long_name: "The Republic of Mozambique",
    iso_short_name: "Mozambique",
    languages_official: ["pt"],
    languages_spoken: ["pt"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "Mozambican",
    number: "508",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "MZ",
    un_member: true,
    unofficial_names: ["Mozambique", "Mosambik", "モザンビーク"],
    vehicle_registration_code: "MOC",
    world_region: "EMEA",
  },
  NA: {
    alpha2: "NA",
    alpha3: "NAM",
    alt_currency: "ZAR",
    continent: "Africa",
    country_code: "264",
    currency_code: "NAD",
    distance_unit: "KM",
    gec: "WA",
    geo: {
      latitude: -22.95764,
      longitude: 18.49041,
      max_latitude: -16.9634849,
      max_longitude: 25.261752,
      min_latitude: -28.97063889999999,
      min_longitude: 11.4696999,
      bounds: {
        northeast: {
          lat: -16.9634849,
          lng: 25.261752,
        },
        southwest: {
          lat: -28.97063889999999,
          lng: 11.4696999,
        },
      },
    },
    international_prefix: "00",
    ioc: "NAM",
    iso_long_name: "The Republic of Namibia",
    iso_short_name: "Namibia",
    languages_official: ["en", "af"],
    languages_spoken: ["en", "af"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6, 7],
    national_prefix: "0",
    nationality: "Namibian",
    number: "516",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Southern Africa",
    un_locode: "NA",
    un_member: true,
    unofficial_names: ["Namibia", "Namibie", "ナミビア", "Namibië"],
    vehicle_registration_code: "NAM",
    world_region: "EMEA",
  },
  NC: {
    alpha2: "NC",
    alpha3: "NCL",
    continent: "Australia",
    country_code: "687",
    currency_code: "XPF",
    distance_unit: "KM",
    gec: "NC",
    geo: {
      latitude: -20.904305,
      longitude: 165.618042,
      max_latitude: -19.1607355,
      max_longitude: 168.3325194,
      min_latitude: -23.2514406,
      min_longitude: 163.3557129,
      bounds: {
        northeast: {
          lat: -19.1607355,
          lng: 168.3325194,
        },
        southwest: {
          lat: -23.2514406,
          lng: 163.3557129,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "New Caledonia",
    iso_short_name: "New Caledonia",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6],
    national_prefix: "None",
    nationality: "New Caledonian",
    number: "540",
    postal_code: true,
    postal_code_format: "988\\d{2}",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Melanesia",
    un_locode: "NC",
    un_member: false,
    unofficial_names: [
      "New Caledonia",
      "Neukaledonien",
      "Nouvelle-Calédonie",
      "Nueva Caledonia",
      "ニューカレドニア",
      "Nieuw-Caledonië",
    ],
    vehicle_registration_code: "NCL",
    world_region: "APAC",
  },
  NE: {
    alpha2: "NE",
    alpha3: "NER",
    continent: "Africa",
    country_code: "227",
    currency_code: "XOF",
    distance_unit: "KM",
    gec: "NG",
    geo: {
      latitude: 17.607789,
      longitude: 8.081666,
      max_latitude: 23.4999997,
      max_longitude: 15.9990339,
      min_latitude: 11.693756,
      min_longitude: 0.1617177,
      bounds: {
        northeast: {
          lat: 23.4999997,
          lng: 15.9990339,
        },
        southwest: {
          lat: 11.693756,
          lng: 0.1617177,
        },
      },
    },
    international_prefix: "00",
    ioc: "NIG",
    iso_long_name: "The Republic of the Niger",
    iso_short_name: "Niger",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Nigerian",
    number: "562",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "NE",
    un_member: true,
    unofficial_names: ["Niger", "Níger", "ニジェール"],
    vehicle_registration_code: "RN",
    world_region: "EMEA",
  },
  NF: {
    alpha2: "NF",
    alpha3: "NFK",
    continent: "Australia",
    country_code: "672",
    currency_code: "AUD",
    distance_unit: "KM",
    gec: "NF",
    geo: {
      latitude: -29.040835,
      longitude: 167.954712,
      max_latitude: -28.9929014,
      max_longitude: 167.9985523,
      min_latitude: -29.137506,
      min_longitude: 167.9134083,
      bounds: {
        northeast: {
          lat: -28.9929014,
          lng: 167.9985523,
        },
        southwest: {
          lat: -29.137506,
          lng: 167.9134083,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "The Territory of Norfolk Island",
    iso_short_name: "Norfolk Island",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6],
    national_prefix: "None",
    nationality: "Norfolk Islander",
    number: "574",
    postal_code: true,
    postal_code_format: "2899",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Australia and New Zealand",
    un_locode: "NF",
    un_member: false,
    unofficial_names: [
      "Norfolk Island",
      "Norfolkinsel",
      "Île de Norfolk",
      "Isla de Norfolk",
      "ノーフォーク島",
      "Norfolkeiland",
    ],
    world_region: "APAC",
  },
  NG: {
    alpha2: "NG",
    alpha3: "NGA",
    continent: "Africa",
    country_code: "234",
    currency_code: "NGN",
    distance_unit: "KM",
    gec: "NI",
    geo: {
      latitude: 9.081999,
      longitude: 8.675277,
      max_latitude: 13.8856449,
      max_longitude: 14.677982,
      min_latitude: 4.1821001,
      min_longitude: 2.676932,
      bounds: {
        northeast: {
          lat: 13.8856449,
          lng: 14.677982,
        },
        southwest: {
          lat: 4.1821001,
          lng: 2.676932,
        },
      },
    },
    international_prefix: "009",
    ioc: "NGR",
    iso_long_name: "The Federal Republic of Nigeria",
    iso_short_name: "Nigeria",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8],
    national_prefix: "0",
    nationality: "Nigerian",
    number: "566",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "NG",
    un_member: true,
    unofficial_names: [
      "Nigeria",
      "Nigéria",
      "the Federal Republic of Nigeria",
      "ナイジェリア",
    ],
    vat_rates: {
      standard: 5,
      reduced: [],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "NGR",
    world_region: "EMEA",
  },
  NI: {
    alpha2: "NI",
    alpha3: "NIC",
    continent: "North America",
    country_code: "505",
    currency_code: "NIO",
    distance_unit: "KM",
    gec: "NU",
    geo: {
      latitude: 12.865416,
      longitude: -85.207229,
      max_latitude: 15.0297369,
      max_longitude: -82.2766,
      min_latitude: 10.7080549,
      min_longitude: -87.7588,
      bounds: {
        northeast: {
          lat: 15.0297369,
          lng: -82.2766,
        },
        southwest: {
          lat: 10.7080549,
          lng: -87.7588,
        },
      },
    },
    international_prefix: "00",
    ioc: "NCA",
    iso_long_name: "The Republic of Nicaragua",
    iso_short_name: "Nicaragua",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Nicaraguan",
    number: "558",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Central America",
    un_locode: "NI",
    un_member: true,
    unofficial_names: ["Nicaragua", "ニカラグア"],
    vehicle_registration_code: "NIC",
    world_region: "AMER",
  },
  NL: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "NL",
    alpha3: "NLD",
    continent: "Europe",
    country_code: "31",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "NL",
    geo: {
      latitude: 52.132633,
      longitude: 5.291265999999999,
      max_latitude: 53.6316,
      max_longitude: 7.227510199999999,
      min_latitude: 50.75038379999999,
      min_longitude: 3.3316001,
      bounds: {
        northeast: {
          lat: 53.6316,
          lng: 7.227510199999999,
        },
        southwest: {
          lat: 50.75038379999999,
          lng: 3.3316001,
        },
      },
    },
    international_prefix: "00",
    ioc: "NED",
    iso_long_name: "The Kingdom of the Netherlands",
    iso_short_name: "Netherlands",
    languages_official: ["nl"],
    languages_spoken: ["nl", "fy"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Dutch",
    number: "528",
    postal_code: true,
    postal_code_format: "\\d{4} ?[A-Z]{2}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Western Europe",
    un_locode: "NL",
    un_member: true,
    unofficial_names: [
      "Netherlands",
      "The Netherlands",
      "Niederlande",
      "Pays-Bas",
      "Países Bajos",
      "オランダ",
      "Nederland",
      "Нидерландия",
    ],
    vat_rates: {
      standard: 21,
      reduced: [9],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "NL",
    world_region: "EMEA",
  },
  NO: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "NO",
    alpha3: "NOR",
    continent: "Europe",
    country_code: "47",
    currency_code: "NOK",
    distance_unit: "KM",
    eea_member: true,
    gec: "NO",
    geo: {
      latitude: 60.47202399999999,
      longitude: 8.468945999999999,
      max_latitude: 71.30780000000001,
      max_longitude: 31.3549999,
      min_latitude: 57.8097,
      min_longitude: 4.0649,
      bounds: {
        northeast: {
          lat: 71.30780000000001,
          lng: 31.3549999,
        },
        southwest: {
          lat: 57.8097,
          lng: 4.0649,
        },
      },
    },
    international_prefix: "00",
    ioc: "NOR",
    iso_long_name: "The Kingdom of Norway",
    iso_short_name: "Norway",
    languages_official: ["nb", "nn"],
    languages_spoken: ["nb", "nn"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Norwegian",
    number: "578",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "NO",
    un_member: true,
    unofficial_names: [
      "Norway",
      "Norwegen",
      "Norvège",
      "Noruega",
      "ノルウェー",
      "Noorwegen",
    ],
    vat_rates: {
      standard: 25,
      reduced: [],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "N",
    world_region: "EMEA",
  },
  NP: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}}\n{{region}} {{postalcode}}\n{{country}}",
    alpha2: "NP",
    alpha3: "NPL",
    continent: "Asia",
    country_code: "977",
    currency_code: "NPR",
    distance_unit: "KM",
    gec: "NP",
    geo: {
      latitude: 28.394857,
      longitude: 84.12400799999999,
      max_latitude: 30.4473898,
      max_longitude: 88.20182969999999,
      min_latitude: 26.3473741,
      min_longitude: 80.05846980000001,
      bounds: {
        northeast: {
          lat: 30.4473898,
          lng: 88.20182969999999,
        },
        southwest: {
          lat: 26.3473741,
          lng: 80.05846980000001,
        },
      },
    },
    international_prefix: "00",
    ioc: "NEP",
    iso_long_name: "The Federal Democratic Republic of Nepal",
    iso_short_name: "Nepal",
    languages_official: ["ne"],
    languages_spoken: ["ne", "mai", "bho", "new", "urd"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8],
    national_prefix: "0",
    nationality: "Nepalese",
    number: "524",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "sunday",
    subregion: "Southern Asia",
    un_locode: "NP",
    un_member: true,
    unofficial_names: [
      "Nepal",
      "Népal",
      "the Federal Democratic Republic of Nepal",
      "ネパール",
    ],
    vehicle_registration_code: "NEP*",
    world_region: "APAC",
  },
  NR: {
    alpha2: "NR",
    alpha3: "NRU",
    continent: "Australia",
    country_code: "674",
    currency_code: "AUD",
    distance_unit: "KM",
    gec: "NR",
    geo: {
      latitude: -0.522778,
      longitude: 166.931503,
      max_latitude: -0.4978976000000001,
      max_longitude: 166.9631767,
      min_latitude: -0.5580623,
      min_longitude: 166.9071293,
      bounds: {
        northeast: {
          lat: -0.4978976000000001,
          lng: 166.9631767,
        },
        southwest: {
          lat: -0.5580623,
          lng: 166.9071293,
        },
      },
    },
    international_prefix: "00",
    ioc: "NRU",
    iso_long_name: "The Republic of Nauru",
    iso_short_name: "Nauru",
    languages_official: ["en", "na"],
    languages_spoken: ["en", "na"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "0",
    nationality: "Nauruan",
    number: "520",
    postal_code: false,
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Micronesia",
    un_locode: "NR",
    un_member: true,
    unofficial_names: ["Nauru", "ナウル"],
    vehicle_registration_code: "NAU",
    world_region: "APAC",
  },
  NU: {
    alpha2: "NU",
    alpha3: "NIU",
    continent: "Australia",
    country_code: "683",
    currency_code: "NZD",
    distance_unit: "KM",
    gec: "NE",
    geo: {
      latitude: -19.054445,
      longitude: -169.867233,
      max_latitude: -18.952625,
      max_longitude: -169.7743248,
      min_latitude: -19.1555668,
      min_longitude: -169.9500846,
      bounds: {
        northeast: {
          lat: -18.952625,
          lng: -169.7743248,
        },
        southwest: {
          lat: -19.1555668,
          lng: -169.9500846,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "Niue",
    iso_short_name: "Niue",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [4],
    national_prefix: "None",
    nationality: "Niuean",
    number: "570",
    postal_code: false,
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Polynesia",
    un_locode: "NU",
    un_member: false,
    unofficial_names: ["Niue", "ニウエ"],
    world_region: "APAC",
  },
  NZ: {
    address_format:
      "{{recipient}}\n{{street}}\n{{region}}\n{{city}} {{postalcode}}\n{{country}}",
    alpha2: "NZ",
    alpha3: "NZL",
    continent: "Australia",
    country_code: "64",
    currency_code: "NZD",
    distance_unit: "KM",
    gec: "NZ",
    geo: {
      latitude: -40.900557,
      longitude: 174.885971,
      max_latitude: -28.8773225,
      max_longitude: -175.1235077,
      min_latitude: -52.7224663,
      min_longitude: 165.7437641,
      bounds: {
        northeast: {
          lat: -28.8773225,
          lng: -175.1235077,
        },
        southwest: {
          lat: -52.7224663,
          lng: 165.7437641,
        },
      },
    },
    international_prefix: "00",
    ioc: "NZL",
    iso_long_name: "New Zealand",
    iso_short_name: "New Zealand",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [1],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "New Zealander",
    number: "554",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Australia and New Zealand",
    un_locode: "NZ",
    un_member: true,
    unofficial_names: [
      "New Zealand",
      "Neuseeland",
      "Nouvelle Zélande",
      "Nueva Zelanda",
      "ニュージーランド",
      "Nieuw-Zeeland",
    ],
    vat_rates: {
      standard: 15,
      reduced: [9],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "NZ",
    world_region: "APAC",
  },
  OM: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{region}}\n{{country}}",
    alpha2: "OM",
    alpha3: "OMN",
    continent: "Asia",
    country_code: "968",
    currency_code: "OMR",
    distance_unit: "KM",
    gec: "MU",
    geo: {
      latitude: 21.4735329,
      longitude: 55.975413,
      max_latitude: 26.4361001,
      max_longitude: 60.30399999999999,
      min_latitude: 16.4571999,
      min_longitude: 52.0000019,
      bounds: {
        northeast: {
          lat: 26.4361001,
          lng: 60.30399999999999,
        },
        southwest: {
          lat: 16.4571999,
          lng: 52.0000019,
        },
      },
    },
    international_prefix: "00",
    ioc: "OMA",
    iso_long_name: "The Sultanate of Oman",
    iso_short_name: "Oman",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Omani",
    number: "512",
    postal_code: true,
    postal_code_format: "(?:PC )?\\d{3}",
    region: "Asia",
    start_of_week: "sunday",
    subregion: "Western Asia",
    un_locode: "OM",
    un_member: true,
    unofficial_names: ["Oman", "عمان", "Omán", "オマーン"],
    vehicle_registration_code: "OM",
    world_region: "EMEA",
  },
  PA: {
    alpha2: "PA",
    alpha3: "PAN",
    alt_currency: "USD",
    continent: "North America",
    country_code: "507",
    currency_code: "PAB",
    distance_unit: "KM",
    gec: "PM",
    geo: {
      latitude: 8.537981,
      longitude: -80.782127,
      max_latitude: 9.7145001,
      max_longitude: -77.1584879,
      min_latitude: 7.0409,
      min_longitude: -83.05224109999999,
      bounds: {
        northeast: {
          lat: 9.7145001,
          lng: -77.1584879,
        },
        southwest: {
          lat: 7.0409,
          lng: -83.05224109999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "PAN",
    iso_long_name: "The Republic of Panamá",
    iso_short_name: "Panama",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Panamanian",
    number: "591",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Central America",
    un_locode: "PA",
    un_member: true,
    unofficial_names: ["Panama", "Panamá", "パナマ"],
    vehicle_registration_code: "PA",
    world_region: "AMER",
  },
  PE: {
    alpha2: "PE",
    alpha3: "PER",
    continent: "South America",
    country_code: "51",
    currency_code: "PEN",
    distance_unit: "KM",
    gec: "PE",
    geo: {
      latitude: -9.189967,
      longitude: -75.015152,
      max_latitude: -0.0387769,
      max_longitude: -68.65232879999999,
      min_latitude: -18.4483,
      min_longitude: -81.3867001,
      bounds: {
        northeast: {
          lat: -0.0387769,
          lng: -68.65232879999999,
        },
        southwest: {
          lat: -18.4483,
          lng: -81.3867001,
        },
      },
    },
    international_prefix: "00",
    ioc: "PER",
    iso_long_name: "The Republic of Perú",
    iso_short_name: "Peru",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "Peruvian",
    number: "604",
    postal_code: true,
    postal_code_format: "(?:LIMA \\d{1,2}|CALLAO 0?\\d)|[0-2]\\d{4}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "PE",
    un_member: true,
    unofficial_names: ["Peru", "Pérou", "Perú", "ペルー"],
    vehicle_registration_code: "PE",
    world_region: "AMER",
  },
  PF: {
    alpha2: "PF",
    alpha3: "PYF",
    continent: "Australia",
    country_code: "689",
    currency_code: "XPF",
    distance_unit: "KM",
    gec: "FP",
    geo: {
      latitude: -17.679742,
      longitude: -149.406843,
      max_latitude: -6.4682,
      max_longitude: -134.0551932,
      min_latitude: -28.61346,
      min_longitude: -155.125483,
      bounds: {
        northeast: {
          lat: -6.4682,
          lng: -134.0551932,
        },
        southwest: {
          lat: -28.61346,
          lng: -155.125483,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "French Polynesia",
    iso_short_name: "French Polynesia",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6],
    national_prefix: "None",
    nationality: "French Polynesian",
    number: "258",
    postal_code: true,
    postal_code_format: "987\\d{2}",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Polynesia",
    un_locode: "PF",
    un_member: false,
    unofficial_names: [
      "French Polynesia",
      "Französisch-Polynesien",
      "Polynésie Française",
      "Polinesia Francesa",
      "フランス領ポリネシア",
      "Frans-Polynesië",
    ],
    world_region: "APAC",
  },
  PG: {
    alpha2: "PG",
    alpha3: "PNG",
    continent: "Australia",
    country_code: "675",
    currency_code: "PGK",
    distance_unit: "KM",
    gec: "PP",
    geo: {
      latitude: -6.314992999999999,
      longitude: 143.95555,
      max_latitude: -0.6702,
      max_longitude: 159.9609001,
      min_latitude: -12.0823,
      min_longitude: 140.8419695,
      bounds: {
        northeast: {
          lat: -0.6702,
          lng: 159.9609001,
        },
        southwest: {
          lat: -12.0823,
          lng: 140.8419695,
        },
      },
    },
    international_prefix: "05",
    ioc: "PNG",
    iso_long_name: "The Independent State of Papua New Guinea",
    iso_short_name: "Papua New Guinea",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Papua New Guinean",
    number: "598",
    postal_code: true,
    postal_code_format: "\\d{3}",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Melanesia",
    un_locode: "PG",
    un_member: true,
    unofficial_names: [
      "Papua New Guinea",
      "Papua-Neuguinea",
      "Papouasie Nouvelle-Guinée",
      "Papúa Nueva Guinea",
      "パプアニューギニア",
      "Papoea-Nieuw-Guinea",
    ],
    vehicle_registration_code: "PNG",
    world_region: "APAC",
  },
  PH: {
    address_format:
      "{{recipient}}\n{{street}} {{region_short}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "PH",
    alpha3: "PHL",
    continent: "Asia",
    country_code: "63",
    currency_code: "PHP",
    distance_unit: "KM",
    gec: "RP",
    geo: {
      latitude: 12.879721,
      longitude: 121.774017,
      max_latitude: 21.2412572,
      max_longitude: 127.6444784,
      min_latitude: 4.2259,
      min_longitude: 116.1474999,
      bounds: {
        northeast: {
          lat: 21.2412572,
          lng: 127.6444784,
        },
        southwest: {
          lat: 4.2259,
          lng: 116.1474999,
        },
      },
    },
    international_prefix: "00",
    ioc: "PHI",
    iso_long_name: "The Republic of the Philippines",
    iso_short_name: "Philippines",
    languages_official: ["tl", "en"],
    languages_spoken: ["tl", "en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9, 10],
    national_prefix: "0",
    nationality: "Filipino",
    number: "608",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "South-Eastern Asia",
    un_locode: "PH",
    un_member: true,
    unofficial_names: [
      "Philippines",
      "Philippinen",
      "Filipinas",
      "フィリピン",
      "Filipijnen",
    ],
    vat_rates: {
      standard: 12,
      reduced: [],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "RP",
    world_region: "APAC",
  },
  PK: {
    alpha2: "PK",
    alpha3: "PAK",
    continent: "Asia",
    country_code: "92",
    currency_code: "PKR",
    distance_unit: "KM",
    gec: "PK",
    geo: {
      latitude: 30.375321,
      longitude: 69.34511599999999,
      max_latitude: 37.0841069,
      max_longitude: 77.8231711,
      min_latitude: 23.6344999,
      min_longitude: 60.8729721,
      bounds: {
        northeast: {
          lat: 37.0841069,
          lng: 77.8231711,
        },
        southwest: {
          lat: 23.6344999,
          lng: 60.8729721,
        },
      },
    },
    international_prefix: "00",
    ioc: "PAK",
    iso_long_name: "The Islamic Republic of Pakistan",
    iso_short_name: "Pakistan",
    languages_official: ["en", "ur"],
    languages_spoken: ["en", "ur"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9, 10],
    national_prefix: "0",
    nationality: "Pakistani",
    number: "586",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Southern Asia",
    un_locode: "PK",
    un_member: true,
    unofficial_names: ["Pakistan", "Paquistán", "パキスタン"],
    vehicle_registration_code: "PK",
    world_region: "APAC",
  },
  PL: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{region}}\n{{country}}",
    alpha2: "PL",
    alpha3: "POL",
    continent: "Europe",
    country_code: "48",
    currency_code: "PLN",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "PL",
    geo: {
      latitude: 51.919438,
      longitude: 19.145136,
      max_latitude: 54.9054761,
      max_longitude: 24.1458931,
      min_latitude: 49.002025,
      min_longitude: 14.1228641,
      bounds: {
        northeast: {
          lat: 54.9054761,
          lng: 24.1458931,
        },
        southwest: {
          lat: 49.002025,
          lng: 14.1228641,
        },
      },
    },
    international_prefix: "00",
    ioc: "POL",
    iso_long_name: "The Republic of Poland",
    iso_short_name: "Poland",
    languages_official: ["pl"],
    languages_spoken: ["pl"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Polish",
    number: "616",
    postal_code: true,
    postal_code_format: "\\d{2}-\\d{3}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Eastern Europe",
    un_locode: "PL",
    un_member: true,
    unofficial_names: ["Poland", "Polen", "Pologne", "Polonia", "ポーランド"],
    vat_rates: {
      standard: 23,
      reduced: [5, 8],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "PL",
    world_region: "EMEA",
  },
  PM: {
    alpha2: "PM",
    alpha3: "SPM",
    continent: "North America",
    country_code: "508",
    currency_code: "EUR",
    distance_unit: "KM",
    gec: "SB",
    geo: {
      latitude: 46.8852,
      longitude: -56.3159,
      max_latitude: 47.21579999999999,
      max_longitude: -55.98249999999999,
      min_latitude: 46.7003,
      min_longitude: -56.5233,
      bounds: {
        northeast: {
          lat: 47.21579999999999,
          lng: -55.98249999999999,
        },
        southwest: {
          lat: 46.7003,
          lng: -56.5233,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "The Overseas Collectivity of Saint-Pierre and Miquelon",
    iso_short_name: "Saint Pierre and Miquelon",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6],
    national_prefix: "0",
    nationality: "French",
    number: "666",
    postal_code: true,
    postal_code_format: "9[78]5\\d{2}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Northern America",
    un_locode: "PM",
    un_member: false,
    unofficial_names: [
      "Saint Pierre and Miquelon",
      "Saint-Pierre und Miquelon",
      "Saint-Pierre-et-Miquelon",
      "San Pedro y Miquelón",
      "サンピエール島・ミクロン島",
      "Saint Pierre en Miquelon",
    ],
    world_region: "AMER",
  },
  PN: {
    alpha2: "PN",
    alpha3: "PCN",
    continent: "Australia",
    country_code: "64",
    currency_code: "NZD",
    distance_unit: "KM",
    gec: "PC",
    geo: {
      latitude: -24.3767537,
      longitude: -128.3242376,
      max_latitude: -23.7928845,
      max_longitude: -124.5410156,
      min_latitude: -25.1776023,
      min_longitude: -130.9268188,
      bounds: {
        northeast: {
          lat: -23.7928845,
          lng: -124.5410156,
        },
        southwest: {
          lat: -25.1776023,
          lng: -130.9268188,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "The Pitcairn, Henderson, Ducie and Oeno Islands",
    iso_short_name: "Pitcairn",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Pitcairn Islander",
    number: "612",
    postal_code: true,
    postal_code_format: "PCRN 1ZZ",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Polynesia",
    un_locode: "PN",
    un_member: false,
    unofficial_names: [
      "Pitcairn",
      "ピトケアン",
      "Pitcairneilanden",
      "Pitcairn Islands",
    ],
    world_region: "APAC",
  },
  PR: {
    alpha2: "PR",
    alpha3: "PRI",
    continent: "North America",
    country_code: "1",
    currency_code: "USD",
    distance_unit: "KM",
    gec: "RQ",
    geo: {
      latitude: 18.220833,
      longitude: -66.590149,
      max_latitude: 18.5720479,
      max_longitude: -65.2105715,
      min_latitude: 17.8449191,
      min_longitude: -67.9611844,
      bounds: {
        northeast: {
          lat: 18.5720479,
          lng: -65.2105715,
        },
        southwest: {
          lat: 17.8449191,
          lng: -67.9611844,
        },
      },
    },
    international_prefix: "011",
    ioc: "PUR",
    iso_long_name: "The Commonwealth of Puerto Rico",
    iso_short_name: "Puerto Rico",
    languages_official: ["es", "en"],
    languages_spoken: ["es", "en"],
    nanp_prefix: "1787",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Puerto Rican",
    number: "630",
    postal_code: true,
    postal_code_format: "(00[679]\\d{2})(?:[ \\-](\\d{4}))?",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "PR",
    un_member: false,
    unofficial_names: ["Puerto Rico", "プエルトリコ"],
    vehicle_registration_code: "PRI",
    world_region: "AMER",
  },
  PS: {
    alpha2: "PS",
    alpha3: "PSE",
    alt_currency: "EGP",
    continent: "Asia",
    country_code: "970",
    currency_code: "ILS",
    distance_unit: "KM",
    gec: "WE",
    geo: {
      latitude: 31.952162,
      longitude: 35.233154,
      max_latitude: 32.5520999,
      max_longitude: 35.5740521,
      min_latitude: 31.219691,
      min_longitude: 34.21010010000001,
      bounds: {
        northeast: {
          lat: 32.5520999,
          lng: 35.5740521,
        },
        southwest: {
          lat: 31.219691,
          lng: 34.21010010000001,
        },
      },
    },
    international_prefix: "00",
    ioc: "PLE",
    iso_long_name: "The State of Palestine",
    iso_short_name: "Palestine, State of",
    languages_official: ["ar", "he", "en"],
    languages_spoken: ["ar", "he", "en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8, 9],
    national_prefix: "0",
    nationality: "Palestinian",
    number: "275",
    postal_code: false,
    region: "Asia",
    start_of_week: "sunday",
    subregion: "Western Asia",
    un_locode: "PS",
    un_member: false,
    unofficial_names: [
      "Palestine",
      "فلسطين",
      "Palästina",
      "Palestina",
      "the Occupied Palestinian Territory",
      "パレスチナ",
      "Palestijnse gebieden",
      "Palestinian Territory Occupied",
      "Palestinian Authority",
    ],
    vehicle_registration_code: "WB",
    world_region: "EMEA",
  },
  PT: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}} {{region_short}}\n{{country}}",
    alpha2: "PT",
    alpha3: "PRT",
    continent: "Europe",
    country_code: "351",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "PO",
    geo: {
      latitude: 39.39987199999999,
      longitude: -8.224454,
      max_latitude: 42.1543111,
      max_longitude: -6.189159200000001,
      min_latitude: 32.2895,
      min_longitude: -31.4647999,
      bounds: {
        northeast: {
          lat: 42.1543111,
          lng: -6.189159200000001,
        },
        southwest: {
          lat: 32.2895,
          lng: -31.4647999,
        },
      },
    },
    international_prefix: "00",
    ioc: "POR",
    iso_long_name: "The Portuguese Republic",
    iso_short_name: "Portugal",
    languages_official: ["pt"],
    languages_spoken: ["pt"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "None",
    nationality: "Portuguese",
    number: "620",
    postal_code: true,
    postal_code_format: "\\d{4}-\\d{3}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "PT",
    un_member: true,
    unofficial_names: ["Portugal", "ポルトガル"],
    vat_rates: {
      standard: 23,
      reduced: [6, 13],
      super_reduced: null,
      parking: 13,
    },
    vehicle_registration_code: "P",
    world_region: "EMEA",
  },
  PW: {
    alpha2: "PW",
    alpha3: "PLW",
    continent: "Australia",
    country_code: "680",
    currency_code: "USD",
    distance_unit: "KM",
    gec: "PS",
    geo: {
      latitude: 7.514979999999999,
      longitude: 134.58252,
      max_latitude: 8.238674,
      max_longitude: 135.0769,
      min_latitude: 2.6394,
      min_longitude: 131.0115,
      bounds: {
        northeast: {
          lat: 8.238674,
          lng: 135.0769,
        },
        southwest: {
          lat: 2.6394,
          lng: 131.0115,
        },
      },
    },
    international_prefix: "00",
    ioc: "PLW",
    iso_long_name: "The Republic of Palau",
    iso_short_name: "Palau",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Palauan",
    number: "585",
    postal_code: true,
    postal_code_format: "(969(?:39|40))(?:[ \\-](\\d{4}))?",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Micronesia",
    un_locode: "PW",
    un_member: true,
    unofficial_names: ["Palau", "パラオ"],
    vehicle_registration_code: "PAL",
    world_region: "APAC",
  },
  PY: {
    alpha2: "PY",
    alpha3: "PRY",
    continent: "South America",
    country_code: "595",
    currency_code: "PYG",
    distance_unit: "KM",
    gec: "PA",
    geo: {
      latitude: -23.442503,
      longitude: -58.443832,
      max_latitude: -19.2876589,
      max_longitude: -54.258562,
      min_latitude: -27.5817594,
      min_longitude: -62.63895230000001,
      bounds: {
        northeast: {
          lat: -19.2876589,
          lng: -54.258562,
        },
        southwest: {
          lat: -27.5817594,
          lng: -62.63895230000001,
        },
      },
    },
    international_prefix: "002",
    ioc: "PAR",
    iso_long_name: "The Republic of Paraguay",
    iso_short_name: "Paraguay",
    languages_official: ["es", "gn"],
    languages_spoken: ["es", "gn"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Paraguayan",
    number: "600",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "PY",
    un_member: true,
    unofficial_names: ["Paraguay", "パラグアイ"],
    vehicle_registration_code: "PY",
    world_region: "AMER",
  },
  QA: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "QA",
    alpha3: "QAT",
    continent: "Asia",
    country_code: "974",
    currency_code: "QAR",
    distance_unit: "KM",
    gec: "QA",
    geo: {
      latitude: 25.354826,
      longitude: 51.183884,
      max_latitude: 26.2171,
      max_longitude: 51.7144001,
      min_latitude: 24.471118,
      min_longitude: 50.7211001,
      bounds: {
        northeast: {
          lat: 26.2171,
          lng: 51.7144001,
        },
        southwest: {
          lat: 24.471118,
          lng: 50.7211001,
        },
      },
    },
    international_prefix: "00",
    ioc: "QAT",
    iso_long_name: "The State of Qatar",
    iso_short_name: "Qatar",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Qatari",
    number: "634",
    postal_code: false,
    region: "Asia",
    start_of_week: "sunday",
    subregion: "Western Asia",
    un_locode: "QA",
    un_member: true,
    unofficial_names: ["Qatar", "قطر", "Katar", "カタール"],
    vehicle_registration_code: "Q",
    world_region: "EMEA",
  },
  ID: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}}\n{{region}} {{postalcode}}\n{{country}}",
    alpha2: "ID",
    alpha3: "IDN",
    continent: "Asia",
    country_code: "62",
    currency_code: "IDR",
    distance_unit: "KM",
    g20_member: true,
    gec: "ID",
    geo: {
      latitude: -0.789275,
      longitude: 113.921327,
      max_latitude: 6.216999899999999,
      max_longitude: 141.0425,
      min_latitude: -11.1082999,
      min_longitude: 94.7351,
      bounds: {
        northeast: {
          lat: 6.216999899999999,
          lng: 141.0425,
        },
        southwest: {
          lat: -11.1082999,
          lng: 94.7351,
        },
      },
    },
    international_prefix: "001",
    ioc: "INA",
    iso_long_name: "The Republic of Indonesia",
    iso_short_name: "Indonesia",
    languages_official: ["id"],
    languages_spoken: ["id"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9, 10, 11],
    national_prefix: "0",
    nationality: "Indonesian",
    number: "360",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "South-Eastern Asia",
    un_locode: "ID",
    un_member: true,
    unofficial_names: [
      "Indonesia",
      "Indonesien",
      "Indonésie",
      "インドネシア",
      "Indonesië",
    ],
    vehicle_registration_code: "RI",
    world_region: "APAC",
  },
  IE: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}} {{region_short}} {{postalcode}}\n{{country}}",
    alpha2: "IE",
    alpha3: "IRL",
    continent: "Europe",
    country_code: "353",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "EI",
    geo: {
      latitude: 53.1423672,
      longitude: -7.692053599999999,
      max_latitude: 55.38294149999999,
      max_longitude: -5.431909999999999,
      min_latitude: 51.4475448,
      min_longitude: -10.4800237,
      bounds: {
        northeast: {
          lat: 55.38294149999999,
          lng: -5.431909999999999,
        },
        southwest: {
          lat: 51.4475448,
          lng: -10.4800237,
        },
      },
    },
    international_prefix: "00",
    ioc: "IRL",
    iso_long_name: "Ireland",
    iso_short_name: "Ireland",
    languages_official: ["en", "ga"],
    languages_spoken: ["en", "ga"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Irish",
    number: "372",
    postal_code: true,
    postal_code_format: "[\\dA-Z]{3} ?[\\dA-Z]{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "IE",
    un_member: true,
    unofficial_names: [
      "Ireland",
      "Irland",
      "Irlande",
      "Irlanda",
      "アイルランド",
      "Ierland",
    ],
    vat_rates: {
      standard: 23,
      reduced: [9, 13.5],
      super_reduced: 4.8,
      parking: 13.5,
    },
    vehicle_registration_code: "IRL",
    world_region: "EMEA",
  },
  IL: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "IL",
    alpha3: "ISR",
    continent: "Asia",
    country_code: "972",
    currency_code: "ILS",
    distance_unit: "KM",
    gec: "IS",
    geo: {
      latitude: 31.046051,
      longitude: 34.851612,
      max_latitude: 33.33280500000001,
      max_longitude: 35.896244,
      min_latitude: 29.47969999999999,
      min_longitude: 34.2673871,
      bounds: {
        northeast: {
          lat: 33.33280500000001,
          lng: 35.896244,
        },
        southwest: {
          lat: 29.47969999999999,
          lng: 34.2673871,
        },
      },
    },
    international_prefix: "00",
    ioc: "ISR",
    iso_long_name: "The State of Israel",
    iso_short_name: "Israel",
    languages_official: ["he", "ar"],
    languages_spoken: ["he", "ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8, 9],
    national_prefix: "0",
    nationality: "Israeli",
    number: "376",
    postal_code: true,
    postal_code_format: "\\d{5}(?:\\d{2})?",
    region: "Asia",
    start_of_week: "sunday",
    subregion: "Western Asia",
    un_locode: "IL",
    un_member: true,
    unofficial_names: ["Israel", "Israël", "イスラエル"],
    vat_rates: {
      standard: 17,
      reduced: [],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "IL",
    world_region: "EMEA",
  },
  IM: {
    alpha2: "IM",
    alpha3: "IMN",
    continent: "Europe",
    country_code: "44",
    currency_code: "GBP",
    distance_unit: "KM",
    gec: "IM",
    geo: {
      latitude: 54.236107,
      longitude: -4.548056,
      max_latitude: 54.4369363,
      max_longitude: -4.270618199999999,
      min_latitude: 54.0186764,
      min_longitude: -4.8736609,
      bounds: {
        northeast: {
          lat: 54.4369363,
          lng: -4.270618199999999,
        },
        southwest: {
          lat: 54.0186764,
          lng: -4.8736609,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "The Isle of Man",
    iso_short_name: "Isle of Man",
    languages_official: ["en", "gv"],
    languages_spoken: ["en", "gv"],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "Manx",
    number: "833",
    postal_code: true,
    postal_code_format: "IM\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "IM",
    un_member: false,
    unofficial_names: [
      "Isle of Man",
      "Insel Man",
      "Île de Man",
      "Isla de Man",
      "マン島",
    ],
    vehicle_registration_code: "GBM",
    world_region: "EMEA",
  },
  IN: {
    address_format:
      "{{recipient}}\n{{street}}\n{{region}}\n{{city}} {{postalcode}}\n{{country}}",
    alpha2: "IN",
    alpha3: "IND",
    continent: "Asia",
    country_code: "91",
    currency_code: "INR",
    distance_unit: "KM",
    g20_member: true,
    gec: "IN",
    geo: {
      latitude: 20.593684,
      longitude: 78.96288,
      max_latitude: 35.513327,
      max_longitude: 97.39535869999999,
      min_latitude: 6.4626999,
      min_longitude: 68.1097,
      bounds: {
        northeast: {
          lat: 35.513327,
          lng: 97.39535869999999,
        },
        southwest: {
          lat: 6.4626999,
          lng: 68.1097,
        },
      },
    },
    international_prefix: "00",
    ioc: "IND",
    iso_long_name: "The Republic of India",
    iso_short_name: "India",
    languages_official: ["hi", "en"],
    languages_spoken: ["hi", "en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [10],
    national_prefix: "0",
    nationality: "Indian",
    number: "356",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Southern Asia",
    un_locode: "IN",
    un_member: true,
    unofficial_names: ["India", "Indien", "Inde", "インド"],
    vehicle_registration_code: "IND",
    world_region: "APAC",
  },
  IO: {
    alpha2: "IO",
    alpha3: "IOT",
    continent: "Asia",
    country_code: "246",
    currency_code: "USD",
    distance_unit: "KM",
    gec: "IO",
    geo: {
      latitude: -6.343194,
      longitude: 71.876519,
      max_latitude: -5.1401857,
      max_longitude: 72.5880433,
      min_latitude: -7.4891118,
      min_longitude: 71.1859131,
      bounds: {
        northeast: {
          lat: -5.1401857,
          lng: 72.5880433,
        },
        southwest: {
          lat: -7.4891118,
          lng: 71.1859131,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "The British Indian Ocean Territory",
    iso_short_name: "British Indian Ocean Territory",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "Indian",
    number: "086",
    postal_code: true,
    postal_code_format: "BBND 1ZZ",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "IO",
    un_member: false,
    unofficial_names: [
      "British Indian Ocean Territory",
      "Britisches Territorium im Indischen Ozean",
      "イギリス領インド洋地域",
      "Britse Gebieden in de Indische Oceaan",
    ],
    world_region: "APAC",
  },
  IQ: {
    alpha2: "IQ",
    alpha3: "IRQ",
    continent: "Asia",
    country_code: "964",
    currency_code: "IQD",
    distance_unit: "KM",
    gec: "IZ",
    geo: {
      latitude: 33.223191,
      longitude: 43.679291,
      max_latitude: 37.380645,
      max_longitude: 48.6350999,
      min_latitude: 29.0612079,
      min_longitude: 38.7936741,
      bounds: {
        northeast: {
          lat: 37.380645,
          lng: 48.6350999,
        },
        southwest: {
          lat: 29.0612079,
          lng: 38.7936741,
        },
      },
    },
    international_prefix: "00",
    ioc: "IRQ",
    iso_long_name: "The Republic of Iraq",
    iso_short_name: "Iraq",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9, 10],
    national_prefix: "None",
    nationality: "Iraqi",
    number: "368",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "sunday",
    subregion: "Western Asia",
    un_locode: "IQ",
    un_member: true,
    unofficial_names: ["Iraq", "العراق", "Irak", "イラク"],
    vehicle_registration_code: "IRQ",
    world_region: "EMEA",
  },
  IR: {
    alpha2: "IR",
    alpha3: "IRN",
    continent: "Asia",
    country_code: "98",
    currency_code: "IRR",
    distance_unit: "KM",
    gec: "IR",
    geo: {
      latitude: 32.427908,
      longitude: 53.688046,
      max_latitude: 39.782056,
      max_longitude: 63.3333366,
      min_latitude: 24.8066999,
      min_longitude: 44.0326949,
      bounds: {
        northeast: {
          lat: 39.782056,
          lng: 63.3333366,
        },
        southwest: {
          lat: 24.8066999,
          lng: 44.0326949,
        },
      },
    },
    international_prefix: "00",
    ioc: "IRI",
    iso_long_name: "The Islamic Republic of Iran",
    iso_short_name: "Iran (Islamic Republic of)",
    languages_official: ["fa"],
    languages_spoken: ["fa"],
    national_destination_code_lengths: [2],
    national_number_lengths: [10],
    national_prefix: "0",
    nationality: "Iranian",
    number: "364",
    postal_code: true,
    postal_code_format: "\\d{5}-?\\d{5}",
    region: "Asia",
    start_of_week: "saturday",
    subregion: "Southern Asia",
    un_locode: "IR",
    un_member: true,
    unofficial_names: [
      "Iran",
      "Irán",
      "Iran (Islamic Republic Of)",
      "イラン・イスラム共和国",
      "Islamic Republic of Iran",
    ],
    vehicle_registration_code: "IR",
    world_region: "EMEA",
  },
  IS: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "IS",
    alpha3: "ISL",
    continent: "Europe",
    country_code: "354",
    currency_code: "ISK",
    distance_unit: "KM",
    eea_member: true,
    gec: "IC",
    geo: {
      latitude: 64.963051,
      longitude: -19.020835,
      max_latitude: 67.2466,
      max_longitude: -12.2388001,
      min_latitude: 62.4819,
      min_longitude: -26.2572999,
      bounds: {
        northeast: {
          lat: 67.2466,
          lng: -12.2388001,
        },
        southwest: {
          lat: 62.4819,
          lng: -26.2572999,
        },
      },
    },
    international_prefix: "00",
    ioc: "ISL",
    iso_long_name: "Iceland",
    iso_short_name: "Iceland",
    languages_official: ["is"],
    languages_spoken: ["is"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8, 9],
    national_prefix: "0",
    nationality: "Icelander",
    number: "352",
    postal_code: true,
    postal_code_format: "\\d{3}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "IS",
    un_member: true,
    unofficial_names: [
      "Iceland",
      "Island",
      "Islande",
      "Islandia",
      "アイスランド",
      "IJsland",
    ],
    vat_rates: {
      standard: 24,
      reduced: [11],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "IS",
    world_region: "EMEA",
  },
  IT: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}} {{region_short}}\n{{country}}",
    alpha2: "IT",
    alpha3: "ITA",
    continent: "Europe",
    country_code: "39",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    g20_member: true,
    g7_member: true,
    gec: "IT",
    geo: {
      latitude: 41.87194,
      longitude: 12.56738,
      max_latitude: 47.092,
      max_longitude: 18.7975999,
      min_latitude: 35.4897,
      min_longitude: 6.6267201,
      bounds: {
        northeast: {
          lat: 47.092,
          lng: 18.7975999,
        },
        southwest: {
          lat: 35.4897,
          lng: 6.6267201,
        },
      },
    },
    international_prefix: "00",
    ioc: "ITA",
    iso_long_name: "The Italian Republic",
    iso_short_name: "Italy",
    languages_official: ["it"],
    languages_spoken: ["it"],
    national_destination_code_lengths: [3],
    national_number_lengths: [9, 11],
    national_prefix: "None",
    nationality: "Italian",
    number: "380",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "IT",
    un_member: true,
    unofficial_names: [
      "Italy",
      "Italien",
      "Italie",
      "Italia",
      "イタリア",
      "Italië",
    ],
    vat_rates: {
      standard: 22,
      reduced: [10],
      super_reduced: 4,
      parking: null,
    },
    vehicle_registration_code: "I",
    world_region: "EMEA",
  },
  JE: {
    alpha2: "JE",
    alpha3: "JEY",
    continent: "Europe",
    country_code: "44",
    currency_code: "GBP",
    distance_unit: "KM",
    gec: "JE",
    geo: {
      latitude: 49.214439,
      longitude: -2.13125,
      max_latitude: 49.26650009999999,
      max_longitude: -2.0013001,
      min_latitude: 49.1582,
      min_longitude: -2.2602001,
      bounds: {
        northeast: {
          lat: 49.26650009999999,
          lng: -2.0013001,
        },
        southwest: {
          lat: 49.1582,
          lng: -2.2602001,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "The Bailiwick of Jersey",
    iso_short_name: "Jersey",
    languages_official: ["en", "fr"],
    languages_spoken: ["en", "fr"],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "Channel Islander",
    number: "832",
    postal_code: true,
    postal_code_format: "JE\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "JE",
    un_member: false,
    unofficial_names: ["Jersey", "ジャージー"],
    vehicle_registration_code: "GBJ",
    world_region: "EMEA",
  },
  JM: {
    alpha2: "JM",
    alpha3: "JAM",
    continent: "North America",
    country_code: "1",
    currency_code: "JMD",
    distance_unit: "KM",
    gec: "JM",
    geo: {
      latitude: 18.109581,
      longitude: -77.297508,
      max_latitude: 18.5697821,
      max_longitude: -76.1448669,
      min_latitude: 17.6688854,
      min_longitude: -78.4073639,
      bounds: {
        northeast: {
          lat: 18.5697821,
          lng: -76.1448669,
        },
        southwest: {
          lat: 17.6688854,
          lng: -78.4073639,
        },
      },
    },
    international_prefix: "011",
    ioc: "JAM",
    iso_long_name: "Jamaica",
    iso_short_name: "Jamaica",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1876",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Jamaican",
    number: "388",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "JM",
    un_member: true,
    unofficial_names: ["Jamaica", "Jamaika", "Jamaïque", "ジャマイカ"],
    vehicle_registration_code: "JA",
    world_region: "AMER",
  },
  JO: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "JO",
    alpha3: "JOR",
    continent: "Asia",
    country_code: "962",
    currency_code: "JOD",
    distance_unit: "KM",
    gec: "JO",
    geo: {
      latitude: 30.585164,
      longitude: 36.238414,
      max_latitude: 33.374735,
      max_longitude: 39.301154,
      min_latitude: 29.1850361,
      min_longitude: 34.9441001,
      bounds: {
        northeast: {
          lat: 33.374735,
          lng: 39.301154,
        },
        southwest: {
          lat: 29.1850361,
          lng: 34.9441001,
        },
      },
    },
    international_prefix: "00",
    ioc: "JOR",
    iso_long_name: "The Hashemite Kingdom of Jordan",
    iso_short_name: "Jordan",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "Jordanian",
    number: "400",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "sunday",
    subregion: "Western Asia",
    un_locode: "JO",
    un_member: true,
    unofficial_names: [
      "Jordan",
      "الأردن",
      "Jordanien",
      "Jordanie",
      "Jordania",
      "ヨルダン",
      "Jordanië",
    ],
    vehicle_registration_code: "JOR",
    world_region: "EMEA",
  },
  JP: {
    address_format:
      "〒{{postalcode}}\n{{region_short}}{{city}}{{street}}\n{{recipient}}\n{{country}}",
    alpha2: "JP",
    alpha3: "JPN",
    continent: "Asia",
    country_code: "81",
    currency_code: "JPY",
    distance_unit: "KM",
    g20_member: true,
    g7_member: true,
    gec: "JA",
    geo: {
      latitude: 36.204824,
      longitude: 138.252924,
      max_latitude: 45.6412626,
      max_longitude: 154.0031455,
      min_latitude: 20.3585295,
      min_longitude: 122.8554688,
      bounds: {
        northeast: {
          lat: 45.6412626,
          lng: 154.0031455,
        },
        southwest: {
          lat: 20.3585295,
          lng: 122.8554688,
        },
      },
    },
    international_prefix: "010",
    ioc: "JPN",
    iso_long_name: "Japan",
    iso_short_name: "Japan",
    languages_official: ["ja"],
    languages_spoken: ["ja"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9, 10],
    national_prefix: "0",
    nationality: "Japanese",
    number: "392",
    postal_code: true,
    postal_code_format: "\\d{3}-?\\d{4}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Eastern Asia",
    un_locode: "JP",
    un_member: true,
    unofficial_names: ["Japan", "Japon", "Japón", "日本"],
    vehicle_registration_code: "J",
    world_region: "APAC",
  },
  KE: {
    alpha2: "KE",
    alpha3: "KEN",
    continent: "Africa",
    country_code: "254",
    currency_code: "KES",
    distance_unit: "KM",
    gec: "KE",
    geo: {
      latitude: -0.023559,
      longitude: 37.906193,
      max_latitude: 5.033420899999999,
      max_longitude: 41.9069449,
      min_latitude: -4.724299999999999,
      min_longitude: 33.90982109999999,
      bounds: {
        northeast: {
          lat: 5.033420899999999,
          lng: 41.9069449,
        },
        southwest: {
          lat: -4.724299999999999,
          lng: 33.90982109999999,
        },
      },
    },
    international_prefix: "000",
    ioc: "KEN",
    iso_long_name: "The Republic of Kenya",
    iso_short_name: "Kenya",
    languages_official: ["en", "sw"],
    languages_spoken: ["en", "sw"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Kenyan",
    number: "404",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "KE",
    un_member: true,
    unofficial_names: ["Kenya", "Kenia", "ケニア"],
    vehicle_registration_code: "EAK",
    world_region: "EMEA",
  },
  KG: {
    alpha2: "KG",
    alpha3: "KGZ",
    continent: "Asia",
    country_code: "996",
    currency_code: "KGS",
    distance_unit: "KM",
    gec: "KG",
    geo: {
      latitude: 41.20438,
      longitude: 74.766098,
      max_latitude: 43.2653569,
      max_longitude: 80.2281514,
      min_latitude: 39.180254,
      min_longitude: 69.250998,
      bounds: {
        northeast: {
          lat: 43.2653569,
          lng: 80.2281514,
        },
        southwest: {
          lat: 39.180254,
          lng: 69.250998,
        },
      },
    },
    international_prefix: "00",
    ioc: "KGZ",
    iso_long_name: "The Kyrgyz Republic",
    iso_short_name: "Kyrgyzstan",
    languages_official: ["ky", "ru"],
    languages_spoken: ["ky", "ru"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Kirghiz",
    number: "417",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Central Asia",
    un_locode: "KG",
    un_member: true,
    unofficial_names: [
      "Kyrgyzstan",
      "Kirgisistan",
      "Kirghizistan",
      "Kirguizistán",
      "キルギス",
      "Kirgizië",
      "Kyrgzstan",
    ],
    vehicle_registration_code: "KG",
    world_region: "EMEA",
  },
  KH: {
    alpha2: "KH",
    alpha3: "KHM",
    continent: "Asia",
    country_code: "855",
    currency_code: "KHR",
    distance_unit: "KM",
    gec: "CB",
    geo: {
      latitude: 12.565679,
      longitude: 104.990963,
      max_latitude: 14.6901791,
      max_longitude: 107.627687,
      min_latitude: 9.6007,
      min_longitude: 102.333542,
      bounds: {
        northeast: {
          lat: 14.6901791,
          lng: 107.627687,
        },
        southwest: {
          lat: 9.6007,
          lng: 102.333542,
        },
      },
    },
    international_prefix: "00",
    ioc: "CAM",
    iso_long_name: "The Kingdom of Cambodia",
    iso_short_name: "Cambodia",
    languages_official: ["km"],
    languages_spoken: ["km"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Cambodian",
    number: "116",
    postal_code: true,
    postal_code_format: "\\d{5,6}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "South-Eastern Asia",
    un_locode: "KH",
    un_member: true,
    unofficial_names: [
      "Cambodia",
      "Kambodscha",
      "Cambodge",
      "Camboya",
      "カンボジア",
      "Cambodja",
    ],
    vehicle_registration_code: "K",
    world_region: "APAC",
  },
  KI: {
    alpha2: "KI",
    alpha3: "KIR",
    continent: "Australia",
    country_code: "686",
    currency_code: "AUD",
    distance_unit: "KM",
    gec: "KR",
    geo: {
      latitude: -3.370417,
      longitude: -168.734039,
      max_latitude: 5.4082108,
      max_longitude: -145.1513674,
      min_latitude: -13.0502263,
      min_longitude: 168.8818359,
      bounds: {
        northeast: {
          lat: 5.4082108,
          lng: -145.1513674,
        },
        southwest: {
          lat: -13.0502263,
          lng: 168.8818359,
        },
      },
    },
    international_prefix: "00",
    ioc: "KIR",
    iso_long_name: "The Republic of Kiribati",
    iso_short_name: "Kiribati",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [5],
    national_prefix: "None",
    nationality: "I-Kiribati",
    number: "296",
    postal_code: false,
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Micronesia",
    un_locode: "KI",
    un_member: true,
    unofficial_names: ["Kiribati", "キリバス"],
    vehicle_registration_code: "KIR",
    world_region: "APAC",
  },
  KM: {
    alpha2: "KM",
    alpha3: "COM",
    continent: "Africa",
    country_code: "269",
    currency_code: "KMF",
    distance_unit: "KM",
    gec: "CN",
    geo: {
      latitude: -11.6455,
      longitude: 43.3333,
      max_latitude: -11.3373321,
      max_longitude: 44.5646666,
      min_latitude: -12.4687602,
      min_longitude: 43.1968689,
      bounds: {
        northeast: {
          lat: -11.3373321,
          lng: 44.5646666,
        },
        southwest: {
          lat: -12.4687602,
          lng: 43.1968689,
        },
      },
    },
    international_prefix: "00",
    ioc: "COM",
    iso_long_name: "The Union of the Comoros",
    iso_short_name: "Comoros",
    languages_official: ["ar", "fr"],
    languages_spoken: ["ar", "fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Comoran",
    number: "174",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "KM",
    un_member: true,
    unofficial_names: [
      "Comoros",
      "Union der Komoren",
      "Comores",
      "コモロ",
      "Comoren",
    ],
    vehicle_registration_code: "COM",
    world_region: "EMEA",
  },
  KN: {
    alpha2: "KN",
    alpha3: "KNA",
    continent: "North America",
    country_code: "1",
    currency_code: "XCD",
    distance_unit: "MI",
    gec: "SC",
    geo: {
      latitude: 17.357822,
      longitude: -62.782998,
      max_latitude: 17.4205891,
      max_longitude: -62.52369989999999,
      min_latitude: 17.07861,
      min_longitude: -62.86949999999999,
      bounds: {
        northeast: {
          lat: 17.4205891,
          lng: -62.52369989999999,
        },
        southwest: {
          lat: 17.07861,
          lng: -62.86949999999999,
        },
      },
    },
    international_prefix: "011",
    ioc: "SKN",
    iso_long_name: "Saint Kitts and Nevis",
    iso_short_name: "Saint Kitts and Nevis",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1869",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Kittian and Nevisian",
    number: "659",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "KN",
    un_member: true,
    unofficial_names: [
      "Saint Kitts and Nevis",
      "Föderation St. Kitts und Nevis",
      "Saint Kitts et Nevis",
      "Saint Kitts y Nevis",
      "セントクリストファー・ネイビス",
      "Saint Kitts en Nevis",
      "St. Kitts and Nevis",
      "St Kitts and Nevis",
    ],
    vehicle_registration_code: "KAN",
    world_region: "AMER",
  },
  KP: {
    alpha2: "KP",
    alpha3: "PRK",
    continent: "Asia",
    country_code: "850",
    currency_code: "KPW",
    distance_unit: "KM",
    gec: "KN",
    geo: {
      latitude: 40.339852,
      longitude: 127.510093,
      max_latitude: 43.01159,
      max_longitude: 130.6990167,
      min_latitude: 37.5892001,
      min_longitude: 124.1491605,
      bounds: {
        northeast: {
          lat: 43.01159,
          lng: 130.6990167,
        },
        southwest: {
          lat: 37.5892001,
          lng: 124.1491605,
        },
      },
    },
    international_prefix: "00",
    ioc: "PRK",
    iso_long_name: "The Democratic People's Republic of Korea",
    iso_short_name: "Korea (Democratic People's Republic of)",
    languages_official: ["ko"],
    languages_spoken: ["ko"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "North Korean",
    number: "408",
    postal_code: false,
    region: "Asia",
    start_of_week: "monday",
    subregion: "Eastern Asia",
    un_locode: "KP",
    un_member: true,
    unofficial_names: [
      "Korea (North)",
      "North Korea",
      "Nordkorea",
      "Corée du Nord",
      "Corea del Norte",
      "朝鮮民主主義人民共和国",
      "Noord-Korea",
      "Korea Democratic People's Republic",
      "Korea (Democratic People s Republic of)",
    ],
    vehicle_registration_code: "KP",
    world_region: "APAC",
  },
  KR: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}} {{region_short}}\n{{postalcode}}\n{{country}}",
    alpha2: "KR",
    alpha3: "KOR",
    continent: "Asia",
    country_code: "82",
    currency_code: "KRW",
    distance_unit: "KM",
    g20_member: true,
    gec: "KS",
    geo: {
      latitude: 35.907757,
      longitude: 127.766922,
      max_latitude: 38.63400000000001,
      max_longitude: 131.1603,
      min_latitude: 33.0041,
      min_longitude: 124.5863,
      bounds: {
        northeast: {
          lat: 38.63400000000001,
          lng: 131.1603,
        },
        southwest: {
          lat: 33.0041,
          lng: 124.5863,
        },
      },
    },
    international_prefix: "001",
    ioc: "KOR",
    iso_long_name: "The Republic of Korea",
    iso_short_name: "Korea (Republic of)",
    languages_official: ["ko"],
    languages_spoken: ["ko"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "South Korean",
    number: "410",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Eastern Asia",
    un_locode: "KR",
    un_member: true,
    unofficial_names: [
      "South Korea",
      "Korea (South)",
      "Südkorea",
      "Corée du Sud",
      "Corea del Sur",
      "大韓民国",
      "Zuid-Korea",
      "Korea (Republic of)",
    ],
    vehicle_registration_code: "ROK",
    world_region: "APAC",
  },
  KW: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{region}}\n{{country}}",
    alpha2: "KW",
    alpha3: "KWT",
    continent: "Asia",
    country_code: "965",
    currency_code: "KWD",
    distance_unit: "KM",
    gec: "KU",
    geo: {
      latitude: 29.31166,
      longitude: 47.481766,
      max_latitude: 30.1036993,
      max_longitude: 48.5184,
      min_latitude: 28.5244463,
      min_longitude: 46.55303989999999,
      bounds: {
        northeast: {
          lat: 30.1036993,
          lng: 48.5184,
        },
        southwest: {
          lat: 28.5244463,
          lng: 46.55303989999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "KUW",
    iso_long_name: "The State of Kuwait",
    iso_short_name: "Kuwait",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Kuwaiti",
    number: "414",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "sunday",
    subregion: "Western Asia",
    un_locode: "KW",
    un_member: true,
    unofficial_names: ["Kuwait", "الكويت", "Koweït", "クウェート", "Koeweit"],
    vehicle_registration_code: "KWT",
    world_region: "EMEA",
  },
  KY: {
    alpha2: "KY",
    alpha3: "CYM",
    continent: "North America",
    country_code: "1",
    currency_code: "KYD",
    distance_unit: "MI",
    gec: "CJ",
    geo: {
      latitude: 19.3133,
      longitude: -81.2546,
      max_latitude: 19.7616,
      max_longitude: -79.7191,
      min_latitude: 19.2538999,
      min_longitude: -81.42940010000001,
      bounds: {
        northeast: {
          lat: 19.7616,
          lng: -79.7191,
        },
        southwest: {
          lat: 19.2538999,
          lng: -81.42940010000001,
        },
      },
    },
    international_prefix: "011",
    ioc: "CAY",
    iso_long_name: "The Cayman Islands",
    iso_short_name: "Cayman Islands",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1345",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Caymanian",
    number: "136",
    postal_code: true,
    postal_code_format: "KY\\d-\\d{4}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "KY",
    un_member: false,
    unofficial_names: [
      "Cayman Islands",
      "Kaimaninseln",
      "Îles Caïmans",
      "Islas Caimán",
      "ケイマン諸島",
      "Caymaneilanden",
    ],
    world_region: "AMER",
  },
  KZ: {
    alpha2: "KZ",
    alpha3: "KAZ",
    continent: "Asia",
    country_code: "7",
    currency_code: "KZT",
    distance_unit: "KM",
    gec: "KZ",
    geo: {
      latitude: 48.019573,
      longitude: 66.923684,
      max_latitude: 55.4419839,
      max_longitude: 87.315415,
      min_latitude: 40.5685841,
      min_longitude: 46.493672,
      bounds: {
        northeast: {
          lat: 55.4419839,
          lng: 87.315415,
        },
        southwest: {
          lat: 40.5685841,
          lng: 46.493672,
        },
      },
    },
    international_prefix: "810",
    ioc: "KAZ",
    iso_long_name: "The Republic of Kazakhstan",
    iso_short_name: "Kazakhstan",
    languages_official: ["kk", "ru"],
    languages_spoken: ["kk", "ru"],
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "8",
    nationality: "Kazakhstani",
    number: "398",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Central Asia",
    un_locode: "KZ",
    un_member: true,
    unofficial_names: [
      "Kazakhstan",
      "Kasachstan",
      "Kazajistán",
      "カザフスタン",
      "Kazachstan",
    ],
    vehicle_registration_code: "KZ",
    world_region: "EMEA",
  },
  LA: {
    alpha2: "LA",
    alpha3: "LAO",
    continent: "Asia",
    country_code: "856",
    currency_code: "LAK",
    distance_unit: "KM",
    gec: "LA",
    geo: {
      latitude: 19.85627,
      longitude: 102.495496,
      max_latitude: 22.5090449,
      max_longitude: 107.635094,
      min_latitude: 13.9097198,
      min_longitude: 100.0832139,
      bounds: {
        northeast: {
          lat: 22.5090449,
          lng: 107.635094,
        },
        southwest: {
          lat: 13.9097198,
          lng: 100.0832139,
        },
      },
    },
    international_prefix: "00",
    ioc: "LAO",
    iso_long_name: "The Lao People's Democratic Republic",
    iso_short_name: "Lao People's Democratic Republic",
    languages_official: ["lo"],
    languages_spoken: ["lo"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Laotian",
    number: "418",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "South-Eastern Asia",
    un_locode: "LA",
    un_member: true,
    unofficial_names: [
      "Laos",
      "ラオス人民民主共和国",
      "Lao People s Democratic Republic",
    ],
    vehicle_registration_code: "LAO",
    world_region: "APAC",
  },
  LB: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "LB",
    alpha3: "LBN",
    continent: "Asia",
    country_code: "961",
    currency_code: "LBP",
    distance_unit: "KM",
    gec: "LE",
    geo: {
      latitude: 33.854721,
      longitude: 35.862285,
      max_latitude: 34.69209,
      max_longitude: 36.62372,
      min_latitude: 33.0550256,
      min_longitude: 35.0711001,
      bounds: {
        northeast: {
          lat: 34.69209,
          lng: 36.62372,
        },
        southwest: {
          lat: 33.0550256,
          lng: 35.0711001,
        },
      },
    },
    international_prefix: "00",
    ioc: "LBN",
    iso_long_name: "The Lebanese Republic",
    iso_short_name: "Lebanon",
    languages_official: ["ar", "fr"],
    languages_spoken: ["ar", "fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Lebanese",
    number: "422",
    postal_code: true,
    postal_code_format: "(?:\\d{4})(?: ?(?:\\d{4}))?",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Western Asia",
    un_locode: "LB",
    un_member: true,
    unofficial_names: [
      "Lebanon",
      "لبنان",
      "Libanon",
      "Liban",
      "Líbano",
      "レバノン",
    ],
    vehicle_registration_code: "RL",
    world_region: "EMEA",
  },
  LC: {
    alpha2: "LC",
    alpha3: "LCA",
    continent: "North America",
    country_code: "1",
    currency_code: "XCD",
    distance_unit: "MI",
    gec: "ST",
    geo: {
      latitude: 13.909444,
      longitude: -60.978893,
      max_latitude: 14.1209277,
      max_longitude: -60.85979460000001,
      min_latitude: 13.7047779,
      min_longitude: -61.0812378,
      bounds: {
        northeast: {
          lat: 14.1209277,
          lng: -60.85979460000001,
        },
        southwest: {
          lat: 13.7047779,
          lng: -61.0812378,
        },
      },
    },
    international_prefix: "011",
    ioc: "LCA",
    iso_long_name: "Saint Lucia",
    iso_short_name: "Saint Lucia",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1758",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Saint Lucian",
    number: "662",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "LC",
    un_member: true,
    unofficial_names: [
      "Saint Lucia",
      "Saint-Lucie",
      "Santa Lucía",
      "セントルシア",
      "St. Lucia",
      "St Lucia",
    ],
    vehicle_registration_code: "WL",
    world_region: "AMER",
  },
  LI: {
    alpha2: "LI",
    alpha3: "LIE",
    continent: "Europe",
    country_code: "423",
    currency_code: "CHF",
    distance_unit: "KM",
    eea_member: true,
    esm_member: true,
    euvat_member: false,
    gec: "LS",
    geo: {
      latitude: 47.166,
      longitude: 9.555373,
      max_latitude: 47.2705467,
      max_longitude: 9.6356501,
      min_latitude: 47.04828999999999,
      min_longitude: 9.47162,
      bounds: {
        northeast: {
          lat: 47.2705467,
          lng: 9.6356501,
        },
        southwest: {
          lat: 47.04828999999999,
          lng: 9.47162,
        },
      },
    },
    international_prefix: "00",
    ioc: "LIE",
    iso_long_name: "The Principality of Liechtenstein",
    iso_short_name: "Liechtenstein",
    languages_official: ["de"],
    languages_spoken: ["de"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Liechtensteiner",
    number: "438",
    postal_code: true,
    postal_code_format: "948[5-9]|949[0-8]",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Western Europe",
    un_locode: "LI",
    un_member: true,
    unofficial_names: ["Liechtenstein", "リヒテンシュタイン"],
    vehicle_registration_code: "FL",
    world_region: "EMEA",
  },
  LK: {
    alpha2: "LK",
    alpha3: "LKA",
    continent: "Asia",
    country_code: "94",
    currency_code: "LKR",
    distance_unit: "KM",
    gec: "CE",
    geo: {
      latitude: 7.873053999999999,
      longitude: 80.77179699999999,
      max_latitude: 10.03377,
      max_longitude: 82.14479999999999,
      min_latitude: 5.6816,
      min_longitude: 79.26769999999999,
      bounds: {
        northeast: {
          lat: 10.03377,
          lng: 82.14479999999999,
        },
        southwest: {
          lat: 5.6816,
          lng: 79.26769999999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "SRI",
    iso_long_name: "The Democratic Socialist Republic of Sri Lanka",
    iso_short_name: "Sri Lanka",
    languages_official: ["si", "ta"],
    languages_spoken: ["si", "ta"],
    national_destination_code_lengths: [2],
    national_number_lengths: [10],
    national_prefix: "0",
    nationality: "Sri Lankan",
    number: "144",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Southern Asia",
    un_locode: "LK",
    un_member: true,
    unofficial_names: ["Sri Lanka", "スリランカ"],
    vehicle_registration_code: "CL",
    world_region: "APAC",
  },
  LR: {
    alpha2: "LR",
    alpha3: "LBR",
    continent: "Africa",
    country_code: "231",
    currency_code: "LRD",
    distance_unit: "MI",
    gec: "LI",
    geo: {
      latitude: 6.428055,
      longitude: -9.429499000000002,
      max_latitude: 8.551986,
      max_longitude: -7.3692549,
      min_latitude: 4.269699999999999,
      min_longitude: -11.5355999,
      bounds: {
        northeast: {
          lat: 8.551986,
          lng: -7.3692549,
        },
        southwest: {
          lat: 4.269699999999999,
          lng: -11.5355999,
        },
      },
    },
    international_prefix: "00",
    ioc: "LBR",
    iso_long_name: "The Republic of Liberia",
    iso_short_name: "Liberia",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6, 7, 8],
    national_prefix: "22",
    nationality: "Liberian",
    number: "430",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "LR",
    un_member: true,
    unofficial_names: ["Liberia", "リベリア"],
    vehicle_registration_code: "LB",
    world_region: "EMEA",
  },
  LS: {
    alpha2: "LS",
    alpha3: "LSO",
    alt_currency: "ZAR",
    continent: "Africa",
    country_code: "266",
    currency_code: "LSL",
    distance_unit: "KM",
    gec: "LT",
    geo: {
      latitude: -29.609988,
      longitude: 28.233608,
      max_latitude: -28.5708011,
      max_longitude: 29.4557087,
      min_latitude: -30.6755788,
      min_longitude: 27.011231,
      bounds: {
        northeast: {
          lat: -28.5708011,
          lng: 29.4557087,
        },
        southwest: {
          lat: -30.6755788,
          lng: 27.011231,
        },
      },
    },
    international_prefix: "00",
    ioc: "LES",
    iso_long_name: "The Kingdom of Lesotho",
    iso_short_name: "Lesotho",
    languages_official: ["en", "st"],
    languages_spoken: ["en", "st"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Mosotho",
    number: "426",
    postal_code: true,
    postal_code_format: "\\d{3}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Southern Africa",
    un_locode: "LS",
    un_member: true,
    unofficial_names: ["Lesotho", "レソト"],
    vehicle_registration_code: "LS",
    world_region: "EMEA",
  },
  LT: {
    alpha2: "LT",
    alpha3: "LTU",
    continent: "Europe",
    country_code: "370",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "LH",
    geo: {
      latitude: 55.169438,
      longitude: 23.881275,
      max_latitude: 56.45032089999999,
      max_longitude: 26.835523,
      min_latitude: 53.8967949,
      min_longitude: 20.931,
      bounds: {
        northeast: {
          lat: 56.45032089999999,
          lng: 26.835523,
        },
        southwest: {
          lat: 53.8967949,
          lng: 20.931,
        },
      },
    },
    international_prefix: "00",
    ioc: "LTU",
    iso_long_name: "The Republic of Lithuania",
    iso_short_name: "Lithuania",
    languages_official: ["lt"],
    languages_spoken: ["lt"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "8",
    nationality: "Lithuanian",
    number: "440",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "LT",
    un_member: true,
    unofficial_names: [
      "Lithuania",
      "Litauen",
      "Lituanie",
      "Lituania",
      "リトアニア",
      "Litouwen",
      "Літва",
      "Lietuva",
    ],
    vat_rates: {
      standard: 21,
      reduced: [5, 9],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "LT",
    world_region: "EMEA",
  },
  LU: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "LU",
    alpha3: "LUX",
    continent: "Europe",
    country_code: "352",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "LU",
    geo: {
      latitude: 49.815273,
      longitude: 6.129582999999999,
      max_latitude: 50.18282,
      max_longitude: 6.530970099999999,
      min_latitude: 49.447779,
      min_longitude: 5.7356699,
      bounds: {
        northeast: {
          lat: 50.18282,
          lng: 6.530970099999999,
        },
        southwest: {
          lat: 49.447779,
          lng: 5.7356699,
        },
      },
    },
    international_prefix: "00",
    ioc: "LUX",
    iso_long_name: "The Grand Duchy of Luxembourg",
    iso_short_name: "Luxembourg",
    languages_official: ["fr", "de", "lb"],
    languages_spoken: ["fr", "de", "lb"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "None",
    nationality: "Luxembourger",
    number: "442",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Western Europe",
    un_locode: "LU",
    un_member: true,
    unofficial_names: [
      "Luxembourg",
      "Luxemburg",
      "Luxemburgo",
      "ルクセンブルク",
    ],
    vat_rates: {
      standard: 17,
      reduced: [8, 14],
      super_reduced: 3,
      parking: 12,
    },
    vehicle_registration_code: "L",
    world_region: "EMEA",
  },
  LV: {
    address_format:
      "{{recipient}}\n{{street}}\n{{region}}\n{{city}} {{postalcode}}\n{{country}}",
    alpha2: "LV",
    alpha3: "LVA",
    continent: "Europe",
    country_code: "371",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "LG",
    geo: {
      latitude: 56.879635,
      longitude: 24.603189,
      max_latitude: 58.0855688,
      max_longitude: 28.2414029,
      min_latitude: 55.6747769,
      min_longitude: 20.8465999,
      bounds: {
        northeast: {
          lat: 58.0855688,
          lng: 28.2414029,
        },
        southwest: {
          lat: 55.6747769,
          lng: 20.8465999,
        },
      },
    },
    international_prefix: "00",
    ioc: "LAT",
    iso_long_name: "The Republic of Latvia",
    iso_short_name: "Latvia",
    languages_official: ["lv"],
    languages_spoken: ["lv"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "8",
    nationality: "Latvian",
    number: "428",
    postal_code: true,
    postal_code_format: "LV-\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "LV",
    un_member: true,
    unofficial_names: [
      "Latvia",
      "Lettland",
      "Lettonie",
      "Letonia",
      "ラトビア",
      "Letland",
    ],
    vat_rates: {
      standard: 21,
      reduced: [12],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "LV",
    world_region: "EMEA",
  },
  LY: {
    alpha2: "LY",
    alpha3: "LBY",
    continent: "Africa",
    country_code: "218",
    currency_code: "LYD",
    distance_unit: "KM",
    gec: "LY",
    geo: {
      latitude: 26.3351,
      longitude: 17.228331,
      max_latitude: 33.2203,
      max_longitude: 25.2686,
      min_latitude: 19.5,
      min_longitude: 9.391466,
      bounds: {
        northeast: {
          lat: 33.2203,
          lng: 25.2686,
        },
        southwest: {
          lat: 19.5,
          lng: 9.391466,
        },
      },
    },
    international_prefix: "00",
    ioc: "LBA",
    iso_long_name: "The State of Libya",
    iso_short_name: "Libya",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "Libyan",
    number: "434",
    postal_code: false,
    region: "Africa",
    start_of_week: "sunday",
    subregion: "Northern Africa",
    un_locode: "LY",
    un_member: true,
    unofficial_names: [
      "Libya",
      "ليبيا",
      "Libyen",
      "Libye",
      "Libia",
      "リビア",
      "Libië",
      "Libyan Arab Jamahiriya",
    ],
    vehicle_registration_code: "LAR",
    world_region: "EMEA",
  },
  MA: {
    alpha2: "MA",
    alpha3: "MAR",
    continent: "Africa",
    country_code: "212",
    currency_code: "MAD",
    distance_unit: "KM",
    gec: "MO",
    geo: {
      latitude: 31.791702,
      longitude: -7.092619999999999,
      max_latitude: 35.9344,
      max_longitude: -0.9969759,
      min_latitude: 27.6672693,
      min_longitude: -13.3044001,
      bounds: {
        northeast: {
          lat: 35.9344,
          lng: -0.9969759,
        },
        southwest: {
          lat: 27.6672693,
          lng: -13.3044001,
        },
      },
    },
    international_prefix: "00",
    ioc: "MAR",
    iso_long_name: "The Kingdom of Morocco",
    iso_short_name: "Morocco",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Moroccan",
    number: "504",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Northern Africa",
    un_locode: "MA",
    un_member: true,
    unofficial_names: [
      "Morocco",
      "المغرب",
      "Marokko",
      "Maroc",
      "Marruecos",
      "モロッコ",
    ],
    vehicle_registration_code: "MA",
    world_region: "EMEA",
  },
  MC: {
    alpha2: "MC",
    alpha3: "MCO",
    continent: "Europe",
    country_code: "377",
    currency_code: "EUR",
    distance_unit: "KM",
    eu_member: false,
    euvat_member: true,
    gec: "MN",
    geo: {
      latitude: 43.73841760000001,
      longitude: 7.424615799999999,
      max_latitude: 43.7519029,
      max_longitude: 7.4426,
      min_latitude: 43.7237999,
      min_longitude: 7.4091049,
      bounds: {
        northeast: {
          lat: 43.7519029,
          lng: 7.4426,
        },
        southwest: {
          lat: 43.7237999,
          lng: 7.4091049,
        },
      },
    },
    international_prefix: "00",
    ioc: "MON",
    iso_long_name: "The Principality of Monaco",
    iso_short_name: "Monaco",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "Monegasque",
    number: "492",
    postal_code: true,
    postal_code_format: "980\\d{2}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Western Europe",
    un_locode: "MC",
    un_member: true,
    unofficial_names: ["Monaco", "Mónaco", "モナコ"],
    vehicle_registration_code: "MC",
    world_region: "EMEA",
  },
  MD: {
    alpha2: "MD",
    alpha3: "MDA",
    continent: "Europe",
    country_code: "373",
    currency_code: "MDL",
    distance_unit: "KM",
    gec: "MD",
    geo: {
      latitude: 47.411631,
      longitude: 28.369885,
      max_latitude: 48.492029,
      max_longitude: 30.1635898,
      min_latitude: 45.4674379,
      min_longitude: 26.6164248,
      bounds: {
        northeast: {
          lat: 48.492029,
          lng: 30.1635898,
        },
        southwest: {
          lat: 45.4674379,
          lng: 26.6164248,
        },
      },
    },
    international_prefix: "00",
    ioc: "MDA",
    iso_long_name: "The Republic of Moldova",
    iso_short_name: "Moldova (Republic of)",
    languages_official: ["ro"],
    languages_spoken: ["ro"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Moldovan",
    number: "498",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Eastern Europe",
    un_locode: "MD",
    un_member: true,
    unofficial_names: [
      "Moldova",
      "Moldawien",
      "Moldavie",
      "Moldavia",
      "the Republic of Moldova",
      "モルドバ共和国",
      "Moldavië",
    ],
    vehicle_registration_code: "MD",
    world_region: "EMEA",
  },
  ME: {
    alpha2: "ME",
    alpha3: "MNE",
    continent: "Europe",
    country_code: "382",
    currency_code: "EUR",
    distance_unit: "KM",
    gec: "MJ",
    geo: {
      latitude: 42.708678,
      longitude: 19.37439,
      max_latitude: 43.558743,
      max_longitude: 20.352926,
      min_latitude: 41.8297,
      min_longitude: 18.4337921,
      bounds: {
        northeast: {
          lat: 43.558743,
          lng: 20.352926,
        },
        southwest: {
          lat: 41.8297,
          lng: 18.4337921,
        },
      },
    },
    international_prefix: "99",
    ioc: "MNE",
    iso_long_name: "Montenegro",
    iso_short_name: "Montenegro",
    languages_official: ["sr", "bs", "sq", "hr"],
    languages_spoken: ["sr", "bs", "sq", "hr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Montenegrin",
    number: "499",
    postal_code: true,
    postal_code_format: "8\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "ME",
    un_member: true,
    unofficial_names: ["Crna Gora", "Montenegro", "モンテネグロ"],
    vehicle_registration_code: "MNE",
    world_region: "EMEA",
  },
  MF: {
    alpha2: "MF",
    alpha3: "MAF",
    continent: "North America",
    country_code: "590",
    currency_code: "EUR",
    distance_unit: "KM",
    eu_member: true,
    euvat_member: false,
    gec: "RN",
    geo: {
      latitude: 18.08255,
      longitude: -63.05225100000001,
      max_latitude: 18.1356001,
      max_longitude: -62.9613001,
      min_latitude: 18.0462883,
      min_longitude: -63.1630001,
      bounds: {
        northeast: {
          lat: 18.1356001,
          lng: -62.9613001,
        },
        southwest: {
          lat: 18.0462883,
          lng: -63.1630001,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "The Collectivity of Saint-Martin",
    iso_short_name: "Saint Martin (French part)",
    languages_official: ["en", "fr", "nl"],
    languages_spoken: ["en", "fr", "nl"],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "French",
    number: "663",
    postal_code: true,
    postal_code_format: "9[78][01]\\d{2}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "MF",
    un_member: false,
    unofficial_names: [
      "Saint Martin",
      "サン・マルタン（フランス領）",
      "Saint-Martin",
    ],
    world_region: "AMER",
  },
  MG: {
    alpha2: "MG",
    alpha3: "MDG",
    continent: "Africa",
    country_code: "261",
    currency_code: "MGA",
    distance_unit: "KM",
    gec: "MA",
    geo: {
      latitude: -18.766947,
      longitude: 46.869107,
      max_latitude: -11.4369999,
      max_longitude: 50.9985001,
      min_latitude: -26.2146,
      min_longitude: 42.7368,
      bounds: {
        northeast: {
          lat: -11.4369999,
          lng: 50.9985001,
        },
        southwest: {
          lat: -26.2146,
          lng: 42.7368,
        },
      },
    },
    international_prefix: "00",
    ioc: "MAD",
    iso_long_name: "The Republic of Madagascar",
    iso_short_name: "Madagascar",
    languages_official: ["fr", "mg"],
    languages_spoken: ["fr", "mg"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "None",
    nationality: "Malagasy",
    number: "450",
    postal_code: true,
    postal_code_format: "\\d{3}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "MG",
    un_member: true,
    unofficial_names: [
      "Madagascar",
      "Madagaskar",
      "the Republic of Madagascar",
      "マダガスカル",
    ],
    vehicle_registration_code: "RM",
    world_region: "EMEA",
  },
  MH: {
    alpha2: "MH",
    alpha3: "MHL",
    continent: "Australia",
    country_code: "692",
    currency_code: "USD",
    distance_unit: "KM",
    gec: "RM",
    geo: {
      latitude: 7.131474,
      longitude: 171.184478,
      max_latitude: 15.0190749,
      max_longitude: 172.5732421,
      min_latitude: 4.1601583,
      min_longitude: 159.8840332,
      bounds: {
        northeast: {
          lat: 15.0190749,
          lng: 172.5732421,
        },
        southwest: {
          lat: 4.1601583,
          lng: 159.8840332,
        },
      },
    },
    international_prefix: "00",
    ioc: "MHL",
    iso_long_name: "The Republic of the Marshall Islands",
    iso_short_name: "Marshall Islands",
    languages_official: ["en", "mh"],
    languages_spoken: ["en", "mh"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "1",
    nationality: "Marshallese",
    number: "584",
    postal_code: true,
    postal_code_format: "(969[67]\\d)(?:[ \\-](\\d{4}))?",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Micronesia",
    un_locode: "MH",
    un_member: true,
    unofficial_names: [
      "Marshall Islands",
      "Marshallinseln",
      "Îles Marshall",
      "Islas Marshall",
      "マーシャル諸島",
      "Marshalleilanden",
    ],
    vehicle_registration_code: "MH",
    world_region: "APAC",
  },
  DE: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "DE",
    alpha3: "DEU",
    continent: "Europe",
    country_code: "49",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    g20_member: true,
    g7_member: true,
    gec: "GM",
    geo: {
      latitude: 51.165691,
      longitude: 10.451526,
      max_latitude: 55.0815,
      max_longitude: 15.0418962,
      min_latitude: 47.2701115,
      min_longitude: 5.8663425,
      bounds: {
        northeast: {
          lat: 55.0815,
          lng: 15.0418962,
        },
        southwest: {
          lat: 47.2701115,
          lng: 5.8663425,
        },
      },
    },
    international_prefix: "00",
    ioc: "GER",
    iso_long_name: "The Federal Republic of Germany",
    iso_short_name: "Germany",
    languages_official: ["de"],
    languages_spoken: ["de"],
    national_destination_code_lengths: [2, 3, 4, 5],
    national_number_lengths: [6, 7, 8, 9, 10, 11],
    national_prefix: "0",
    nationality: "German",
    number: "276",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Western Europe",
    un_locode: "DE",
    un_member: true,
    unofficial_names: [
      "Germany",
      "Deutschland",
      "Allemagne",
      "Alemania",
      "ドイツ",
      "Duitsland",
    ],
    vat_rates: {
      standard: 19,
      reduced: [7],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "D",
    world_region: "EMEA",
  },
  DJ: {
    alpha2: "DJ",
    alpha3: "DJI",
    continent: "Africa",
    country_code: "253",
    currency_code: "DJF",
    distance_unit: "KM",
    gec: "DJ",
    geo: {
      latitude: 11.825138,
      longitude: 42.590275,
      max_latitude: 12.7136972,
      max_longitude: 43.4839,
      min_latitude: 10.912953,
      min_longitude: 41.77084600000001,
      bounds: {
        northeast: {
          lat: 12.7136972,
          lng: 43.4839,
        },
        southwest: {
          lat: 10.912953,
          lng: 41.77084600000001,
        },
      },
    },
    international_prefix: "00",
    ioc: "DJI",
    iso_long_name: "The Republic of Djibouti",
    iso_short_name: "Djibouti",
    languages_official: ["ar", "fr"],
    languages_spoken: ["ar", "fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6],
    national_prefix: "None",
    nationality: "Djibouti",
    number: "262",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "DJ",
    un_member: true,
    unofficial_names: ["Djibouti", "جيبوتي", "Dschibuti", "ジブチ"],
    vehicle_registration_code: "DJI",
    world_region: "EMEA",
  },
  DK: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{region}}\n{{country}}",
    alpha2: "DK",
    alpha3: "DNK",
    continent: "Europe",
    country_code: "45",
    currency_code: "DKK",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "DA",
    geo: {
      latitude: 56.26392,
      longitude: 9.501785,
      max_latitude: 58.02846,
      max_longitude: 15.2298,
      min_latitude: 54.4317001,
      min_longitude: 7.855200099999999,
      bounds: {
        northeast: {
          lat: 58.02846,
          lng: 15.2298,
        },
        southwest: {
          lat: 54.4317001,
          lng: 7.855200099999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "DEN",
    iso_long_name: "The Kingdom of Denmark",
    iso_short_name: "Denmark",
    languages_official: ["da"],
    languages_spoken: ["da"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Danish",
    number: "208",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "DK",
    un_member: true,
    unofficial_names: [
      "Denmark",
      "Dänemark",
      "Danemark",
      "Dinamarca",
      "デンマーク",
      "Denemarken",
    ],
    vat_rates: {
      standard: 25,
      reduced: [],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "DK",
    world_region: "EMEA",
  },
  DM: {
    alpha2: "DM",
    alpha3: "DMA",
    continent: "North America",
    country_code: "1",
    currency_code: "XCD",
    distance_unit: "MI",
    gec: "DO",
    geo: {
      latitude: 15.414999,
      longitude: -61.37097600000001,
      max_latitude: 15.6485199,
      max_longitude: -61.23090180000001,
      min_latitude: 15.2042266,
      min_longitude: -61.484108,
      bounds: {
        northeast: {
          lat: 15.6485199,
          lng: -61.23090180000001,
        },
        southwest: {
          lat: 15.2042266,
          lng: -61.484108,
        },
      },
    },
    international_prefix: "011",
    ioc: "DMA",
    iso_long_name: "The Commonwealth of Dominica",
    iso_short_name: "Dominica",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1767",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Dominican",
    number: "212",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "DM",
    un_member: true,
    unofficial_names: ["Dominica", "ドミニカ国"],
    vehicle_registration_code: "WD",
    world_region: "AMER",
  },
  DO: {
    alpha2: "DO",
    alpha3: "DOM",
    continent: "North America",
    country_code: "1",
    currency_code: "DOP",
    distance_unit: "KM",
    gec: "DR",
    geo: {
      latitude: 18.735693,
      longitude: -70.162651,
      max_latitude: 19.9786989,
      max_longitude: -68.25260010000001,
      min_latitude: 17.3611001,
      min_longitude: -72.0075099,
      bounds: {
        northeast: {
          lat: 19.9786989,
          lng: -68.25260010000001,
        },
        southwest: {
          lat: 17.3611001,
          lng: -72.0075099,
        },
      },
    },
    international_prefix: "011",
    ioc: "DOM",
    iso_long_name: "The Dominican Republic",
    iso_short_name: "Dominican Republic",
    languages_official: ["es"],
    languages_spoken: ["es"],
    nanp_prefix: "1809",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Dominican",
    number: "214",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "DO",
    un_member: true,
    unofficial_names: [
      "Dominican Republic",
      "Dominikanische Republik",
      "République Dominicaine",
      "República Dominicana",
      "ドミニカ共和国",
      "Dominicaanse Republiek",
    ],
    vehicle_registration_code: "DOM",
    world_region: "AMER",
  },
  DZ: {
    alpha2: "DZ",
    alpha3: "DZA",
    continent: "Africa",
    country_code: "213",
    currency_code: "DZD",
    distance_unit: "KM",
    gec: "AG",
    geo: {
      latitude: 28.033886,
      longitude: 1.659626,
      max_latitude: 37.2216,
      max_longitude: 11.9999992,
      min_latitude: 18.9681469,
      min_longitude: -8.6676111,
      bounds: {
        northeast: {
          lat: 37.2216,
          lng: 11.9999992,
        },
        southwest: {
          lat: 18.9681469,
          lng: -8.6676111,
        },
      },
    },
    international_prefix: "00",
    ioc: "ALG",
    iso_long_name: "The People's Democratic Republic of Algeria",
    iso_short_name: "Algeria",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "7",
    nationality: "Algerian",
    number: "012",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Africa",
    start_of_week: "sunday",
    subregion: "Northern Africa",
    un_locode: "DZ",
    un_member: true,
    unofficial_names: [
      "Algeria",
      "الجزائر",
      "Algerien",
      "Algérie",
      "Argelia",
      "アルジェリア",
      "Algerije",
    ],
    vehicle_registration_code: "DZ",
    world_region: "EMEA",
  },
  EC: {
    alpha2: "EC",
    alpha3: "ECU",
    continent: "South America",
    country_code: "593",
    currency_code: "USD",
    distance_unit: "KM",
    gec: "EC",
    geo: {
      latitude: -1.831239,
      longitude: -78.18340599999999,
      max_latitude: 2.2955,
      max_longitude: -75.1887938,
      min_latitude: -5.0143509,
      min_longitude: -92.60379999999999,
      bounds: {
        northeast: {
          lat: 2.2955,
          lng: -75.1887938,
        },
        southwest: {
          lat: -5.0143509,
          lng: -92.60379999999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "ECU",
    iso_long_name: "The Republic of Ecuador",
    iso_short_name: "Ecuador",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "Ecuadorean",
    number: "218",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "EC",
    un_member: true,
    unofficial_names: ["Ecuador", "Équateur", "エクアドル"],
    vehicle_registration_code: "EC",
    world_region: "AMER",
  },
  EE: {
    alpha2: "EE",
    alpha3: "EST",
    continent: "Europe",
    country_code: "372",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "EN",
    geo: {
      latitude: 58.595272,
      longitude: 25.0136071,
      max_latitude: 59.7315,
      max_longitude: 28.2101389,
      min_latitude: 57.50931600000001,
      min_longitude: 21.6540999,
      bounds: {
        northeast: {
          lat: 59.7315,
          lng: 28.2101389,
        },
        southwest: {
          lat: 57.50931600000001,
          lng: 21.6540999,
        },
      },
    },
    international_prefix: "00",
    ioc: "EST",
    iso_long_name: "The Republic of Estonia",
    iso_short_name: "Estonia",
    languages_official: ["et"],
    languages_spoken: ["et"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8],
    national_prefix: "None",
    nationality: "Estonian",
    number: "233",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "EE",
    un_member: true,
    unofficial_names: ["Estonia", "Estland", "Estonie", "エストニア"],
    vat_rates: {
      standard: 22,
      reduced: [9],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "EST",
    world_region: "EMEA",
  },
  EG: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "EG",
    alpha3: "EGY",
    continent: "Africa",
    country_code: "20",
    currency_code: "EGP",
    distance_unit: "KM",
    gec: "EG",
    geo: {
      latitude: 26.820553,
      longitude: 30.802498,
      max_latitude: 31.8122,
      max_longitude: 37.0569,
      min_latitude: 21.9999999,
      min_longitude: 24.696775,
      bounds: {
        northeast: {
          lat: 31.8122,
          lng: 37.0569,
        },
        southwest: {
          lat: 21.9999999,
          lng: 24.696775,
        },
      },
    },
    international_prefix: "00",
    ioc: "EGY",
    iso_long_name: "The Arab Republic of Egypt",
    iso_short_name: "Egypt",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Egyptian",
    number: "818",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Africa",
    start_of_week: "sunday",
    subregion: "Northern Africa",
    un_locode: "EG",
    un_member: true,
    unofficial_names: [
      "Egypt",
      "مصر",
      "Ägypten",
      "Égypte",
      "Egipto",
      "エジプト",
      "Egypte",
    ],
    vehicle_registration_code: "EG",
    world_region: "EMEA",
  },
  EH: {
    alpha2: "EH",
    alpha3: "ESH",
    continent: "Africa",
    country_code: "212",
    currency_code: "MAD",
    distance_unit: "KM",
    gec: "WI",
    geo: {
      latitude: 24.215527,
      longitude: -12.885834,
      max_latitude: 27.7223999,
      max_longitude: -8.667525,
      min_latitude: 20.427,
      min_longitude: -17.4573001,
      bounds: {
        northeast: {
          lat: 27.7223999,
          lng: -8.667525,
        },
        southwest: {
          lat: 20.427,
          lng: -17.4573001,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "The Sahrawi Arab Democratic Republic",
    iso_short_name: "Western Sahara",
    languages_official: ["es", "fr"],
    languages_spoken: ["es", "fr"],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "Sahrawi",
    number: "732",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Northern Africa",
    un_locode: "EH",
    un_member: false,
    unofficial_names: [
      "Western Sahara",
      "الصحراء الغربية",
      "Westsahara",
      "Sahara Occidental",
      "西サハラ",
      "Westelijke Sahara",
    ],
    vehicle_registration_code: "WSA",
    world_region: "EMEA",
  },
  ER: {
    alpha2: "ER",
    alpha3: "ERI",
    continent: "Africa",
    country_code: "291",
    currency_code: "ERN",
    distance_unit: "KM",
    gec: "ER",
    geo: {
      latitude: 15.179384,
      longitude: 39.782334,
      max_latitude: 18.0204137,
      max_longitude: 43.2312,
      min_latitude: 12.354723,
      min_longitude: 36.433348,
      bounds: {
        northeast: {
          lat: 18.0204137,
          lng: 43.2312,
        },
        southwest: {
          lat: 12.354723,
          lng: 36.433348,
        },
      },
    },
    international_prefix: "00",
    ioc: "ERI",
    iso_long_name: "The State of Eritrea",
    iso_short_name: "Eritrea",
    languages_official: ["en", "ar", "ti"],
    languages_spoken: ["en", "ar", "ti"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "0",
    nationality: "Eritrean",
    number: "232",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "ER",
    un_member: true,
    unofficial_names: ["Eritrea", "إريتريا", "Érythrée", "エリトリア"],
    vehicle_registration_code: "ER",
    world_region: "EMEA",
  },
  ES: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{region}}\n{{country}}",
    alpha2: "ES",
    alpha3: "ESP",
    continent: "Europe",
    country_code: "34",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "SP",
    geo: {
      latitude: 40.46366700000001,
      longitude: -3.74922,
      max_latitude: 43.8504,
      max_longitude: 4.6362,
      min_latitude: 27.4985,
      min_longitude: -18.2648001,
      bounds: {
        northeast: {
          lat: 43.8504,
          lng: 4.6362,
        },
        southwest: {
          lat: 27.4985,
          lng: -18.2648001,
        },
      },
    },
    international_prefix: "00",
    ioc: "ESP",
    iso_long_name: "The Kingdom of Spain",
    iso_short_name: "Spain",
    languages_official: ["es"],
    languages_spoken: [
      "es",
      "ca",
      "gl",
      "eu",
      "an",
      "ast",
      "fax",
      "rif",
      "rmq",
    ],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "None",
    nationality: "Spanish",
    number: "724",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "ES",
    un_member: true,
    unofficial_names: [
      "Spain",
      "Spanien",
      "Espagne",
      "España",
      "スペイン",
      "Spanje",
    ],
    vat_rates: {
      standard: 21,
      reduced: [10],
      super_reduced: 4,
      parking: null,
    },
    vehicle_registration_code: "E",
    world_region: "EMEA",
  },
  ET: {
    alpha2: "ET",
    alpha3: "ETH",
    continent: "Africa",
    country_code: "251",
    currency_code: "ETB",
    distance_unit: "KM",
    gec: "ET",
    geo: {
      latitude: 9.145000000000001,
      longitude: 40.489673,
      max_latitude: 14.8942141,
      max_longitude: 48.0010561,
      min_latitude: 3.4041369,
      min_longitude: 32.997734,
      bounds: {
        northeast: {
          lat: 14.8942141,
          lng: 48.0010561,
        },
        southwest: {
          lat: 3.4041369,
          lng: 32.997734,
        },
      },
    },
    international_prefix: "00",
    ioc: "ETH",
    iso_long_name: "The Federal Democratic Republic of Ethiopia",
    iso_short_name: "Ethiopia",
    languages_official: ["am"],
    languages_spoken: ["am"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Ethiopian",
    number: "231",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "ET",
    un_member: true,
    unofficial_names: [
      "Ethiopia",
      "Äthiopien",
      "Éthiopie",
      "Etiopía",
      "エチオピア",
      "Ethiopië",
    ],
    vehicle_registration_code: "ETH",
    world_region: "EMEA",
  },
  FI: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "FI",
    alpha3: "FIN",
    continent: "Europe",
    country_code: "358",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "FI",
    geo: {
      latitude: 61.92410999999999,
      longitude: 25.7481511,
      max_latitude: 70.0922932,
      max_longitude: 31.5870999,
      min_latitude: 59.693623,
      min_longitude: 20.4565002,
      bounds: {
        northeast: {
          lat: 70.0922932,
          lng: 31.5870999,
        },
        southwest: {
          lat: 59.693623,
          lng: 20.4565002,
        },
      },
    },
    international_prefix: "00",
    ioc: "FIN",
    iso_long_name: "The Republic of Finland",
    iso_short_name: "Finland",
    languages_official: ["fi", "sv"],
    languages_spoken: ["fi", "sv"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Finnish",
    number: "246",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "FI",
    un_member: true,
    unofficial_names: [
      "Finland",
      "Finnland",
      "Finlande",
      "Finlandia",
      "フィンランド",
    ],
    vat_rates: {
      standard: 25.5,
      reduced: [10, 14],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "FIN",
    world_region: "EMEA",
  },
  FJ: {
    alpha2: "FJ",
    alpha3: "FJI",
    continent: "Australia",
    country_code: "679",
    currency_code: "FJD",
    distance_unit: "KM",
    gec: "FJ",
    geo: {
      latitude: -17.713371,
      longitude: 178.065032,
      max_latitude: -12.2084957,
      max_longitude: -177.8686523,
      min_latitude: -20.8998713,
      min_longitude: 176.7919922,
      bounds: {
        northeast: {
          lat: -12.2084957,
          lng: -177.8686523,
        },
        southwest: {
          lat: -20.8998713,
          lng: 176.7919922,
        },
      },
    },
    international_prefix: "00",
    ioc: "FIJ",
    iso_long_name: "The Republic of Fiji",
    iso_short_name: "Fiji",
    languages_official: ["en", "fj", "hi"],
    languages_spoken: ["en", "fj", "hi", "ur"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Fijian",
    number: "242",
    postal_code: false,
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Melanesia",
    un_locode: "FJ",
    un_member: true,
    unofficial_names: ["Fiji", "Fidschi", "Fidji", "フィジー"],
    vehicle_registration_code: "FJI",
    world_region: "APAC",
  },
  FK: {
    alpha2: "FK",
    alpha3: "FLK",
    continent: "South America",
    country_code: "500",
    currency_code: "FKP",
    distance_unit: "MI",
    gec: "FK",
    geo: {
      latitude: -51.796253,
      longitude: -59.523613,
      max_latitude: -50.9809115,
      max_longitude: -57.6768495,
      min_latitude: -52.4744161,
      min_longitude: -61.3792419,
      bounds: {
        northeast: {
          lat: -50.9809115,
          lng: -57.6768495,
        },
        southwest: {
          lat: -52.4744161,
          lng: -61.3792419,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "The Falkland Islands",
    iso_short_name: "Falkland Islands (Malvinas)",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [5],
    national_prefix: "None",
    nationality: "Falkland Islander",
    number: "238",
    postal_code: true,
    postal_code_format: "FIQQ 1ZZ",
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "FK",
    un_member: false,
    unofficial_names: [
      "Falkland Islands",
      "Falklandinseln",
      "Îles Malouines",
      "Islas Malvinas",
      "フォークランド（マルビナス）諸島",
      "Falklandeilanden [Islas Malvinas]",
    ],
    world_region: "AMER",
  },
  FM: {
    alpha2: "FM",
    alpha3: "FSM",
    continent: "Australia",
    country_code: "691",
    currency_code: "USD",
    distance_unit: "KM",
    gec: "FM",
    geo: {
      latitude: 7.425554,
      longitude: 150.550812,
      max_latitude: 10.2770863,
      max_longitude: 163.5177612,
      min_latitude: 0.1538084,
      min_longitude: 136.9226075,
      bounds: {
        northeast: {
          lat: 10.2770863,
          lng: 163.5177612,
        },
        southwest: {
          lat: 0.1538084,
          lng: 136.9226075,
        },
      },
    },
    international_prefix: "011",
    ioc: "FSM",
    iso_long_name: "The Federated States of Micronesia",
    iso_short_name: "Micronesia (Federated States of)",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "1",
    nationality: "Micronesian",
    number: "583",
    postal_code: true,
    postal_code_format: "(9694[1-4])(?:[ \\-](\\d{4}))?",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Micronesia",
    un_locode: "FM",
    un_member: true,
    unofficial_names: [
      "Micronesia",
      "Mikronesien",
      "Micronésie",
      "ミクロネシア連邦",
      "Micronesië",
    ],
    vehicle_registration_code: "FSM",
    world_region: "APAC",
  },
  FO: {
    alpha2: "FO",
    alpha3: "FRO",
    continent: "Europe",
    country_code: "298",
    currency_code: "DKK",
    distance_unit: "KM",
    gec: "FO",
    geo: {
      latitude: 61.89263500000001,
      longitude: -6.9118061,
      max_latitude: 62.4310742,
      max_longitude: -6.190796,
      min_latitude: 61.3677776,
      min_longitude: -7.7178956,
      bounds: {
        northeast: {
          lat: 62.4310742,
          lng: -6.190796,
        },
        southwest: {
          lat: 61.3677776,
          lng: -7.7178956,
        },
      },
    },
    international_prefix: "00",
    ioc: "FRO",
    iso_long_name: "The Faroe Islands",
    iso_short_name: "Faroe Islands",
    languages_official: ["fo"],
    languages_spoken: ["fo"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6],
    national_prefix: "None",
    nationality: "Faroese",
    number: "234",
    postal_code: true,
    postal_code_format: "\\d{3}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "FO",
    un_member: false,
    unofficial_names: [
      "Faroe Islands",
      "Färöer-Inseln",
      "Îles Féroé",
      "Islas Faroe",
      "フェロー諸島",
      "Faeröer",
    ],
    vehicle_registration_code: "FO",
    world_region: "EMEA",
  },
  FR: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "FR",
    alpha3: "FRA",
    continent: "Europe",
    country_code: "33",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    g20_member: true,
    g7_member: true,
    gec: "FR",
    geo: {
      latitude: 46.227638,
      longitude: 2.213749,
      max_latitude: 51.1241999,
      max_longitude: 9.6624999,
      min_latitude: 41.31433,
      min_longitude: -5.5591,
      bounds: {
        northeast: {
          lat: 51.1241999,
          lng: 9.6624999,
        },
        southwest: {
          lat: 41.31433,
          lng: -5.5591,
        },
      },
    },
    international_prefix: "00",
    ioc: "FRA",
    iso_long_name: "The French Republic",
    iso_short_name: "France",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [1],
    national_number_lengths: [9, 10],
    national_prefix: "0",
    nationality: "French",
    number: "250",
    postal_code: true,
    postal_code_format: "\\d{2} ?\\d{3}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Western Europe",
    un_locode: "FR",
    un_member: true,
    unofficial_names: [
      "France",
      "Frankreich",
      "the French Republic",
      "フランス",
      "Frankrijk",
      "Francia",
    ],
    vat_rates: {
      standard: 20,
      reduced: [5.5, 10],
      super_reduced: 2.1,
      parking: null,
    },
    vehicle_registration_code: "F",
    world_region: "EMEA",
  },
  GA: {
    alpha2: "GA",
    alpha3: "GAB",
    continent: "Africa",
    country_code: "241",
    currency_code: "XAF",
    distance_unit: "KM",
    gec: "GB",
    geo: {
      latitude: -0.803689,
      longitude: 11.609444,
      max_latitude: 2.318109,
      max_longitude: 14.5269234,
      min_latitude: -4.1656,
      min_longitude: 8.421,
      bounds: {
        northeast: {
          lat: 2.318109,
          lng: 14.5269234,
        },
        southwest: {
          lat: -4.1656,
          lng: 8.421,
        },
      },
    },
    international_prefix: "00",
    ioc: "GAB",
    iso_long_name: "The Gabonese Republic",
    iso_short_name: "Gabon",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6, 7, 8],
    national_prefix: "None",
    nationality: "Gabonese",
    number: "266",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Middle Africa",
    un_locode: "GA",
    un_member: true,
    unofficial_names: ["Gabon", "Gabun", "Gabón", "ガボン"],
    vehicle_registration_code: "G",
    world_region: "EMEA",
  },
  GB: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}}\n{{region}}\n{{postalcode}}\n{{country}}",
    alpha2: "GB",
    alpha3: "GBR",
    continent: "Europe",
    country_code: "44",
    currency_code: "GBP",
    distance_unit: "MI",
    eea_member: false,
    eu_member: false,
    g20_member: true,
    g7_member: true,
    gec: "UK",
    geo: {
      latitude: 55.378051,
      longitude: -3.435973,
      max_latitude: 60.91569999999999,
      max_longitude: 1.68153079591,
      min_latitude: 49.959999905,
      min_longitude: -7.57216793459,
      bounds: {
        northeast: {
          lat: 60.91569999999999,
          lng: 1.68153079591,
        },
        southwest: {
          lat: 49.959999905,
          lng: -7.57216793459,
        },
      },
    },
    international_prefix: "00",
    ioc: "GBR",
    iso_long_name: "The United Kingdom of Great Britain and Northern Ireland",
    iso_short_name: "United Kingdom of Great Britain and Northern Ireland",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [10, 11],
    national_prefix: "0",
    nationality: "British",
    number: "826",
    postal_code: true,
    postal_code_format:
      "GIR ?0AA|(?:(?:AB|AL|B|BA|BB|BD|BF|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(?:\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}))|BFPO ?\\d{1,4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "GB",
    un_member: true,
    unofficial_names: [
      "United Kingdom",
      "The United Kingdom",
      "England",
      "Großbritannien",
      "Vereinigtes Königreich",
      "Royaume-Uni",
      "Reino Unido",
      "イギリス",
      "Verenigd Koninkrijk",
      "Great Britain (UK)",
      "UK",
      "Великобритания",
      "Velká Británie",
      "İngiltere",
      "Великобританія",
      "Great Britain",
    ],
    vat_rates: {
      standard: 20,
      reduced: [5],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "UK",
    world_region: "EMEA",
  },
  GD: {
    alpha2: "GD",
    alpha3: "GRD",
    continent: "North America",
    country_code: "1",
    currency_code: "XCD",
    distance_unit: "MI",
    gec: "GJ",
    geo: {
      latitude: 12.1165,
      longitude: -61.67899999999999,
      max_latitude: 12.5367,
      max_longitude: -61.3746999,
      min_latitude: 11.9829051,
      min_longitude: -61.80589999999999,
      bounds: {
        northeast: {
          lat: 12.5367,
          lng: -61.3746999,
        },
        southwest: {
          lat: 11.9829051,
          lng: -61.80589999999999,
        },
      },
    },
    international_prefix: "011",
    ioc: "GRN",
    iso_long_name: "Grenada",
    iso_short_name: "Grenada",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1473",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Grenadian",
    number: "308",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "GD",
    un_member: true,
    unofficial_names: ["Grenada", "グレナダ"],
    vehicle_registration_code: "WG",
    world_region: "AMER",
  },
  GE: {
    alpha2: "GE",
    alpha3: "GEO",
    continent: "Asia",
    country_code: "995",
    currency_code: "GEL",
    distance_unit: "KM",
    gec: "GG",
    geo: {
      latitude: 42.315407,
      longitude: 43.35689199999999,
      max_latitude: 43.5866269,
      max_longitude: 46.7361189,
      min_latitude: 41.054942,
      min_longitude: 39.9792001,
      bounds: {
        northeast: {
          lat: 43.5866269,
          lng: 46.7361189,
        },
        southwest: {
          lat: 41.054942,
          lng: 39.9792001,
        },
      },
    },
    international_prefix: "810",
    ioc: "GEO",
    iso_long_name: "Georgia",
    iso_short_name: "Georgia",
    languages_official: ["ka"],
    languages_spoken: ["ka"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "8*",
    nationality: "Georgian",
    number: "268",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Western Asia",
    un_locode: "GE",
    un_member: true,
    unofficial_names: ["Georgia", "Georgien", "Géorgie", "グルジア", "Georgië"],
    vehicle_registration_code: "GE",
    world_region: "EMEA",
  },
  GF: {
    alpha2: "GF",
    alpha3: "GUF",
    continent: "South America",
    country_code: "594",
    currency_code: "EUR",
    distance_unit: "KM",
    eu_member: true,
    euvat_member: false,
    gec: "FG",
    geo: {
      latitude: 3.933889,
      longitude: -53.125782,
      max_latitude: 5.9548,
      max_longitude: -51.6164491,
      min_latitude: 2.109287,
      min_longitude: -54.5544379,
      bounds: {
        northeast: {
          lat: 5.9548,
          lng: -51.6164491,
        },
        southwest: {
          lat: 2.109287,
          lng: -54.5544379,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "Guyane",
    iso_short_name: "French Guiana",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "None",
    nationality: "French Guianan",
    number: "254",
    postal_code: true,
    postal_code_format: "9[78]3\\d{2}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "GF",
    un_member: false,
    unofficial_names: [
      "French Guiana",
      "Französisch Guyana",
      "Guayana Francesa",
      "フランス領ギアナ",
      "Frans-Guyana",
    ],
    world_region: "AMER",
  },
  GG: {
    alpha2: "GG",
    alpha3: "GGY",
    continent: "Europe",
    country_code: "44",
    currency_code: "GBP",
    distance_unit: "KM",
    gec: "GK",
    geo: {
      latitude: 49.4481982,
      longitude: -2.58949,
      max_latitude: 49.5094108,
      max_longitude: -2.5016885,
      min_latitude: 49.4167199,
      min_longitude: -2.6745361,
      bounds: {
        northeast: {
          lat: 49.5094108,
          lng: -2.5016885,
        },
        southwest: {
          lat: 49.4167199,
          lng: -2.6745361,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "The Bailiwick of Guernsey",
    iso_short_name: "Guernsey",
    languages_official: ["en", "fr"],
    languages_spoken: ["en", "fr"],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "Channel Islander",
    number: "831",
    postal_code: true,
    postal_code_format: "GY\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "GG",
    un_member: false,
    unofficial_names: [
      "Guernsey and Alderney",
      "Guernsey und Alderney",
      "Guernsey et Alderney",
      "Guernsey y Alderney",
      "ガーンジー",
      "Guernsey",
    ],
    vehicle_registration_code: "GBA",
    world_region: "EMEA",
  },
  GH: {
    alpha2: "GH",
    alpha3: "GHA",
    continent: "Africa",
    country_code: "233",
    currency_code: "GHS",
    distance_unit: "KM",
    gec: "GH",
    geo: {
      latitude: 7.946527,
      longitude: -1.023194,
      max_latitude: 11.1750308,
      max_longitude: 1.199972,
      min_latitude: 4.6339001,
      min_longitude: -3.2607859,
      bounds: {
        northeast: {
          lat: 11.1750308,
          lng: 1.199972,
        },
        southwest: {
          lat: 4.6339001,
          lng: -3.2607859,
        },
      },
    },
    international_prefix: "00",
    ioc: "GHA",
    iso_long_name: "The Republic of Ghana",
    iso_short_name: "Ghana",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [5, 6, 7, 8],
    national_prefix: "None",
    nationality: "Ghanaian",
    number: "288",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "GH",
    un_member: true,
    unofficial_names: ["Ghana", "ガーナ"],
    vehicle_registration_code: "GH",
    world_region: "EMEA",
  },
  GI: {
    alpha2: "GI",
    alpha3: "GIB",
    continent: "Europe",
    country_code: "350",
    currency_code: "GIP",
    distance_unit: "KM",
    gec: "GI",
    geo: {
      latitude: 36.140751,
      longitude: -5.353585,
      max_latitude: 36.1551186,
      max_longitude: -5.334499999999999,
      min_latitude: 36.1038999,
      min_longitude: -5.3721,
      bounds: {
        northeast: {
          lat: 36.1551186,
          lng: -5.334499999999999,
        },
        southwest: {
          lat: 36.1038999,
          lng: -5.3721,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "Gibraltar",
    iso_short_name: "Gibraltar",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Gibraltar",
    number: "292",
    postal_code: true,
    postal_code_format: "GX11 1AA",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "GI",
    un_member: false,
    unofficial_names: ["Gibraltar", "ジブラルタル"],
    vehicle_registration_code: "GBZ",
    world_region: "EMEA",
  },
  GL: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "GL",
    alpha3: "GRL",
    continent: "North America",
    country_code: "299",
    currency_code: "DKK",
    distance_unit: "KM",
    gec: "GL",
    geo: {
      latitude: 71.706936,
      longitude: -42.604303,
      max_latitude: 83.9702561,
      max_longitude: -8.2617199,
      min_latitude: 58.26329,
      min_longitude: -73.8281196,
      bounds: {
        northeast: {
          lat: 83.9702561,
          lng: -8.2617199,
        },
        southwest: {
          lat: 58.26329,
          lng: -73.8281196,
        },
      },
    },
    international_prefix: "009",
    ioc: null,
    iso_long_name: "Kalaallit Nunaat",
    iso_short_name: "Greenland",
    languages_official: ["kl"],
    languages_spoken: ["kl"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6],
    national_prefix: "None",
    nationality: "Greenlandic",
    number: "304",
    postal_code: true,
    postal_code_format: "39\\d{2}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Northern America",
    un_locode: "GL",
    un_member: false,
    unofficial_names: [
      "Greenland",
      "Grönland",
      "Groenland",
      "Groenlandia",
      "グリーンランド",
    ],
    vehicle_registration_code: "KN",
    world_region: "EMEA",
  },
  GM: {
    alpha2: "GM",
    alpha3: "GMB",
    continent: "Africa",
    country_code: "220",
    currency_code: "GMD",
    distance_unit: "KM",
    gec: "GA",
    geo: {
      latitude: 13.443182,
      longitude: -15.310139,
      max_latitude: 13.825058,
      max_longitude: -13.7913862,
      min_latitude: 13.0098999,
      min_longitude: -16.9464001,
      bounds: {
        northeast: {
          lat: 13.825058,
          lng: -13.7913862,
        },
        southwest: {
          lat: 13.0098999,
          lng: -16.9464001,
        },
      },
    },
    international_prefix: "00",
    ioc: "GAM",
    iso_long_name: "The Republic of The Gambia",
    iso_short_name: "Gambia",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Gambian",
    number: "270",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "GM",
    un_member: true,
    unofficial_names: ["The Gambia", "ガンビア"],
    vehicle_registration_code: "WAG",
    world_region: "EMEA",
  },
  GN: {
    alpha2: "GN",
    alpha3: "GIN",
    continent: "Africa",
    country_code: "224",
    currency_code: "GNF",
    distance_unit: "KM",
    gec: "GV",
    geo: {
      latitude: 9.945587,
      longitude: -9.696645,
      max_latitude: 12.6748616,
      max_longitude: -7.637853,
      min_latitude: 7.190909099999999,
      min_longitude: -15.282,
      bounds: {
        northeast: {
          lat: 12.6748616,
          lng: -7.637853,
        },
        southwest: {
          lat: 7.190909099999999,
          lng: -15.282,
        },
      },
    },
    international_prefix: "00",
    ioc: "GUI",
    iso_long_name: "The Republic of Guinea",
    iso_short_name: "Guinea",
    languages_official: ["fr", "ff"],
    languages_spoken: ["fr", "ff"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Guinean",
    number: "324",
    postal_code: true,
    postal_code_format: "\\d{3}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "GN",
    un_member: true,
    unofficial_names: ["Guinea", "Guinée", "ギニア", "Guinee"],
    vehicle_registration_code: "RG",
    world_region: "EMEA",
  },
  GP: {
    alpha2: "GP",
    alpha3: "GLP",
    continent: "North America",
    country_code: "590",
    currency_code: "EUR",
    distance_unit: "KM",
    eu_member: true,
    euvat_member: false,
    gec: "GP",
    geo: {
      latitude: 16.265,
      longitude: -61.55099999999999,
      max_latitude: 16.5572273,
      max_longitude: -60.9473,
      min_latitude: 15.742032,
      min_longitude: -61.8468,
      bounds: {
        northeast: {
          lat: 16.5572273,
          lng: -60.9473,
        },
        southwest: {
          lat: 15.742032,
          lng: -61.8468,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "Guadeloupe",
    iso_short_name: "Guadeloupe",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "None",
    nationality: "French",
    number: "312",
    postal_code: true,
    postal_code_format: "9[78][01]\\d{2}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "GP",
    un_member: false,
    unofficial_names: ["Guadeloupe", "Guadalupe", "グアドループ"],
    world_region: "AMER",
  },
  GQ: {
    alpha2: "GQ",
    alpha3: "GNQ",
    continent: "Africa",
    country_code: "240",
    currency_code: "XAF",
    distance_unit: "KM",
    gec: "EK",
    geo: {
      latitude: 1.650801,
      longitude: 10.267895,
      max_latitude: 3.8355,
      max_longitude: 11.3333,
      min_latitude: -1.5475,
      min_longitude: 5.541900099999999,
      bounds: {
        northeast: {
          lat: 3.8355,
          lng: 11.3333,
        },
        southwest: {
          lat: -1.5475,
          lng: 5.541900099999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "GEQ",
    iso_long_name: "The Republic of Equatorial Guinea",
    iso_short_name: "Equatorial Guinea",
    languages_official: ["es", "fr"],
    languages_spoken: ["es", "fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6],
    national_prefix: "None",
    nationality: "Equatorial Guinean",
    number: "226",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Middle Africa",
    un_locode: "GQ",
    un_member: true,
    unofficial_names: [
      "Equatorial Guinea",
      "Äquatorial-Guinea",
      "Guinée Équatoriale",
      "Guinea Ecuatorial",
      "赤道ギニア",
      "Equatoriaal-Guinea",
    ],
    vehicle_registration_code: "GQ",
    world_region: "EMEA",
  },
  GR: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "GR",
    alpha3: "GRC",
    continent: "Europe",
    country_code: "30",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "GR",
    geo: {
      latitude: 39.074208,
      longitude: 21.824312,
      max_latitude: 41.7488784,
      max_longitude: 29.6527999,
      min_latitude: 34.5428,
      min_longitude: 19.3098,
      bounds: {
        northeast: {
          lat: 41.7488784,
          lng: 29.6527999,
        },
        southwest: {
          lat: 34.5428,
          lng: 19.3098,
        },
      },
    },
    international_prefix: "00",
    ioc: "GRE",
    iso_long_name: "The Hellenic Republic",
    iso_short_name: "Greece",
    languages_official: ["el"],
    languages_spoken: ["el"],
    national_destination_code_lengths: [2],
    national_number_lengths: [10],
    national_prefix: "None",
    nationality: "Greek",
    number: "300",
    postal_code: true,
    postal_code_format: "\\d{3} ?\\d{2}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "GR",
    un_member: true,
    unofficial_names: [
      "Greece",
      "Griechenland",
      "Grèce",
      "Grecia",
      "ギリシャ",
      "Griekenland",
    ],
    vat_rates: {
      standard: 24,
      reduced: [6, 13],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "GR",
    world_region: "EMEA",
  },
  GS: {
    alpha2: "GS",
    alpha3: "SGS",
    continent: "Antarctica",
    country_code: "500",
    currency_code: "GBP",
    distance_unit: "KM",
    gec: "SX",
    geo: {
      latitude: -54.429579,
      longitude: -36.587909,
      max_latitude: -53.8525267,
      max_longitude: -25.4663085,
      min_latitude: -59.91097600000001,
      min_longitude: -38.4301758,
      bounds: {
        northeast: {
          lat: -53.8525267,
          lng: -25.4663085,
        },
        southwest: {
          lat: -59.91097600000001,
          lng: -38.4301758,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "South Georgia and the South Sandwich Islands",
    iso_short_name: "South Georgia and the South Sandwich Islands",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "South Georgia and the South Sandwich Islander",
    number: "239",
    postal_code: true,
    postal_code_format: "SIQQ 1ZZ",
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "GS",
    un_member: false,
    unofficial_names: [
      "South Georgia",
      "South Georgia and the South Sandwich Islands",
      "Südgeorgien und die Südlichen Sandwichinseln",
      "サウスジョージア・サウスサンドウィッチ諸島",
      "Zuid-Georgia en Zuidelijke Sandwicheilanden",
    ],
    world_region: "AMER",
  },
  GT: {
    alpha2: "GT",
    alpha3: "GTM",
    continent: "North America",
    country_code: "502",
    currency_code: "GTQ",
    distance_unit: "KM",
    gec: "GT",
    geo: {
      latitude: 15.783471,
      longitude: -90.23075899999999,
      max_latitude: 17.815697,
      max_longitude: -88.1982001,
      min_latitude: 13.63,
      min_longitude: -92.2714,
      bounds: {
        northeast: {
          lat: 17.815697,
          lng: -88.1982001,
        },
        southwest: {
          lat: 13.63,
          lng: -92.2714,
        },
      },
    },
    international_prefix: "00",
    ioc: "GUA",
    iso_long_name: "The Republic of Guatemala",
    iso_short_name: "Guatemala",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Guatemalan",
    number: "320",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Central America",
    un_locode: "GT",
    un_member: true,
    unofficial_names: ["Guatemala", "グアテマラ"],
    vehicle_registration_code: "GCA",
    world_region: "AMER",
  },
  GU: {
    alpha2: "GU",
    alpha3: "GUM",
    continent: "Australia",
    country_code: "1",
    currency_code: "USD",
    distance_unit: "MI",
    gec: "GQ",
    geo: {
      latitude: 13.444304,
      longitude: 144.793731,
      max_latitude: 13.7994072,
      max_longitude: 145.112915,
      min_latitude: 13.1022175,
      min_longitude: 144.4647218,
      bounds: {
        northeast: {
          lat: 13.7994072,
          lng: 145.112915,
        },
        southwest: {
          lat: 13.1022175,
          lng: 144.4647218,
        },
      },
    },
    international_prefix: "011",
    ioc: "GUM",
    iso_long_name: "The Territory of Guam",
    iso_short_name: "Guam",
    languages_official: ["en", "ch", "es"],
    languages_spoken: ["en", "ch", "es"],
    nanp_prefix: "1671",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Guamanian",
    number: "316",
    postal_code: true,
    postal_code_format: "(969(?:[12]\\d|3[12]))(?:[ \\-](\\d{4}))?",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Micronesia",
    un_locode: "GU",
    un_member: false,
    unofficial_names: ["Guam", "グアム"],
    world_region: "APAC",
  },
  GW: {
    alpha2: "GW",
    alpha3: "GNB",
    continent: "Africa",
    country_code: "245",
    currency_code: "XOF",
    distance_unit: "KM",
    gec: "PU",
    geo: {
      latitude: 11.803749,
      longitude: -15.180413,
      max_latitude: 12.6869468,
      max_longitude: -13.6265235,
      min_latitude: 10.7146,
      min_longitude: -16.9518999,
      bounds: {
        northeast: {
          lat: 12.6869468,
          lng: -13.6265235,
        },
        southwest: {
          lat: 10.7146,
          lng: -16.9518999,
        },
      },
    },
    international_prefix: "00",
    ioc: "GBS",
    iso_long_name: "The Republic of Guinea-Bissau",
    iso_short_name: "Guinea-Bissau",
    languages_official: ["pt"],
    languages_spoken: ["pt"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Guinea-Bissauan",
    number: "624",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "GW",
    un_member: true,
    unofficial_names: [
      "Guinea-Bissau",
      "Guinée-Bissau",
      "ギニアビサウ",
      "Guinee-Bissau",
      "Guinea Bissau",
    ],
    vehicle_registration_code: "GUB",
    world_region: "EMEA",
  },
  GY: {
    alpha2: "GY",
    alpha3: "GUY",
    continent: "South America",
    country_code: "592",
    currency_code: "GYD",
    distance_unit: "KM",
    gec: "GY",
    geo: {
      latitude: 4.860416,
      longitude: -58.93018,
      max_latitude: 8.722199999999999,
      max_longitude: -56.49112,
      min_latitude: 1.164724,
      min_longitude: -61.414905,
      bounds: {
        northeast: {
          lat: 8.722199999999999,
          lng: -56.49112,
        },
        southwest: {
          lat: 1.164724,
          lng: -61.414905,
        },
      },
    },
    international_prefix: "00",
    ioc: "GUY",
    iso_long_name: "The Co-operative Republic of Guyana",
    iso_short_name: "Guyana",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6, 7],
    national_prefix: "None",
    nationality: "Guyanese",
    number: "328",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "GY",
    un_member: true,
    unofficial_names: ["Guyana", "ガイアナ"],
    vehicle_registration_code: "GUY",
    world_region: "AMER",
  },
  HK: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}} {{region_short}}\n{{country}}",
    alpha2: "HK",
    alpha3: "HKG",
    continent: "Asia",
    country_code: "852",
    currency_code: "HKD",
    distance_unit: "KM",
    gec: "HK",
    geo: {
      latitude: 22.3193039,
      longitude: 114.1693611,
      max_latitude: 22.5619469,
      max_longitude: 114.4294999,
      min_latitude: 22.1435,
      min_longitude: 113.8259001,
      bounds: {
        northeast: {
          lat: 22.5619469,
          lng: 114.4294999,
        },
        southwest: {
          lat: 22.1435,
          lng: 113.8259001,
        },
      },
    },
    international_prefix: "001",
    ioc: "HKG",
    iso_long_name: "The Hong Kong Special Administrative Region of China",
    iso_short_name: "Hong Kong",
    languages_official: ["en", "zh"],
    languages_spoken: ["en", "zh"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Hong Kongese",
    number: "344",
    postal_code: false,
    region: "Asia",
    start_of_week: "monday",
    subregion: "Eastern Asia",
    un_locode: "HK",
    un_member: false,
    unofficial_names: ["Hong Kong", "香港", "Hongkong"],
    vehicle_registration_code: "HK",
    world_region: "APAC",
  },
  HM: {
    alpha2: "HM",
    alpha3: "HMD",
    continent: "Antarctica",
    country_code: "672",
    currency_code: "AUD",
    distance_unit: "KM",
    gec: "HM",
    geo: {
      latitude: -53.08181,
      longitude: 73.50415799999999,
      max_latitude: -52.9609444,
      max_longitude: 73.7792016,
      min_latitude: -53.19168759999999,
      min_longitude: 73.25065599999999,
      bounds: {
        northeast: {
          lat: -52.9609444,
          lng: 73.7792016,
        },
        southwest: {
          lat: -53.19168759999999,
          lng: 73.25065599999999,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "The Territory of Heard Island and McDonald Islands",
    iso_short_name: "Heard Island and McDonald Islands",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "Heard and McDonald Islander",
    number: "334",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "",
    start_of_week: "monday",
    subregion: "",
    un_locode: "HM",
    un_member: false,
    unofficial_names: [
      "Heard and McDonald Islands",
      "Heard und die McDonaldinseln",
      "ハード島とマクドナルド諸島",
      "Heard- en McDonaldeilanden",
      "Heard Island and McDonald Islands",
    ],
    world_region: "APAC",
  },
  HN: {
    alpha2: "HN",
    alpha3: "HND",
    continent: "North America",
    country_code: "504",
    currency_code: "HNL",
    distance_unit: "KM",
    gec: "HO",
    geo: {
      latitude: 15.199999,
      longitude: -86.241905,
      max_latitude: 17.4677999,
      max_longitude: -83.0621001,
      min_latitude: 12.9808201,
      min_longitude: -89.3564822,
      bounds: {
        northeast: {
          lat: 17.4677999,
          lng: -83.0621001,
        },
        southwest: {
          lat: 12.9808201,
          lng: -89.3564822,
        },
      },
    },
    international_prefix: "00",
    ioc: "HON",
    iso_long_name: "The Republic of Honduras",
    iso_short_name: "Honduras",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8],
    national_prefix: "None",
    nationality: "Honduran",
    number: "340",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Central America",
    un_locode: "HN",
    un_member: true,
    unofficial_names: ["Honduras", "ホンジュラス"],
    vehicle_registration_code: "HN",
    world_region: "AMER",
  },
  HR: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "HR",
    alpha3: "HRV",
    continent: "Europe",
    country_code: "385",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "HR",
    geo: {
      latitude: 45.1,
      longitude: 15.2000001,
      max_latitude: 46.5549857,
      max_longitude: 19.4480523,
      min_latitude: 42.3385087,
      min_longitude: 13.3649,
      bounds: {
        northeast: {
          lat: 46.5549857,
          lng: 19.4480523,
        },
        southwest: {
          lat: 42.3385087,
          lng: 13.3649,
        },
      },
    },
    international_prefix: "00",
    ioc: "CRO",
    iso_long_name: "The Republic of Croatia",
    iso_short_name: "Croatia",
    languages_official: ["hr"],
    languages_spoken: ["hr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Croatian",
    number: "191",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "HR",
    un_member: true,
    unofficial_names: [
      "Croatia",
      "Kroatien",
      "Croatie",
      "Croacia",
      "クロアチア",
      "Kroatië",
      "Croatia (Hrvatska)",
    ],
    vat_rates: {
      standard: 25,
      reduced: [5, 13],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "HR",
    world_region: "EMEA",
  },
  HT: {
    alpha2: "HT",
    alpha3: "HTI",
    continent: "North America",
    country_code: "509",
    currency_code: "HTG",
    distance_unit: "KM",
    gec: "HA",
    geo: {
      latitude: 18.971187,
      longitude: -72.285215,
      max_latitude: 20.1282,
      max_longitude: -71.621754,
      min_latitude: 17.9422,
      min_longitude: -74.6082,
      bounds: {
        northeast: {
          lat: 20.1282,
          lng: -71.621754,
        },
        southwest: {
          lat: 17.9422,
          lng: -74.6082,
        },
      },
    },
    international_prefix: "00",
    ioc: "HAI",
    iso_long_name: "The Republic of Haiti",
    iso_short_name: "Haiti",
    languages_official: ["fr", "ht"],
    languages_spoken: ["fr", "ht"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Haitian",
    number: "332",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "HT",
    un_member: true,
    unofficial_names: ["Haiti", "ハイチ", "Haïti"],
    vehicle_registration_code: "RH",
    world_region: "AMER",
  },
  HU: {
    address_format:
      "{{recipient}}\n{{city}}\n{{street}}\n{{postalcode}}\n{{country}}",
    alpha2: "HU",
    alpha3: "HUN",
    continent: "Europe",
    country_code: "36",
    currency_code: "HUF",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "HU",
    geo: {
      latitude: 47.162494,
      longitude: 19.5033041,
      max_latitude: 48.585234,
      max_longitude: 22.8965438,
      min_latitude: 45.7370889,
      min_longitude: 16.1133078,
      bounds: {
        northeast: {
          lat: 48.585234,
          lng: 22.8965438,
        },
        southwest: {
          lat: 45.7370889,
          lng: 16.1133078,
        },
      },
    },
    international_prefix: "00",
    ioc: "HUN",
    iso_long_name: "Hungary",
    iso_short_name: "Hungary",
    languages_official: ["hu"],
    languages_spoken: ["hu"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "06",
    nationality: "Hungarian",
    number: "348",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Eastern Europe",
    un_locode: "HU",
    un_member: true,
    unofficial_names: [
      "Hungary",
      "Ungarn",
      "Hongrie",
      "Hungría",
      "ハンガリー",
      "Hongarije",
    ],
    vat_rates: {
      standard: 27,
      reduced: [5, 18],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "H",
    world_region: "EMEA",
  },
  AX: {
    alpha2: "AX",
    alpha3: "ALA",
    continent: "Europe",
    country_code: "358",
    currency_code: "EUR",
    distance_unit: "KM",
    eu_member: true,
    euvat_member: false,
    gec: null,
    geo: {
      latitude: 60.1785247,
      longitude: 19.9156105,
      max_latitude: 60.8400009,
      max_longitude: 21.4866841,
      min_latitude: 59.6872001,
      min_longitude: 19.2095998,
      bounds: {
        northeast: {
          lat: 60.8400009,
          lng: 21.4866841,
        },
        southwest: {
          lat: 59.6872001,
          lng: 19.2095998,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "Åland",
    iso_short_name: "Åland Islands",
    languages_official: ["sv"],
    languages_spoken: ["sv"],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "Swedish",
    number: "248",
    postal_code: true,
    postal_code_format: "22\\d{3}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Northern Europe",
    un_locode: "AX",
    un_member: false,
    unofficial_names: [
      "Åland Islands",
      "Åland",
      "オーランド諸島",
      "Ålandeilanden",
    ],
    vehicle_registration_code: "AX",
    world_region: "EMEA",
  },
  AZ: {
    alpha2: "AZ",
    alpha3: "AZE",
    continent: "Asia",
    country_code: "994",
    currency_code: "AZN",
    distance_unit: "KM",
    gec: "AJ",
    geo: {
      latitude: 40.143105,
      longitude: 47.576927,
      max_latitude: 41.9594999,
      max_longitude: 50.7458001,
      min_latitude: 38.3922171,
      min_longitude: 44.7632599,
      bounds: {
        northeast: {
          lat: 41.9594999,
          lng: 50.7458001,
        },
        southwest: {
          lat: 38.3922171,
          lng: 44.7632599,
        },
      },
    },
    international_prefix: "810",
    ioc: "AZE",
    iso_long_name: "The Republic of Azerbaijan",
    iso_short_name: "Azerbaijan",
    languages_official: ["az", "hy"],
    languages_spoken: ["az", "hy"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "8",
    nationality: "Azerbaijani",
    number: "031",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Western Asia",
    un_locode: "AZ",
    un_member: true,
    unofficial_names: [
      "Azerbaijan",
      "Aserbaidschan",
      "Azerbaïdjan",
      "Azerbaiyán",
      "アゼルバイジャン",
      "Azerbeidzjan",
    ],
    vehicle_registration_code: "AZ",
    world_region: "EMEA",
  },
  BA: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "BA",
    alpha3: "BIH",
    continent: "Europe",
    country_code: "387",
    currency_code: "BAM",
    distance_unit: "KM",
    gec: "BK",
    geo: {
      latitude: 43.915886,
      longitude: 17.679076,
      max_latitude: 45.2766262,
      max_longitude: 19.6237016,
      min_latitude: 42.5564808,
      min_longitude: 15.7223665,
      bounds: {
        northeast: {
          lat: 45.2766262,
          lng: 19.6237016,
        },
        southwest: {
          lat: 42.5564808,
          lng: 15.7223665,
        },
      },
    },
    international_prefix: "00",
    ioc: "BIH",
    iso_long_name: "Bosnia and Herzegovina",
    iso_short_name: "Bosnia and Herzegovina",
    languages_official: ["bs", "hr", "sr"],
    languages_spoken: ["bs", "hr", "sr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Bosnian, Herzegovinian",
    number: "070",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "BA",
    un_member: true,
    unofficial_names: [
      "Bosnia and Herzegovina",
      "Bosnien und Herzegowina",
      "Bosnie et Herzégovine",
      "Bosnia y Herzegovina",
      "ボスニア・ヘルツェゴビナ",
      "Bosnië en Herzegovina",
      "Bosnia Herzegovina",
    ],
    vehicle_registration_code: "BIH",
    world_region: "EMEA",
  },
  BB: {
    alpha2: "BB",
    alpha3: "BRB",
    continent: "North America",
    country_code: "1",
    currency_code: "BBD",
    distance_unit: "KM",
    gec: "BB",
    geo: {
      latitude: 13.193887,
      longitude: -59.543198,
      max_latitude: 13.3365093,
      max_longitude: -59.4174957,
      min_latitude: 13.039844,
      min_longitude: -59.6530151,
      bounds: {
        northeast: {
          lat: 13.3365093,
          lng: -59.4174957,
        },
        southwest: {
          lat: 13.039844,
          lng: -59.6530151,
        },
      },
    },
    international_prefix: "011",
    ioc: "BAR",
    iso_long_name: "Barbados",
    iso_short_name: "Barbados",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1246",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Barbadian",
    number: "052",
    postal_code: true,
    postal_code_format: "BB\\d{5}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "BB",
    un_member: true,
    unofficial_names: ["Barbade", "Barbados", "バルバドス"],
    vehicle_registration_code: "BDS",
    world_region: "AMER",
  },
  BD: {
    alpha2: "BD",
    alpha3: "BGD",
    continent: "Asia",
    country_code: "880",
    currency_code: "BDT",
    distance_unit: "KM",
    gec: "BG",
    geo: {
      latitude: 23.684994,
      longitude: 90.356331,
      max_latitude: 26.633914,
      max_longitude: 92.6801153,
      min_latitude: 20.3794,
      min_longitude: 88.00861410000002,
      bounds: {
        northeast: {
          lat: 26.633914,
          lng: 92.6801153,
        },
        southwest: {
          lat: 20.3794,
          lng: 88.00861410000002,
        },
      },
    },
    international_prefix: "00",
    ioc: "BAN",
    iso_long_name: "The People's Republic of Bangladesh",
    iso_short_name: "Bangladesh",
    languages_official: ["bn"],
    languages_spoken: ["bn"],
    national_destination_code_lengths: [2],
    national_number_lengths: [10],
    national_prefix: "0",
    nationality: "Bangladeshi",
    number: "050",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Asia",
    start_of_week: "sunday",
    subregion: "Southern Asia",
    un_locode: "BD",
    un_member: true,
    unofficial_names: ["Bangladesh", "Bangladesch", "バングラデシュ"],
    vehicle_registration_code: "BD",
    world_region: "APAC",
  },
  BE: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "BE",
    alpha3: "BEL",
    continent: "Europe",
    country_code: "32",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "BE",
    geo: {
      latitude: 50.503887,
      longitude: 4.469936,
      max_latitude: 51.5051449,
      max_longitude: 6.408124099999999,
      min_latitude: 49.497013,
      min_longitude: 2.5240999,
      bounds: {
        northeast: {
          lat: 51.5051449,
          lng: 6.408124099999999,
        },
        southwest: {
          lat: 49.497013,
          lng: 2.5240999,
        },
      },
    },
    international_prefix: "00",
    ioc: "BEL",
    iso_long_name: "The Kingdom of Belgium",
    iso_short_name: "Belgium",
    languages_official: ["nl", "fr", "de"],
    languages_spoken: ["nl", "fr", "de"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "Belgian",
    number: "056",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Western Europe",
    un_locode: "BE",
    un_member: true,
    unofficial_names: [
      "Belgium",
      "Belgien",
      "Belgique",
      "Bélgica",
      "ベルギー",
      "België",
    ],
    vat_rates: {
      standard: 21,
      reduced: [6, 12],
      super_reduced: null,
      parking: 12,
    },
    vehicle_registration_code: "B",
    world_region: "EMEA",
  },
  BF: {
    alpha2: "BF",
    alpha3: "BFA",
    continent: "Africa",
    country_code: "226",
    currency_code: "XOF",
    distance_unit: "KM",
    gec: "UV",
    geo: {
      latitude: 12.238333,
      longitude: -1.561593,
      max_latitude: 15.0840397,
      max_longitude: 2.4043596,
      min_latitude: 9.4104717,
      min_longitude: -5.5132416,
      bounds: {
        northeast: {
          lat: 15.0840397,
          lng: 2.4043596,
        },
        southwest: {
          lat: 9.4104717,
          lng: -5.5132416,
        },
      },
    },
    international_prefix: "00",
    ioc: "BUR",
    iso_long_name: "Burkina Faso",
    iso_short_name: "Burkina Faso",
    languages_official: ["fr", "ff"],
    languages_spoken: ["fr", "ff"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Burkinabe",
    number: "854",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "BF",
    un_member: true,
    unofficial_names: ["Burkina Faso", "ブルキナファソ"],
    vehicle_registration_code: "BF",
    world_region: "EMEA",
  },
  BG: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "BG",
    alpha3: "BGR",
    continent: "Europe",
    country_code: "359",
    currency_code: "BGN",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "BU",
    geo: {
      latitude: 42.733883,
      longitude: 25.48583,
      max_latitude: 44.2153059,
      max_longitude: 28.7292001,
      min_latitude: 41.2354469,
      min_longitude: 22.3573446,
      bounds: {
        northeast: {
          lat: 44.2153059,
          lng: 28.7292001,
        },
        southwest: {
          lat: 41.2354469,
          lng: 22.3573446,
        },
      },
    },
    international_prefix: "00",
    ioc: "BUL",
    iso_long_name: "The Republic of Bulgaria",
    iso_short_name: "Bulgaria",
    languages_official: ["bg"],
    languages_spoken: ["bg"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9, 10],
    national_prefix: "0",
    nationality: "Bulgarian",
    number: "100",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Eastern Europe",
    un_locode: "BG",
    un_member: true,
    unofficial_names: [
      "Bulgaria",
      "България",
      "Bulgarien",
      "Bulgarie",
      "ブルガリア",
      "Bulgarije",
    ],
    vat_rates: {
      standard: 20,
      reduced: [9],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "BG",
    world_region: "EMEA",
  },
  BH: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "BH",
    alpha3: "BHR",
    continent: "Asia",
    country_code: "973",
    currency_code: "BHD",
    distance_unit: "KM",
    gec: "BA",
    geo: {
      latitude: 26.0667,
      longitude: 50.5577,
      max_latitude: 26.3469001,
      max_longitude: 50.8509064,
      min_latitude: 25.5349999,
      min_longitude: 50.324246,
      bounds: {
        northeast: {
          lat: 26.3469001,
          lng: 50.8509064,
        },
        southwest: {
          lat: 25.5349999,
          lng: 50.324246,
        },
      },
    },
    international_prefix: "00",
    ioc: "BRN",
    iso_long_name: "The Kingdom of Bahrain",
    iso_short_name: "Bahrain",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Bahraini",
    number: "048",
    postal_code: true,
    postal_code_format: "(?:\\d|1[0-2])\\d{2}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Western Asia",
    un_locode: "BH",
    un_member: true,
    unofficial_names: [
      "Bahrain",
      "البحرين",
      "Bahreïn",
      "Bahrein",
      "バーレーン",
    ],
    vehicle_registration_code: "BRN",
    world_region: "EMEA",
  },
  BI: {
    alpha2: "BI",
    alpha3: "BDI",
    continent: "Africa",
    country_code: "257",
    currency_code: "BIF",
    distance_unit: "KM",
    gec: "BY",
    geo: {
      latitude: -3.373056,
      longitude: 29.918886,
      max_latitude: -2.3097301,
      max_longitude: 30.84954,
      min_latitude: -4.4693288,
      min_longitude: 29.000968,
      bounds: {
        northeast: {
          lat: -2.3097301,
          lng: 30.84954,
        },
        southwest: {
          lat: -4.4693288,
          lng: 29.000968,
        },
      },
    },
    international_prefix: "00",
    ioc: "BDI",
    iso_long_name: "The Republic of Burundi",
    iso_short_name: "Burundi",
    languages_official: ["fr", "rn"],
    languages_spoken: ["fr", "rn"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Burundian",
    number: "108",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Eastern Africa",
    un_locode: "BI",
    un_member: true,
    unofficial_names: ["Burundi", "ブルンジ"],
    vehicle_registration_code: "RU",
    world_region: "EMEA",
  },
  BJ: {
    alpha2: "BJ",
    alpha3: "BEN",
    continent: "Africa",
    country_code: "229",
    currency_code: "XOF",
    distance_unit: "KM",
    gec: "BN",
    geo: {
      latitude: 9.30769,
      longitude: 2.315834,
      max_latitude: 12.4086111,
      max_longitude: 3.8433429,
      min_latitude: 6.2061001,
      min_longitude: 0.7754124000000001,
      bounds: {
        northeast: {
          lat: 12.4086111,
          lng: 3.8433429,
        },
        southwest: {
          lat: 6.2061001,
          lng: 0.7754124000000001,
        },
      },
    },
    international_prefix: "00",
    ioc: "BEN",
    iso_long_name: "The Republic of Benin",
    iso_short_name: "Benin",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Beninese",
    number: "204",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "BJ",
    un_member: true,
    unofficial_names: ["Benin", "Bénin", "ベナン"],
    vehicle_registration_code: "BJ",
    world_region: "EMEA",
  },
  BL: {
    alpha2: "BL",
    alpha3: "BLM",
    continent: "North America",
    country_code: "590",
    currency_code: "EUR",
    distance_unit: "KM",
    gec: "TB",
    geo: {
      latitude: 17.9,
      longitude: -62.833333,
      max_latitude: 17.978,
      max_longitude: -62.7869,
      min_latitude: 17.8663,
      min_longitude: -62.9559999,
      bounds: {
        northeast: {
          lat: 17.978,
          lng: -62.7869,
        },
        southwest: {
          lat: 17.8663,
          lng: -62.9559999,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "The Collectivity of Saint-Barthélemy",
    iso_short_name: "Saint Barthélemy",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "Saint Barthélemy Islander",
    number: "652",
    postal_code: true,
    postal_code_format: "9[78][01]\\d{2}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "BL",
    un_member: false,
    unofficial_names: [
      "Saint Barthélemy",
      "Saint-Barthélemy",
      "サン・バルテルミー",
    ],
    world_region: "APAC",
  },
  BM: {
    alpha2: "BM",
    alpha3: "BMU",
    continent: "North America",
    country_code: "1",
    currency_code: "BMD",
    distance_unit: "KM",
    gec: "BD",
    geo: {
      latitude: 32.3078,
      longitude: -64.7505,
      max_latitude: 32.3961,
      max_longitude: -64.6413999,
      min_latitude: 32.2424975,
      min_longitude: -64.89139999999999,
      bounds: {
        northeast: {
          lat: 32.3961,
          lng: -64.6413999,
        },
        southwest: {
          lat: 32.2424975,
          lng: -64.89139999999999,
        },
      },
    },
    international_prefix: "011",
    ioc: "BER",
    iso_long_name: "Bermuda",
    iso_short_name: "Bermuda",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1441",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Bermudian",
    number: "060",
    postal_code: true,
    postal_code_format: "[A-Z]{2} ?[A-Z0-9]{2}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Northern America",
    un_locode: "BM",
    un_member: false,
    unofficial_names: ["Bermuda", "Bermudes", "Bermudas", "バミューダ"],
    world_region: "AMER",
  },
  BN: {
    alpha2: "BN",
    alpha3: "BRN",
    continent: "Asia",
    country_code: "673",
    currency_code: "BND",
    distance_unit: "KM",
    gec: "BX",
    geo: {
      latitude: 4.535277,
      longitude: 114.727669,
      max_latitude: 5.0978001,
      max_longitude: 115.3639552,
      min_latitude: 4.002460999999999,
      min_longitude: 114.0752,
      bounds: {
        northeast: {
          lat: 5.0978001,
          lng: 115.3639552,
        },
        southwest: {
          lat: 4.002460999999999,
          lng: 114.0752,
        },
      },
    },
    international_prefix: "00",
    ioc: "BRU",
    iso_long_name: "The Nation of Brunei, the Abode of Peace",
    iso_short_name: "Brunei Darussalam",
    languages_official: ["ms"],
    languages_spoken: ["ms"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "0",
    nationality: "Bruneian",
    number: "096",
    postal_code: true,
    postal_code_format: "[A-Z]{2} ?\\d{4}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "South-Eastern Asia",
    un_locode: "BN",
    un_member: true,
    unofficial_names: ["Brunei", "ブルネイ・ダルサラーム"],
    vehicle_registration_code: "BRU",
    world_region: "APAC",
  },
  BO: {
    alpha2: "BO",
    alpha3: "BOL",
    continent: "South America",
    country_code: "591",
    currency_code: "BOB",
    distance_unit: "KM",
    gec: "BL",
    geo: {
      latitude: -16.290154,
      longitude: -63.58865299999999,
      max_latitude: -9.669323,
      max_longitude: -57.453803,
      min_latitude: -22.8980899,
      min_longitude: -69.64498999999999,
      bounds: {
        northeast: {
          lat: -9.669323,
          lng: -57.453803,
        },
        southwest: {
          lat: -22.8980899,
          lng: -69.64498999999999,
        },
      },
    },
    international_prefix: "0010",
    ioc: "BOL",
    iso_long_name: "The Plurinational State of Bolivia",
    iso_short_name: "Bolivia (Plurinational State of)",
    languages_official: ["es", "ay", "qu"],
    languages_spoken: ["es", "ay", "qu"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "010",
    nationality: "Bolivian",
    number: "068",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "BO",
    un_member: true,
    unofficial_names: ["Bolivia", "Bolivien", "Bolivie", "ボリビア多民族国"],
    vehicle_registration_code: "BOL",
    world_region: "AMER",
  },
  BQ: {
    alpha2: "BQ",
    alpha3: "BES",
    continent: "North America",
    country_code: "599",
    currency_code: "USD",
    distance_unit: "KM",
    geo: {
      latitude: 12.1783611,
      longitude: -68.2385339,
      max_latitude: 17.6606999,
      max_longitude: -62.9228,
      min_latitude: 11.9641,
      min_longitude: -68.5149,
      bounds: {
        northeast: {
          lat: 17.6606999,
          lng: -62.9228,
        },
        southwest: {
          lat: 11.9641,
          lng: -68.5149,
        },
      },
    },
    international_prefix: "00",
    iso_long_name: "Bonaire, Sint Eustatius and Saba",
    iso_short_name: "Bonaire, Sint Eustatius and Saba",
    languages_official: ["nl", "en"],
    languages_spoken: ["nl", "en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "0",
    nationality: "Dutch",
    number: "535",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "BQ",
    un_member: false,
    unofficial_names: [
      "Bonaire, Sint Eustatius and Saba",
      "Caribbean Netherlands",
      "Caribisch Nederland",
      "ボネール、シント・ユースタティウスおよびサバ",
    ],
    world_region: "APAC",
  },
  BR: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}} {{region_short}}\n{{country}}",
    alpha2: "BR",
    alpha3: "BRA",
    continent: "South America",
    country_code: "55",
    currency_code: "BRL",
    distance_unit: "KM",
    g20_member: true,
    gec: "BR",
    geo: {
      latitude: -14.235004,
      longitude: -51.92528,
      max_latitude: 5.2717863,
      max_longitude: -28.650543,
      min_latitude: -34.0891,
      min_longitude: -73.9828169,
      bounds: {
        northeast: {
          lat: 5.2717863,
          lng: -28.650543,
        },
        southwest: {
          lat: -34.0891,
          lng: -73.9828169,
        },
      },
    },
    international_prefix: "0014",
    ioc: "BRA",
    iso_long_name: "The Federative Republic of Brazil",
    iso_short_name: "Brazil",
    languages_official: ["pt"],
    languages_spoken: ["pt"],
    national_destination_code_lengths: [2],
    national_number_lengths: [10, 11],
    national_prefix: "014",
    nationality: "Brazilian",
    number: "076",
    postal_code: true,
    postal_code_format: "\\d{5}-?\\d{3}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "BR",
    un_member: true,
    unofficial_names: [
      "Brazil",
      "Brasilien",
      "Brésil",
      "Brasil",
      "ブラジル",
      "Brazilië",
    ],
    vat_rates: {
      standard: 17,
      reduced: [12, 7],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "BR",
    world_region: "AMER",
  },
  BS: {
    alpha2: "BS",
    alpha3: "BHS",
    continent: "North America",
    country_code: "1",
    currency_code: "BSD",
    distance_unit: "MI",
    gec: "BF",
    geo: {
      latitude: 25.03428,
      longitude: -77.39627999999999,
      max_latitude: 27.263412,
      max_longitude: -72.70975390000001,
      min_latitude: 20.9082735,
      min_longitude: -80.4775603,
      bounds: {
        northeast: {
          lat: 27.263412,
          lng: -72.70975390000001,
        },
        southwest: {
          lat: 20.9082735,
          lng: -80.4775603,
        },
      },
    },
    international_prefix: "011",
    ioc: "BAH",
    iso_long_name: "The Commonwealth of The Bahamas",
    iso_short_name: "Bahamas",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1242",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Bahamian",
    number: "044",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "BS",
    un_member: true,
    unofficial_names: ["The Bahamas", "バハマ"],
    vehicle_registration_code: "BS",
    world_region: "AMER",
  },
  BT: {
    alpha2: "BT",
    alpha3: "BTN",
    continent: "Asia",
    country_code: "975",
    currency_code: "BTN",
    distance_unit: "KM",
    gec: "BT",
    geo: {
      latitude: 27.514162,
      longitude: 90.433601,
      max_latitude: 28.246987,
      max_longitude: 92.125232,
      min_latitude: 26.702016,
      min_longitude: 88.7464739,
      bounds: {
        northeast: {
          lat: 28.246987,
          lng: 92.125232,
        },
        southwest: {
          lat: 26.702016,
          lng: 88.7464739,
        },
      },
    },
    international_prefix: "00",
    ioc: "BHU",
    iso_long_name: "The Kingdom of Bhutan",
    iso_short_name: "Bhutan",
    languages_official: ["dz"],
    languages_spoken: ["dz"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8],
    national_prefix: "None",
    nationality: "Bhutanese",
    number: "064",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Southern Asia",
    un_locode: "BT",
    un_member: true,
    unofficial_names: ["Bhutan", "Bhoutan", "Bután", "ブータン"],
    vehicle_registration_code: "BHT",
    world_region: "APAC",
  },
  BV: {
    alpha2: "BV",
    alpha3: "BVT",
    continent: "Antarctica",
    country_code: "47",
    currency_code: "NOK",
    distance_unit: "KM",
    gec: "BV",
    geo: {
      latitude: -54.4207915,
      longitude: 3.3464497,
      max_latitude: -54.3869298,
      max_longitude: 3.4332785,
      min_latitude: -54.4541004,
      min_longitude: 3.2858826,
      bounds: {
        northeast: {
          lat: -54.3869298,
          lng: 3.4332785,
        },
        southwest: {
          lat: -54.4541004,
          lng: 3.2858826,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "Bouvet Island",
    iso_short_name: "Bouvet Island",
    languages_official: [],
    languages_spoken: [],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "",
    number: "074",
    postal_code: false,
    region: "",
    start_of_week: "monday",
    subregion: "",
    un_locode: "BV",
    un_member: false,
    unofficial_names: [
      "Bouvet Island",
      "Bouvetinsel",
      "ブーベ島",
      "Bouveteiland",
    ],
    world_region: "APAC",
  },
  BW: {
    alpha2: "BW",
    alpha3: "BWA",
    continent: "Africa",
    country_code: "267",
    currency_code: "BWP",
    distance_unit: "KM",
    gec: "BC",
    geo: {
      latitude: -22.328474,
      longitude: 24.684866,
      max_latitude: -17.7781369,
      max_longitude: 29.375304,
      min_latitude: -26.9075448,
      min_longitude: 19.998903,
      bounds: {
        northeast: {
          lat: -17.7781369,
          lng: 29.375304,
        },
        southwest: {
          lat: -26.9075448,
          lng: 19.998903,
        },
      },
    },
    international_prefix: "00",
    ioc: "BOT",
    iso_long_name: "The Republic of Botswana",
    iso_short_name: "Botswana",
    languages_official: ["en", "tn"],
    languages_spoken: ["en", "tn"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Motswana",
    number: "072",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Southern Africa",
    un_locode: "BW",
    un_member: true,
    unofficial_names: ["Botswana", "ボツワナ"],
    vehicle_registration_code: "RB",
    world_region: "EMEA",
  },
  BY: {
    alpha2: "BY",
    alpha3: "BLR",
    continent: "Europe",
    country_code: "375",
    currency_code: "BYN",
    distance_unit: "KM",
    gec: "BO",
    geo: {
      latitude: 53.709807,
      longitude: 27.953389,
      max_latitude: 56.1718719,
      max_longitude: 32.7768202,
      min_latitude: 51.26201100000001,
      min_longitude: 23.1783377,
      bounds: {
        northeast: {
          lat: 56.1718719,
          lng: 32.7768202,
        },
        southwest: {
          lat: 51.26201100000001,
          lng: 23.1783377,
        },
      },
    },
    international_prefix: "810",
    ioc: "BLR",
    iso_long_name: "The Republic of Belarus",
    iso_short_name: "Belarus",
    languages_official: ["be", "ru"],
    languages_spoken: ["be", "ru"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "8",
    nationality: "Belarusian",
    number: "112",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Eastern Europe",
    un_locode: "BY",
    un_member: true,
    unofficial_names: [
      "Belarus",
      "Weißrussland",
      "Biélorussie",
      "Bielorrusia",
      "ベラルーシ",
      "Wit-Rusland",
      "Беларусь",
    ],
    vehicle_registration_code: "BY",
    world_region: "EMEA",
  },
  BZ: {
    alpha2: "BZ",
    alpha3: "BLZ",
    continent: "North America",
    country_code: "501",
    currency_code: "BZD",
    distance_unit: "MI",
    gec: "BH",
    geo: {
      latitude: 17.189877,
      longitude: -88.49765,
      max_latitude: 18.4959419,
      max_longitude: -87.41269989999999,
      min_latitude: 15.8856189,
      min_longitude: -89.22758789999999,
      bounds: {
        northeast: {
          lat: 18.4959419,
          lng: -87.41269989999999,
        },
        southwest: {
          lat: 15.8856189,
          lng: -89.22758789999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "BIZ",
    iso_long_name: "Belize",
    iso_short_name: "Belize",
    languages_official: ["en", "es"],
    languages_spoken: ["en", "es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "0",
    nationality: "Belizean",
    number: "084",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Central America",
    un_locode: "BZ",
    un_member: true,
    unofficial_names: ["Belize", "Belice", "ベリーズ"],
    vehicle_registration_code: "BZ",
    world_region: "AMER",
  },
  CA: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}} {{region_short}} {{postalcode}}\n{{country}}",
    alpha2: "CA",
    alpha3: "CAN",
    continent: "North America",
    country_code: "1",
    currency_code: "CAD",
    distance_unit: "KM",
    g20_member: true,
    g7_member: true,
    gec: "CA",
    geo: {
      latitude: 56.130366,
      longitude: -106.346771,
      max_latitude: 83.6381,
      max_longitude: -50.9766,
      min_latitude: 41.6765559,
      min_longitude: -141.00187,
      bounds: {
        northeast: {
          lat: 83.6381,
          lng: -50.9766,
        },
        southwest: {
          lat: 41.6765559,
          lng: -141.00187,
        },
      },
    },
    international_prefix: "011",
    ioc: "CAN",
    iso_long_name: "Canada",
    iso_short_name: "Canada",
    languages_official: ["en", "fr"],
    languages_spoken: ["en", "fr"],
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Canadian",
    number: "124",
    postal_code: true,
    postal_code_format:
      "[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z] ?\\d[ABCEGHJ-NPRSTV-Z]\\d",
    region: "Americas",
    start_of_week: "sunday",
    subregion: "Northern America",
    un_locode: "CA",
    un_member: true,
    unofficial_names: ["Canada", "Kanada", "Canadá", "カナダ"],
    vehicle_registration_code: "CDN",
    world_region: "AMER",
  },
  CC: {
    alpha2: "CC",
    alpha3: "CCK",
    continent: "Asia",
    country_code: "61",
    currency_code: "AUD",
    distance_unit: "KM",
    gec: "CK",
    geo: {
      latitude: -12.164165,
      longitude: 96.87095599999999,
      max_latitude: -11.819973,
      max_longitude: 96.93271639999999,
      min_latitude: -12.2118513,
      min_longitude: 96.8134118,
      bounds: {
        northeast: {
          lat: -11.819973,
          lng: 96.93271639999999,
        },
        southwest: {
          lat: -12.2118513,
          lng: 96.8134118,
        },
      },
    },
    international_prefix: "0011",
    ioc: null,
    iso_long_name: "The Territory of Cocos (Keeling) Islands",
    iso_short_name: "Cocos (Keeling) Islands",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Cocos Islander",
    number: "166",
    postal_code: true,
    postal_code_format: "6799",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Australia and New Zealand",
    un_locode: "CC",
    un_member: false,
    unofficial_names: [
      "Cocos (Keeling) Islands",
      "Kokosinseln",
      "ココス（キーリング）諸島",
      "Cocoseilanden",
    ],
    world_region: "APAC",
  },
  CD: {
    alpha2: "CD",
    alpha3: "COD",
    continent: "Africa",
    country_code: "243",
    currency_code: "CDF",
    distance_unit: "KM",
    gec: "CG",
    geo: {
      latitude: -4.038333,
      longitude: 21.758664,
      max_latitude: 5.3920029,
      max_longitude: 31.314612,
      min_latitude: -13.4590349,
      min_longitude: 12.1454,
      bounds: {
        northeast: {
          lat: 5.3920029,
          lng: 31.314612,
        },
        southwest: {
          lat: -13.4590349,
          lng: 12.1454,
        },
      },
    },
    international_prefix: "00",
    ioc: "COD",
    iso_long_name: "The Democratic Republic of the Congo",
    iso_short_name: "Congo (Democratic Republic of the)",
    languages_official: ["fr", "ln", "kg", "sw", "lu"],
    languages_spoken: ["fr", "ln", "kg", "sw", "lu"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Congolese",
    number: "180",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Middle Africa",
    un_locode: "CD",
    un_member: true,
    unofficial_names: [
      "Congo (Dem. Rep.)",
      "Kongo (Dem. Rep.)",
      "Congo (Rep. Dem.)",
      "コンゴ民主共和国",
      "Congo [DRC]",
      "Congo (The Democratic Republic Of The)",
      "Democratic Republic of the Congo",
      "Congo, Democratic Republic of",
      "Congo (Kinshasa)",
    ],
    vehicle_registration_code: "CGO",
    world_region: "EMEA",
  },
  CF: {
    alpha2: "CF",
    alpha3: "CAF",
    continent: "Africa",
    country_code: "236",
    currency_code: "XAF",
    distance_unit: "KM",
    gec: "CT",
    geo: {
      latitude: 6.611110999999999,
      longitude: 20.939444,
      max_latitude: 11.0179569,
      max_longitude: 27.4583049,
      min_latitude: 2.2230529,
      min_longitude: 14.4150981,
      bounds: {
        northeast: {
          lat: 11.0179569,
          lng: 27.4583049,
        },
        southwest: {
          lat: 2.2230529,
          lng: 14.4150981,
        },
      },
    },
    international_prefix: "00",
    ioc: "CAF",
    iso_long_name: "The Central African Republic",
    iso_short_name: "Central African Republic",
    languages_official: ["fr", "sg"],
    languages_spoken: ["fr", "sg"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Central African",
    number: "140",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Middle Africa",
    un_locode: "CF",
    un_member: true,
    unofficial_names: [
      "Central African Republic",
      "Zentralafrikanische Republik",
      "République Centrafricaine",
      "República Centroafricana",
      "中央アフリカ共和国",
      "Centraal-Afrikaanse Republiek",
    ],
    vehicle_registration_code: "RCA",
    world_region: "EMEA",
  },
  CG: {
    alpha2: "CG",
    alpha3: "COG",
    continent: "Africa",
    country_code: "242",
    currency_code: "XAF",
    distance_unit: "KM",
    gec: "CF",
    geo: {
      latitude: -0.228021,
      longitude: 15.827659,
      max_latitude: 3.707791,
      max_longitude: 18.650421,
      min_latitude: -5.0964,
      min_longitude: 11.1182001,
      bounds: {
        northeast: {
          lat: 3.707791,
          lng: 18.650421,
        },
        southwest: {
          lat: -5.0964,
          lng: 11.1182001,
        },
      },
    },
    international_prefix: "00",
    ioc: "CGO",
    iso_long_name: "The Republic of the Congo",
    iso_short_name: "Congo",
    languages_official: ["fr", "ln"],
    languages_spoken: ["fr", "ln"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Congolese",
    number: "178",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Middle Africa",
    un_locode: "CG",
    un_member: true,
    unofficial_names: [
      "Congo",
      "Kongo",
      "コンゴ共和国",
      "Congo [Republiek]",
      "Congo, Republic of",
      "Congo (Brazzaville)",
    ],
    vehicle_registration_code: "RCB",
    world_region: "EMEA",
  },
  CH: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "CH",
    alpha3: "CHE",
    continent: "Europe",
    country_code: "41",
    currency_code: "CHF",
    distance_unit: "KM",
    esm_member: true,
    gec: "SZ",
    geo: {
      latitude: 46.818188,
      longitude: 8.227511999999999,
      max_latitude: 47.8084546,
      max_longitude: 10.4923401,
      min_latitude: 45.81792,
      min_longitude: 5.95608,
      bounds: {
        northeast: {
          lat: 47.8084546,
          lng: 10.4923401,
        },
        southwest: {
          lat: 45.81792,
          lng: 5.95608,
        },
      },
    },
    international_prefix: "00",
    ioc: "SUI",
    iso_long_name: "The Swiss Confederation",
    iso_short_name: "Switzerland",
    languages_official: ["de", "fr", "it", "rm"],
    languages_spoken: ["de", "fr", "it", "rm"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9, 10],
    national_prefix: "0",
    nationality: "Swiss",
    number: "756",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Western Europe",
    un_locode: "CH",
    un_member: true,
    unofficial_names: [
      "Switzerland",
      "Schweiz",
      "Suisse",
      "Suiza",
      "スイス",
      "Zwitserland",
    ],
    vat_rates: {
      standard: 8.1,
      reduced: [2.6, 3.8],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "CH",
    world_region: "EMEA",
  },
  CI: {
    alpha2: "CI",
    alpha3: "CIV",
    continent: "Africa",
    country_code: "225",
    currency_code: "XOF",
    distance_unit: "KM",
    gec: "IV",
    geo: {
      latitude: 7.539988999999999,
      longitude: -5.547079999999999,
      max_latitude: 10.7400149,
      max_longitude: -2.493031,
      min_latitude: 4.193,
      min_longitude: -8.6020589,
      bounds: {
        northeast: {
          lat: 10.7400149,
          lng: -2.493031,
        },
        southwest: {
          lat: 4.193,
          lng: -8.6020589,
        },
      },
    },
    international_prefix: "00",
    ioc: "CIV",
    iso_long_name: "The Republic of Côte d'Ivoire",
    iso_short_name: "Côte d'Ivoire",
    languages_official: ["fr"],
    languages_spoken: ["fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Ivorian",
    number: "384",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "CI",
    un_member: true,
    unofficial_names: [
      "Côte D'Ivoire",
      "Elfenbeinküste",
      "コートジボワール",
      "Ivoorkust",
      "Cote D'Ivoire (Ivory Coast)",
      "Cote d Ivoire (Ivory Coast)",
      "Ivory Coast",
    ],
    vehicle_registration_code: "CI",
    world_region: "EMEA",
  },
  CK: {
    alpha2: "CK",
    alpha3: "COK",
    continent: "Australia",
    country_code: "682",
    currency_code: "NZD",
    distance_unit: "KM",
    gec: "CW",
    geo: {
      latitude: -21.236736,
      longitude: -159.777671,
      max_latitude: -8.1679932,
      max_longitude: -155.6982422,
      min_latitude: -23.0898384,
      min_longitude: -166.1791992,
      bounds: {
        northeast: {
          lat: -8.1679932,
          lng: -155.6982422,
        },
        southwest: {
          lat: -23.0898384,
          lng: -166.1791992,
        },
      },
    },
    international_prefix: "00",
    ioc: "COK",
    iso_long_name: "The Cook Islands",
    iso_short_name: "Cook Islands",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [5],
    national_prefix: "00",
    nationality: "Cook Islander",
    number: "184",
    postal_code: false,
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Polynesia",
    un_locode: "CK",
    un_member: false,
    unofficial_names: [
      "Cook Islands",
      "Cookinseln",
      "Îles Cook",
      "Islas Cook",
      "クック諸島",
      "Cookeilanden",
    ],
    world_region: "APAC",
  },
  CL: {
    alpha2: "CL",
    alpha3: "CHL",
    continent: "South America",
    country_code: "56",
    currency_code: "CLP",
    distance_unit: "KM",
    gec: "CI",
    geo: {
      latitude: -35.675147,
      longitude: -71.542969,
      max_latitude: -17.4983291,
      max_longitude: -66.3327,
      min_latitude: -56.1455,
      min_longitude: -110.0281,
      bounds: {
        northeast: {
          lat: -17.4983291,
          lng: -66.3327,
        },
        southwest: {
          lat: -56.1455,
          lng: -110.0281,
        },
      },
    },
    international_prefix: "00",
    ioc: "CHI",
    iso_long_name: "The Republic of Chile",
    iso_short_name: "Chile",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "Chilean",
    number: "152",
    postal_code: true,
    postal_code_format: "\\d{7}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "CL",
    un_member: true,
    unofficial_names: ["Chile", "チリ", "Chili"],
    vat_rates: {
      standard: 19,
      reduced: [],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "RCH",
    world_region: "AMER",
  },
  CM: {
    alpha2: "CM",
    alpha3: "CMR",
    continent: "Africa",
    country_code: "237",
    currency_code: "XAF",
    distance_unit: "KM",
    gec: "CM",
    geo: {
      latitude: 7.369721999999999,
      longitude: 12.354722,
      max_latitude: 13.083335,
      max_longitude: 16.1944081,
      min_latitude: 1.6559,
      min_longitude: 8.3936001,
      bounds: {
        northeast: {
          lat: 13.083335,
          lng: 16.1944081,
        },
        southwest: {
          lat: 1.6559,
          lng: 8.3936001,
        },
      },
    },
    international_prefix: "00",
    ioc: "CMR",
    iso_long_name: "The Republic of Cameroon",
    iso_short_name: "Cameroon",
    languages_official: ["en", "fr"],
    languages_spoken: ["en", "fr"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Cameroonian",
    number: "120",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Middle Africa",
    un_locode: "CM",
    un_member: true,
    unofficial_names: [
      "Cameroon",
      "Kamerun",
      "Cameroun",
      "Camerún",
      "カメルーン",
      "Kameroen",
    ],
    vehicle_registration_code: "CAM",
    world_region: "EMEA",
  },
  CN: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}} {{region_short}}\n{{country}}",
    alpha2: "CN",
    alpha3: "CHN",
    continent: "Asia",
    country_code: "86",
    currency_code: "CNY",
    distance_unit: "KM",
    g20_member: true,
    gec: "CH",
    geo: {
      latitude: 35.86166,
      longitude: 104.195397,
      max_latitude: 53.5609739,
      max_longitude: 134.7754563,
      min_latitude: 17.9996,
      min_longitude: 73.4994136,
      bounds: {
        northeast: {
          lat: 53.5609739,
          lng: 134.7754563,
        },
        southwest: {
          lat: 17.9996,
          lng: 73.4994136,
        },
      },
    },
    international_prefix: "00",
    ioc: "CHN",
    iso_long_name: "The People's Republic of China",
    iso_short_name: "China",
    languages_official: ["zh"],
    languages_spoken: ["zh"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8, 9, 10, 11],
    national_prefix: "0",
    nationality: "Chinese",
    number: "156",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Eastern Asia",
    un_locode: "CN",
    un_member: true,
    unofficial_names: ["China", "Chine", "中国"],
    vehicle_registration_code: "CHN*",
    world_region: "APAC",
  },
  CO: {
    alpha2: "CO",
    alpha3: "COL",
    continent: "South America",
    country_code: "57",
    currency_code: "COP",
    distance_unit: "KM",
    gec: "CO",
    geo: {
      latitude: 4.570868,
      longitude: -74.297333,
      max_latitude: 13.5177999,
      max_longitude: -66.8463122,
      min_latitude: -4.227109899999999,
      min_longitude: -81.8317,
      bounds: {
        northeast: {
          lat: 13.5177999,
          lng: -66.8463122,
        },
        southwest: {
          lat: -4.227109899999999,
          lng: -81.8317,
        },
      },
    },
    international_prefix: "005",
    ioc: "COL",
    iso_long_name: "The Republic of Colombia",
    iso_short_name: "Colombia",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9, 10],
    national_prefix: "05",
    nationality: "Colombian",
    number: "170",
    postal_code: true,
    postal_code_format: "\\d{6}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "CO",
    un_member: true,
    unofficial_names: ["Colombia", "Kolumbien", "Colombie", "コロンビア"],
    vehicle_registration_code: "CO",
    world_region: "AMER",
  },
  CR: {
    alpha2: "CR",
    alpha3: "CRI",
    continent: "North America",
    country_code: "506",
    currency_code: "CRC",
    distance_unit: "KM",
    gec: "CS",
    geo: {
      latitude: 9.748916999999999,
      longitude: -83.753428,
      max_latitude: 11.2196806,
      max_longitude: -82.51830009999999,
      min_latitude: 5.496099999999999,
      min_longitude: -87.09899999999999,
      bounds: {
        northeast: {
          lat: 11.2196806,
          lng: -82.51830009999999,
        },
        southwest: {
          lat: 5.496099999999999,
          lng: -87.09899999999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "CRC",
    iso_long_name: "The Republic of Costa Rica",
    iso_short_name: "Costa Rica",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Costa Rican",
    number: "188",
    postal_code: true,
    postal_code_format: "\\d{4,5}|\\d{3}-\\d{4}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Central America",
    un_locode: "CR",
    un_member: true,
    unofficial_names: ["Costa Rica", "コスタリカ"],
    vehicle_registration_code: "CR",
    world_region: "AMER",
  },
  CU: {
    alpha2: "CU",
    alpha3: "CUB",
    continent: "North America",
    country_code: "53",
    currency_code: "CUP",
    distance_unit: "KM",
    gec: "CU",
    geo: {
      latitude: 21.521757,
      longitude: -77.781167,
      max_latitude: 23.3776001,
      max_longitude: -73.9545,
      min_latitude: 19.6529001,
      min_longitude: -85.1715001,
      bounds: {
        northeast: {
          lat: 23.3776001,
          lng: -73.9545,
        },
        southwest: {
          lat: 19.6529001,
          lng: -85.1715001,
        },
      },
    },
    international_prefix: "119",
    ioc: "CUB",
    iso_long_name: "The Republic of Cuba",
    iso_short_name: "Cuba",
    languages_official: ["es"],
    languages_spoken: ["es"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "0",
    nationality: "Cuban",
    number: "192",
    postal_code: true,
    postal_code_format: "\\d{5}",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "CU",
    un_member: true,
    unofficial_names: ["Cuba", "Kuba", "キューバ"],
    vehicle_registration_code: "C",
    world_region: "AMER",
  },
  CV: {
    alpha2: "CV",
    alpha3: "CPV",
    continent: "Africa",
    country_code: "238",
    currency_code: "CVE",
    distance_unit: "KM",
    gec: "CV",
    geo: {
      latitude: 16.5388,
      longitude: -23.0418,
      max_latitude: 17.3191764,
      max_longitude: -22.5933839,
      min_latitude: 14.7270733,
      min_longitude: -25.383911,
      bounds: {
        northeast: {
          lat: 17.3191764,
          lng: -22.5933839,
        },
        southwest: {
          lat: 14.7270733,
          lng: -25.383911,
        },
      },
    },
    international_prefix: "00",
    ioc: "CPV",
    iso_long_name: "The Republic of Cabo Verde",
    iso_short_name: "Cabo Verde",
    languages_official: ["pt"],
    languages_spoken: ["pt"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Cape Verdian",
    number: "132",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Africa",
    start_of_week: "monday",
    subregion: "Western Africa",
    un_locode: "CV",
    un_member: true,
    unofficial_names: [
      "Cape Verde",
      "Kap Verde",
      "Cap Vert",
      "Cabo Verde",
      "カーボベルデ",
      "Kaapverdië",
    ],
    vehicle_registration_code: "CV",
    world_region: "EMEA",
  },
  CW: {
    alpha2: "CW",
    alpha3: "CUW",
    continent: "North America",
    country_code: "599",
    currency_code: "ANG",
    distance_unit: "KM",
    gec: "UC",
    geo: {
      latitude: 12.16957,
      longitude: -68.99002,
      max_latitude: 12.4941999,
      max_longitude: -68.5670001,
      min_latitude: 11.9224,
      min_longitude: -69.29899999999999,
      bounds: {
        northeast: {
          lat: 12.4941999,
          lng: -68.5670001,
        },
        southwest: {
          lat: 11.9224,
          lng: -69.29899999999999,
        },
      },
    },
    international_prefix: "00",
    ioc: null,
    iso_long_name: "The Country of Curaçao",
    iso_short_name: "Curaçao",
    languages_official: ["nl"],
    languages_spoken: ["nl"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "0",
    nationality: "Dutch",
    number: "531",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "CW",
    un_member: false,
    unofficial_names: ["Curaçao", "キュラソー島"],
    world_region: "AMER",
  },
  CX: {
    alpha2: "CX",
    alpha3: "CXR",
    continent: "Asia",
    country_code: "61",
    currency_code: "AUD",
    distance_unit: "KM",
    gec: "KT",
    geo: {
      latitude: -10.447525,
      longitude: 105.690449,
      max_latitude: -10.412352,
      max_longitude: 105.7129382,
      min_latitude: -10.5703619,
      min_longitude: 105.5333161,
      bounds: {
        northeast: {
          lat: -10.412352,
          lng: 105.7129382,
        },
        southwest: {
          lat: -10.5703619,
          lng: 105.5333161,
        },
      },
    },
    international_prefix: "0011",
    ioc: null,
    iso_long_name: "The Territory of Christmas Island",
    iso_short_name: "Christmas Island",
    languages_official: ["en", "zh", "ms"],
    languages_spoken: ["en", "zh", "ms"],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "0",
    nationality: "Christmas Island",
    number: "162",
    postal_code: true,
    postal_code_format: "6798",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Australia and New Zealand",
    un_locode: "CX",
    un_member: false,
    unofficial_names: [
      "Christmas Island",
      "Weihnachtsinsel",
      "クリスマス島",
      "Christmaseiland",
    ],
    world_region: "APAC",
  },
  CY: {
    alpha2: "CY",
    alpha3: "CYP",
    continent: "Asia",
    country_code: "357",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "CY",
    geo: {
      latitude: 35.126413,
      longitude: 33.429859,
      max_latitude: 35.7071999,
      max_longitude: 34.60450000000001,
      min_latitude: 34.6304001,
      min_longitude: 32.2459,
      bounds: {
        northeast: {
          lat: 35.7071999,
          lng: 34.60450000000001,
        },
        southwest: {
          lat: 34.6304001,
          lng: 32.2459,
        },
      },
    },
    international_prefix: "00",
    ioc: "CYP",
    iso_long_name: "The Republic of Cyprus",
    iso_short_name: "Cyprus",
    languages_official: ["el", "tr", "hy"],
    languages_spoken: ["el", "tr", "hy"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "None",
    nationality: "Cypriot",
    number: "196",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Western Asia",
    un_locode: "CY",
    un_member: true,
    unofficial_names: ["Cyprus", "Zypern", "Chypre", "Chipre", "キプロス"],
    vat_rates: {
      standard: 19,
      reduced: [5, 9],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "CY",
    world_region: "EMEA",
  },
  CZ: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "CZ",
    alpha3: "CZE",
    continent: "Europe",
    country_code: "420",
    currency_code: "CZK",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "EZ",
    geo: {
      latitude: 49.81749199999999,
      longitude: 15.472962,
      max_latitude: 51.0557185,
      max_longitude: 18.8592361,
      min_latitude: 48.5518081,
      min_longitude: 12.090589,
      bounds: {
        northeast: {
          lat: 51.0557185,
          lng: 18.8592361,
        },
        southwest: {
          lat: 48.5518081,
          lng: 12.090589,
        },
      },
    },
    international_prefix: "00",
    ioc: "CZE",
    iso_long_name: "The Czech Republic",
    iso_short_name: "Czechia",
    languages_official: ["cs"],
    languages_spoken: ["cs"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "None",
    nationality: "Czech",
    number: "203",
    postal_code: true,
    postal_code_format: "\\d{3} ?\\d{2}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Eastern Europe",
    un_locode: "CZ",
    un_member: true,
    unofficial_names: [
      "Czech Republic",
      "Tschechische Republik",
      "République Tchèque",
      "República Checa",
      "チェコ",
      "Tsjechië",
      "Czechia",
      "Česká republika",
    ],
    vat_rates: {
      standard: 21,
      reduced: [12],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "CZ",
    world_region: "EMEA",
  },
  AD: {
    alpha2: "AD",
    alpha3: "AND",
    continent: "Europe",
    country_code: "376",
    currency_code: "EUR",
    distance_unit: "KM",
    gec: "AN",
    geo: {
      latitude: 42.506285,
      longitude: 1.521801,
      max_latitude: 42.655791,
      max_longitude: 1.786639,
      min_latitude: 42.4287488,
      min_longitude: 1.4087052,
      bounds: {
        northeast: {
          lat: 42.655791,
          lng: 1.786639,
        },
        southwest: {
          lat: 42.4287488,
          lng: 1.4087052,
        },
      },
    },
    international_prefix: "00",
    ioc: "AND",
    iso_long_name: "The Principality of Andorra",
    iso_short_name: "Andorra",
    languages_official: ["ca"],
    languages_spoken: ["ca"],
    national_destination_code_lengths: [2],
    national_number_lengths: [6, 7, 8, 9],
    national_prefix: "None",
    nationality: "Andorran",
    number: "020",
    postal_code: true,
    postal_code_format: "AD[1-7]0\\d",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "AD",
    un_member: true,
    unofficial_names: ["Andorre", "Andorra", "アンドラ"],
    vehicle_registration_code: "AND",
    world_region: "EMEA",
  },
  AE: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "AE",
    alpha3: "ARE",
    continent: "Asia",
    country_code: "971",
    currency_code: "AED",
    distance_unit: "KM",
    gec: "AE",
    geo: {
      latitude: 23.424076,
      longitude: 53.847818,
      max_latitude: 26.0765,
      max_longitude: 56.4395001,
      min_latitude: 22.6315138,
      min_longitude: 51.4723,
      bounds: {
        northeast: {
          lat: 26.0765,
          lng: 56.4395001,
        },
        southwest: {
          lat: 22.6315138,
          lng: 51.4723,
        },
      },
    },
    international_prefix: "00",
    ioc: "UAE",
    iso_long_name: "The United Arab Emirates",
    iso_short_name: "United Arab Emirates",
    languages_official: ["ar"],
    languages_spoken: ["ar"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8, 9],
    national_prefix: "0",
    nationality: "Emirian",
    number: "784",
    postal_code: false,
    region: "Asia",
    start_of_week: "monday",
    subregion: "Western Asia",
    un_locode: "AE",
    un_member: true,
    unofficial_names: [
      "United Arab Emirates",
      "الإمارات العربية المتحدة",
      "Vereinigte Arabische Emirate",
      "Émirats Arabes Unis",
      "Emiratos Árabes Unidos",
      "アラブ首長国連邦",
      "Verenigde Arabische Emiraten",
    ],
    vat_rates: {
      standard: 5,
      reduced: [],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "UAE",
    world_region: "EMEA",
  },
  AF: {
    alpha2: "AF",
    alpha3: "AFG",
    continent: "Asia",
    country_code: "93",
    currency_code: "AFN",
    distance_unit: "KM",
    gec: "AF",
    geo: {
      latitude: 33.93911,
      longitude: 67.709953,
      max_latitude: 38.49087670000001,
      max_longitude: 74.8898619,
      min_latitude: 29.3772,
      min_longitude: 60.5170005,
      bounds: {
        northeast: {
          lat: 38.49087670000001,
          lng: 74.8898619,
        },
        southwest: {
          lat: 29.3772,
          lng: 60.5170005,
        },
      },
    },
    international_prefix: "00",
    ioc: "AFG",
    iso_long_name: "The Islamic Republic of Afghanistan",
    iso_short_name: "Afghanistan",
    languages_official: ["ps", "uz", "tk"],
    languages_spoken: ["ps", "uz", "tk"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "Afghan",
    number: "004",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Southern Asia",
    un_locode: "AF",
    un_member: true,
    unofficial_names: ["Afghanistan", "Afganistán", "アフガニスタン"],
    vehicle_registration_code: "AFG",
    world_region: "APAC",
  },
  AG: {
    alpha2: "AG",
    alpha3: "ATG",
    continent: "North America",
    country_code: "1",
    currency_code: "XCD",
    distance_unit: "KM",
    gec: "AC",
    geo: {
      latitude: 17.060816,
      longitude: -61.796428,
      max_latitude: 17.7499946,
      max_longitude: -61.6394,
      min_latitude: 16.9018,
      min_longitude: -62.38100009999999,
      bounds: {
        northeast: {
          lat: 17.7499946,
          lng: -61.6394,
        },
        southwest: {
          lat: 16.9018,
          lng: -62.38100009999999,
        },
      },
    },
    international_prefix: "011",
    ioc: "ANT",
    iso_long_name: "Antigua and Barbuda",
    iso_short_name: "Antigua and Barbuda",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1268",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Antiguan, Barbudan",
    number: "028",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "AG",
    un_member: true,
    unofficial_names: [
      "Antigua and Barbuda",
      "Antigua und Barbuda",
      "Antigua et Barbuda",
      "Antigua y Barbuda",
      "アンティグア・バーブーダ",
      "Antigua en Barbuda",
    ],
    vehicle_registration_code: "AG",
    world_region: "AMER",
  },
  AI: {
    alpha2: "AI",
    alpha3: "AIA",
    continent: "North America",
    country_code: "1",
    currency_code: "XCD",
    distance_unit: "KM",
    gec: "AV",
    geo: {
      latitude: 18.220554,
      longitude: -63.06861499999999,
      max_latitude: 18.6332326,
      max_longitude: -62.91999999999999,
      min_latitude: 18.1465043,
      min_longitude: -63.4803,
      bounds: {
        northeast: {
          lat: 18.6332326,
          lng: -62.91999999999999,
        },
        southwest: {
          lat: 18.1465043,
          lng: -63.4803,
        },
      },
    },
    international_prefix: "011",
    ioc: null,
    iso_long_name: "Anguilla",
    iso_short_name: "Anguilla",
    languages_official: ["en"],
    languages_spoken: ["en"],
    nanp_prefix: "1264",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "Anguillian",
    number: "660",
    postal_code: true,
    postal_code_format: "(?:AI-)?2640",
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "AI",
    un_member: false,
    unofficial_names: ["Anguilla", "アンギラ"],
    vehicle_registration_code: "AXA",
    world_region: "AMER",
  },
  AL: {
    alpha2: "AL",
    alpha3: "ALB",
    continent: "Europe",
    country_code: "355",
    currency_code: "ALL",
    distance_unit: "KM",
    gec: "AL",
    geo: {
      latitude: 41.153332,
      longitude: 20.168331,
      max_latitude: 42.6611669,
      max_longitude: 21.0572394,
      min_latitude: 39.6447296,
      min_longitude: 19.1217,
      bounds: {
        northeast: {
          lat: 42.6611669,
          lng: 21.0572394,
        },
        southwest: {
          lat: 39.6447296,
          lng: 19.1217,
        },
      },
    },
    international_prefix: "00",
    ioc: "ALB",
    iso_long_name: "The Republic of Albania",
    iso_short_name: "Albania",
    languages_official: ["sq"],
    languages_spoken: ["sq"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7, 8, 9],
    national_prefix: "0",
    nationality: "Albanian",
    number: "008",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Southern Europe",
    un_locode: "AL",
    un_member: true,
    unofficial_names: [
      "Albania",
      "Albanien",
      "Albanie",
      "アルバニア",
      "Albanië",
    ],
    vehicle_registration_code: "AL",
    world_region: "EMEA",
  },
  AM: {
    alpha2: "AM",
    alpha3: "ARM",
    continent: "Asia",
    country_code: "374",
    currency_code: "AMD",
    distance_unit: "KM",
    gec: "AM",
    geo: {
      latitude: 40.069099,
      longitude: 45.038189,
      max_latitude: 41.300993,
      max_longitude: 46.6342219,
      min_latitude: 38.840244,
      min_longitude: 43.4472601,
      bounds: {
        northeast: {
          lat: 41.300993,
          lng: 46.6342219,
        },
        southwest: {
          lat: 38.840244,
          lng: 43.4472601,
        },
      },
    },
    international_prefix: "00",
    ioc: "ARM",
    iso_long_name: "The Republic of Armenia",
    iso_short_name: "Armenia",
    languages_official: ["hy"],
    languages_spoken: ["hy", "ru"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8],
    national_prefix: "8",
    nationality: "Armenian",
    number: "051",
    postal_code: true,
    postal_code_format: "(?:37)?\\d{4}",
    region: "Asia",
    start_of_week: "monday",
    subregion: "Western Asia",
    un_locode: "AM",
    un_member: true,
    unofficial_names: [
      "Armenia",
      "Armenien",
      "Arménie",
      "アルメニア",
      "Armenië",
    ],
    vehicle_registration_code: "AM",
    world_region: "EMEA",
  },
  AO: {
    alpha2: "AO",
    alpha3: "AGO",
    continent: "Africa",
    country_code: "244",
    currency_code: "AOA",
    distance_unit: "KM",
    gec: "AO",
    geo: {
      latitude: -11.202692,
      longitude: 17.873887,
      max_latitude: -4.388063300000001,
      max_longitude: 24.0878855,
      min_latitude: -18.0391039,
      min_longitude: 11.4696999,
      bounds: {
        northeast: {
          lat: -4.388063300000001,
          lng: 24.0878855,
        },
        southwest: {
          lat: -18.0391039,
          lng: 11.4696999,
        },
      },
    },
    international_prefix: "00",
    ioc: "ANG",
    iso_long_name: "The Republic of Angola",
    iso_short_name: "Angola",
    languages_official: ["pt"],
    languages_spoken: ["pt"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Angolan",
    number: "024",
    postal_code: false,
    region: "Africa",
    start_of_week: "monday",
    subregion: "Middle Africa",
    un_locode: "AO",
    un_member: true,
    unofficial_names: ["Angola", "アンゴラ"],
    vehicle_registration_code: "ANG",
    world_region: "EMEA",
  },
  AQ: {
    alpha2: "AQ",
    alpha3: "ATA",
    continent: "Antarctica",
    country_code: "672",
    currency_code: "USD",
    distance_unit: "KM",
    gec: "AY",
    geo: {
      latitude: -82.862752,
      longitude: 135,
      max_latitude: -60.1086999,
      max_longitude: 180,
      min_latitude: -90,
      min_longitude: -180,
      bounds: {
        northeast: {
          lat: -60.1086999,
          lng: 180,
        },
        southwest: {
          lat: -90,
          lng: -180,
        },
      },
    },
    international_prefix: "",
    ioc: null,
    iso_long_name: "Antarctica",
    iso_short_name: "Antarctica",
    languages_official: [],
    languages_spoken: [],
    national_destination_code_lengths: [],
    national_number_lengths: [],
    national_prefix: "",
    nationality: "",
    number: "010",
    postal_code: false,
    region: "",
    start_of_week: "monday",
    subregion: "",
    un_locode: "AQ",
    un_member: false,
    unofficial_names: [
      "Antarctica",
      "Antarktis",
      "Antarctique",
      "Antártida",
      "南極",
    ],
    world_region: "AMER",
  },
  AR: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{region}}\n{{country}}",
    alpha2: "AR",
    alpha3: "ARG",
    continent: "South America",
    country_code: "54",
    currency_code: "ARS",
    distance_unit: "KM",
    g20_member: true,
    gec: "AR",
    geo: {
      latitude: -38.416097,
      longitude: -63.61667199999999,
      max_latitude: -21.7810459,
      max_longitude: -53.637481,
      min_latitude: -55.1250224,
      min_longitude: -73.5603601,
      bounds: {
        northeast: {
          lat: -21.7810459,
          lng: -53.637481,
        },
        southwest: {
          lat: -55.1250224,
          lng: -73.5603601,
        },
      },
    },
    international_prefix: "00",
    ioc: "ARG",
    iso_long_name: "The Argentine Republic",
    iso_short_name: "Argentina",
    languages_official: ["es", "gn"],
    languages_spoken: ["es", "gn", "qu"],
    national_destination_code_lengths: [2],
    national_number_lengths: [8, 9],
    national_prefix: "0",
    nationality: "Argentinean",
    number: "032",
    postal_code: true,
    postal_code_format: "((?:[A-HJ-NP-Z])?\\d{4})([A-Z]{3})?",
    region: "Americas",
    start_of_week: "monday",
    subregion: "South America",
    un_locode: "AR",
    un_member: true,
    unofficial_names: [
      "Argentina",
      "Argentinien",
      "Argentine",
      "アルゼンチン",
      "Argentinië",
    ],
    vehicle_registration_code: "RA",
    world_region: "AMER",
  },
  AS: {
    alpha2: "AS",
    alpha3: "ASM",
    continent: "Australia",
    country_code: "1",
    currency_code: "USD",
    distance_unit: "MI",
    gec: "AQ",
    geo: {
      latitude: -14.270972,
      longitude: -170.132217,
      max_latitude: -13.4056506,
      max_longitude: -169.2059326,
      min_latitude: -14.7217608,
      min_longitude: -171.0076904,
      bounds: {
        northeast: {
          lat: -13.4056506,
          lng: -169.2059326,
        },
        southwest: {
          lat: -14.7217608,
          lng: -171.0076904,
        },
      },
    },
    international_prefix: "011",
    ioc: "ASA",
    iso_long_name: "The Territory of American Samoa",
    iso_short_name: "American Samoa",
    languages_official: ["en", "sm"],
    languages_spoken: ["en", "sm"],
    nanp_prefix: "1684",
    national_destination_code_lengths: [3],
    national_number_lengths: [10],
    national_prefix: "1",
    nationality: "American Samoan",
    number: "016",
    postal_code: true,
    postal_code_format: "(96799)(?:[ \\-](\\d{4}))?",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Polynesia",
    un_locode: "AS",
    un_member: false,
    unofficial_names: [
      "American Samoa",
      "Amerikanisch-Samoa",
      "Samoa américaines",
      "Samoa Americana",
      "アメリカ領サモア",
      "Amerikaans Samoa",
    ],
    world_region: "APAC",
  },
  AT: {
    address_format:
      "{{recipient}}\n{{street}}\n{{postalcode}} {{city}}\n{{country}}",
    alpha2: "AT",
    alpha3: "AUT",
    continent: "Europe",
    country_code: "43",
    currency_code: "EUR",
    distance_unit: "KM",
    eea_member: true,
    eu_member: true,
    gec: "AU",
    geo: {
      latitude: 47.516231,
      longitude: 14.550072,
      max_latitude: 49.0206081,
      max_longitude: 17.1607329,
      min_latitude: 46.37233579999999,
      min_longitude: 9.530783399999999,
      bounds: {
        northeast: {
          lat: 49.0206081,
          lng: 17.1607329,
        },
        southwest: {
          lat: 46.37233579999999,
          lng: 9.530783399999999,
        },
      },
    },
    international_prefix: "00",
    ioc: "AUT",
    iso_long_name: "The Republic of Austria",
    iso_short_name: "Austria",
    languages_official: ["de"],
    languages_spoken: ["de"],
    national_destination_code_lengths: [1, 2, 3],
    national_number_lengths: [7, 8, 9, 10, 11, 12, 13],
    national_prefix: "0",
    nationality: "Austrian",
    number: "040",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Europe",
    start_of_week: "monday",
    subregion: "Western Europe",
    un_locode: "AT",
    un_member: true,
    unofficial_names: [
      "Austria",
      "Österreich",
      "Autriche",
      "オーストリア",
      "Oostenrijk",
    ],
    vat_rates: {
      standard: 20,
      reduced: [10],
      super_reduced: null,
      parking: 12,
    },
    vehicle_registration_code: "A",
    world_region: "EMEA",
  },
  AU: {
    address_format:
      "{{recipient}}\n{{street}}\n{{city}} {{region_short}} {{postalcode}}\n{{country}}",
    alpha2: "AU",
    alpha3: "AUS",
    continent: "Australia",
    country_code: "61",
    currency_code: "AUD",
    distance_unit: "KM",
    g20_member: true,
    gec: "AS",
    geo: {
      latitude: -25.274398,
      longitude: 133.775136,
      max_latitude: -9.187026399999999,
      max_longitude: 159.2872223,
      min_latitude: -54.83376579999999,
      min_longitude: 110.9510339,
      bounds: {
        northeast: {
          lat: -9.187026399999999,
          lng: 159.2872223,
        },
        southwest: {
          lat: -54.83376579999999,
          lng: 110.9510339,
        },
      },
    },
    international_prefix: "0011",
    ioc: "AUS",
    iso_long_name: "The Commonwealth of Australia",
    iso_short_name: "Australia",
    languages_official: ["en"],
    languages_spoken: ["en"],
    national_destination_code_lengths: [2],
    national_number_lengths: [9],
    national_prefix: "0",
    nationality: "Australian",
    number: "036",
    postal_code: true,
    postal_code_format: "\\d{4}",
    region: "Oceania",
    start_of_week: "monday",
    subregion: "Australia and New Zealand",
    un_locode: "AU",
    un_member: true,
    unofficial_names: [
      "Australia",
      "Australien",
      "Australie",
      "オーストラリア",
      "Australië",
      "澳洲",
    ],
    vat_rates: {
      standard: 10,
      reduced: [],
      super_reduced: null,
      parking: null,
    },
    vehicle_registration_code: "AUS",
    world_region: "APAC",
  },
  AW: {
    alpha2: "AW",
    alpha3: "ABW",
    continent: "North America",
    country_code: "297",
    currency_code: "AWG",
    distance_unit: "KM",
    gec: "AA",
    geo: {
      latitude: 12.52111,
      longitude: -69.968338,
      max_latitude: 12.6306179,
      max_longitude: -69.8644638,
      min_latitude: 12.406093,
      min_longitude: -70.070114,
      bounds: {
        northeast: {
          lat: 12.6306179,
          lng: -69.8644638,
        },
        southwest: {
          lat: 12.406093,
          lng: -70.070114,
        },
      },
    },
    international_prefix: "00",
    ioc: "ARU",
    iso_long_name: "Aruba",
    iso_short_name: "Aruba",
    languages_official: ["nl"],
    languages_spoken: ["nl"],
    national_destination_code_lengths: [2],
    national_number_lengths: [7],
    national_prefix: "None",
    nationality: "Aruban",
    number: "533",
    postal_code: false,
    region: "Americas",
    start_of_week: "monday",
    subregion: "Caribbean",
    un_locode: "AW",
    un_member: false,
    unofficial_names: ["Aruba", "アルバ"],
    vehicle_registration_code: "ARU",
    world_region: "AMER",
  },
};

function getCountry(code) {
  return COUNTRIES[code];
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-translations]").forEach(function (elem) {
    const translations = JSON.parse(elem.dataset.translations);
    const country = getCountry(Shopify.country);
    if (country.region == 'Europe' && Shopify.country != 'GB') {
      elem.innerText = translations['EU']
    } else if (Shopify.country == "GB") {
      elem.innerText = translations["UK"];
    } else {
      elem.innerText = translations["US"];
    }
  });
});
